var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AddOrderNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick);
  }
  handleClick(e) {
    e.preventDefault();
    document.querySelector(e.currentTarget.getAttribute("target-input")).style.display = null;
    this.remove();
  }
}
customElements.define("add-order-note", AddOrderNote);
const EaseInOut = "cubic-bezier(.7, 0, .3, 1)";
const EaseIn = "cubic-bezier(.7, 0, 1, 1)";
const EaseOut = "cubic-bezier(0, 0, .3, 1)";
function debounce(fn, wait) {
  let t;
  const debounced = (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
  debounced.cancel = () => {
    clearTimeout(t);
  };
  return debounced;
}
function throttle(fn, delay3) {
  let wait = false;
  return (...args) => {
    if (wait) {
      return;
    }
    fn(...args);
    wait = true;
    setTimeout(() => {
      wait = false;
    }, delay3);
  };
}
function tap(obj, fn) {
  fn(obj);
  return obj;
}
function mod(n, m) {
  return (n % m + m) % m;
}
function scrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop;
}
function fetchConfig(type = "json") {
  switch (type) {
    case "form-data":
      return {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      };
    case "json":
      return {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      };
  }
}
function pauseAllMedia() {
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI)
      model.modelViewerUI.pause();
  });
}
function setScrollbarWidth() {
  window.setScrollbarWidth();
}
function cancelAnims(...el) {
  el.filter((x) => x).forEach(
    (el2) => el2.getAnimations().forEach((anim) => anim.cancel())
  );
}
function delay$1(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
window._delay = delay$1;
function createElementFromHtml(html) {
  const template = document.createElement("template");
  template.innerHTML = html;
  return template.content.firstElementChild;
}
function scrollIntoViewIfNeeded(element, padding = 16) {
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const rect = element.getBoundingClientRect();
  const fullyInView = rect.top >= 0 && rect.bottom <= viewportHeight;
  if (!fullyInView) {
    if (rect.top < 0) {
      window.scrollBy({
        top: rect.top - padding,
        behavior: "smooth"
      });
    } else if (rect.height > viewportHeight) {
      if (rect.top >= 0 && rect.top <= viewportHeight * 0.85) {
        return;
      } else {
        window.scrollBy({
          top: rect.top - padding,
          behavior: "smooth"
        });
      }
    } else if (rect.bottom > viewportHeight) {
      const scrollAmount = rect.bottom - viewportHeight;
      window.scrollBy({
        top: scrollAmount + padding,
        behavior: "smooth"
      });
    }
  }
}
async function imageLoaded(image) {
  if (Array.isArray(image)) {
    await Promise.all(image.map((x) => imageLoaded(x)));
    return;
  }
  if (image.complete) {
    return;
  } else {
    return new Promise((resolve) => {
      const onFinish = () => {
        image.removeEventListener("load", onFinish);
        image.removeEventListener("error", onFinish);
        resolve();
      };
      image.addEventListener("load", onFinish);
      image.addEventListener("error", onFinish);
    });
  }
}
function preserveFocus(closure) {
  var _a;
  const focusedElementId = (_a = document.activeElement) == null ? void 0 : _a.id;
  closure();
  setTimeout(() => {
    var _a2;
    (_a2 = document.getElementById(focusedElementId)) == null ? void 0 : _a2.focus();
  });
}
function whenInView(element, callback, options) {
  element = wrap(element);
  if (element.length === 0) {
    return () => {
    };
  }
  const observer = new IntersectionObserver(([entry], observer2) => {
    if (entry && entry.isIntersecting) {
      callback();
      observer2.disconnect();
    }
  }, options);
  element.forEach((item) => observer.observe(item));
  return () => {
    observer.disconnect();
  };
}
function wrap(item) {
  return Array.isArray(item) ? item : [item];
}
let loaded = false;
window.addEventListener("load", () => {
  loaded = true;
});
function windowLoaded() {
  if (loaded) {
    return Promise.resolve();
  } else {
    return new Promise((resolve) => {
      window.addEventListener("load", resolve);
    });
  }
}
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplay = true;
    this.autoplayRunning = false;
  }
  get transition() {
    return this.getAttribute("transition") ?? "fade";
  }
  get speed() {
    return Number(this.getAttribute("speed") ?? 4e3);
  }
  connectedCallback() {
    this.autoplay = this.getAttribute("autoplay") === "true";
    this.slides = this.querySelectorAll(".announcement");
    this.slides[0].classList.add("is-active");
    this.slides[0].animate({ opacity: [0, 1] }, { duration: 250 });
    if (this.slides.length <= 1) {
      return;
    }
    this.buttonPrev = this.querySelector("[data-button-prev]");
    this.buttonNext = this.querySelector("[data-button-next]");
    this.buttonPrev.addEventListener("click", this.onPrevClick.bind(this));
    this.buttonNext.addEventListener("click", this.onNextClick.bind(this));
    if (this.autoplay) {
      this.startAutoplay();
    }
  }
  disconnectedCallback() {
    this.stopAutoplay();
    this.slides.forEach((el) => {
      el.classList.remove("is-active");
      el.getAnimations().forEach((el2) => el2.cancel());
    });
  }
  async startAutoplay() {
    if (this.autoplayRunning)
      return;
    this.autoplayRunning = true;
    while (this.autoplay) {
      await delay$1(this.speed);
      if (!this.autoplay)
        break;
      this.next();
    }
    this.autoplayRunning = false;
  }
  stopAutoplay() {
    this.autoplay = false;
  }
  onPrevClick() {
    this.stopAutoplay();
    this.prev();
  }
  onNextClick() {
    this.stopAutoplay();
    this.next();
  }
  async prev() {
    const prev = this.getCurSlide();
    this.decIndex();
    await this.animateTransition(prev, this.getCurSlide());
  }
  async next() {
    const prev = this.getCurSlide();
    this.incIndex();
    await this.animateTransition(prev, this.getCurSlide());
  }
  async animateTransition(prev, cur) {
    var _a, _b;
    try {
      (_a = this.currentNextAnim) == null ? void 0 : _a.cancel();
      (_b = this.currentPrevAnim) == null ? void 0 : _b.cancel();
      this.slides.forEach((slide) => slide.classList.remove("is-active"));
      prev.classList.add("is-active");
      if (prev) {
        this.currentPrevAnim = this.animateOutSlide(prev);
        if (this.transition !== "fade") {
          await this.currentPrevAnim.finished;
        }
        prev.classList.remove("is-active");
      }
      this.currentNextAnim = this.animateInSlide(cur);
      await this.currentNextAnim.finished;
      cur.classList.add("is-active");
    } catch (err) {
    }
  }
  getCurSlide() {
    return this.slides[this.currentIndex];
  }
  incIndex() {
    this.currentIndex = mod(this.currentIndex + 1, this.slides.length);
  }
  decIndex() {
    this.currentIndex = mod(this.currentIndex - 1, this.slides.length);
  }
  animateOutSlide(slide) {
    switch (this.transition) {
      case "fade":
        return slide.animate({ opacity: [1, 0] }, { duration: 150 });
      case "slide-y":
        return slide.animate(
          { opacity: [1, 0], transform: ["none", "translateY(-.5rem)"] },
          { duration: 200, easing: EaseIn }
        );
    }
  }
  animateInSlide(slide) {
    switch (this.transition) {
      case "fade":
        return slide.animate({ opacity: [0, 1] }, { duration: 150 });
      case "slide-y":
        return slide.animate(
          { opacity: [0, 1], transform: ["translateY(.5rem)", "none"] },
          { duration: 200, easing: EaseOut }
        );
    }
  }
}
customElements.define("announcement-bar", AnnouncementBar);
class Carousel extends HTMLElement {
  constructor() {
    super();
    this.scrollTarget = 0;
    this.currentIndex = 0;
    this.scrollBehavior = "smooth";
    this.userScroll = false;
  }
  connectedCallback() {
    var _a, _b, _c;
    this.addEventListener(
      "touchstart",
      () => {
        clearTimeout(this.touchendTimeout);
        this.touching = true;
      },
      { passive: true }
    );
    this.addEventListener("touchend", () => {
      this.touchendTimeout = setTimeout(() => {
        this.touching = false;
      }, 100);
    });
    this.sectionId = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    this.vertical = this.getAttribute("vertical") !== null;
    this.btnPrev = this.getAttribute("button-prev") ? document.querySelector(this.getAttribute("button-prev")) : this.parentNode.querySelector(":scope > [data-carousel-prev]");
    this.btnNext = this.getAttribute("button-next") ? document.querySelector(this.getAttribute("button-next")) : this.parentNode.querySelector(":scope > [data-carousel-next]");
    // CB Select button if out of this
    if(!this.btnPrev) this.btnPrev = this.closest('.section').querySelector('[data-carousel-prev]');
    if(!this.btnNext) this.btnNext = this.closest('.section').querySelector('[data-carousel-next]');
    // CB end Select button if out of this
    this.scrollShadowStart = this.querySelector(".scroll-shadow-start");
    this.scrollShadowEnd = this.querySelector(".scroll-shadow-end");
    this.items = Array.from(this.querySelectorAll(this.itemSelector));
    (_b = this.btnPrev) == null ? void 0 : _b.addEventListener("click", () => this.goPrev());
    (_c = this.btnNext) == null ? void 0 : _c.addEventListener("click", () => this.goNext());
    this.onResizeDebounced = debounce(this.onResize.bind(this), 100);
    this.addEventListener("scroll", this.onScroll.bind(this));
    this.addEventListener("scroll", debounce(this.onScrollEnd.bind(this), 150));
    this.resizeObserver = new ResizeObserver(this.onResizeDebounced);
    this.resizeObserver.observe(this);
    this.updateButtons();
    this.updateShadow();
  }
  get itemSelector() {
    return this.getAttribute("item-selector") ?? ":scope > *";
  }
  get loop() {
    return this.getAttribute("loop") !== null;
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
  scrollAmount() {
    return this.vertical ? this.scrollTop : this.scrollLeft;
  }
  onScroll() {
    if (this.touching) {
      this.userScroll = true;
    }
    this.updateShadow();
  }
  onScrollEnd() {
    this.scrollTarget = this.scrollAmount();
    this.updateButtons();
    this.userScroll = false;
  }
  onResize() {
    this.scrollTarget = this.scrollAmount();
    this.updateButtons();
    this.updateShadow();
  }
  triggerScroll(x) {
    this.scrollTo({
      [this.vertical ? "top" : "left"]: x,
      behavior: this.scrollBehavior
    });
    this.scrollTarget = x;
    this.updateButtons();
  }
  goPrev() {
  }
  goNext() {
  }
  updateButtons() {
    if (!this.btnPrev || !this.btnNext)
      return;
    if (this.loop && this.items.length > 1) {
      this.btnPrev.classList.remove("is-hidden");
      this.btnNext.classList.remove("is-hidden");
      return;
    }
    let nextHidden, prevHidden;
    if (this.vertical) {
      nextHidden = this.scrollHeight - this.clientHeight - Math.abs(this.scrollTarget) < 3;
    } else {
      nextHidden = this.scrollWidth - this.clientWidth - Math.abs(this.scrollTarget) < 3;
    }
    prevHidden = Math.abs(this.scrollTarget) < 3;
    if (nextHidden) {
      this.btnNext.classList.add("is-hidden");
    } else {
      this.btnNext.classList.remove("is-hidden");
    }
    if (prevHidden) {
      this.btnPrev.classList.add("is-hidden");
    } else {
      this.btnPrev.classList.remove("is-hidden");
    }
  }
  isOverflowing() {
    if (this.vertical) {
      return this.scrollHeight > this.clientHeight;
    } else {
      return this.scrollWidth > this.clientWidth;
    }
  }
  updateShadow() {
    if (!this.scrollShadowStart || !this.scrollShadowEnd)
      return;
    if (!this.isOverflowing()) {
      this.scrollShadowStart.classList.add("hidden");
      this.scrollShadowEnd.classList.add("hidden");
    } else {
      this.scrollShadowStart.classList.remove("hidden");
      this.scrollShadowEnd.classList.remove("hidden");
    }
    this.style.setProperty("--scroll-progress", this.getScrollProgressRatio());
  }
  getScrollProgressRatio() {
    if (this.vertical) {
      return this.scrollTop / (this.scrollHeight - this.clientHeight);
    } else {
      return Math.abs(this.scrollLeft) / (this.scrollWidth - this.clientWidth);
    }
  }
}
function setLoadingOverlay(state) {
  const overlay = document.querySelector("[data-main-loading-overlay]");
  if (state) {
    overlay.style.display = null;
  } else {
    overlay.style.display = "none";
  }
}
async function waitForImagesToLoad(images) {
  const imageArray = Array.isArray(images) ? images : Array.from(images);
  const isImageLoaded = (image) => {
    return image.complete && image.naturalWidth !== 0 && image.naturalHeight !== 0;
  };
  const createImagePromise = (image) => {
    return new Promise((resolve, reject) => {
      const onLoad = () => {
        image.removeEventListener("load", onLoad);
        image.removeEventListener("error", onError);
        resolve(image);
      };
      const onError = (error) => {
        image.removeEventListener("load", onLoad);
        image.removeEventListener("error", onError);
        reject(error);
      };
      if (isImageLoaded(image)) {
        resolve(image);
      } else {
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
      }
    });
  };
  const imagePromises = imageArray.map((image) => createImagePromise(image));
  try {
    await Promise.all(imagePromises);
  } catch (error) {
    console.error("One or more images failed to load:", error);
    throw error;
  }
}
function preloadImage(image) {
  return new Promise((resolve) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = image.src;
    link.imageSrcset = image.srcset;
    link.imageSizes = image.sizes;
    document.head.appendChild(link);
    link.onload = () => {
      document.head.removeChild(link);
      resolve();
    };
    link.onerror = () => {
      document.head.removeChild(link);
      resolve();
    };
  });
}
async function showNotification(params) {
  await document.querySelector("notification-wrapper").showNotification(params);
}
function getSectionId(section) {
  return section.id.replace(/^shopify-section-/, "");
}
function getSection(html, selector = ".shopify-section") {
  return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
}
async function reloadSection(section, { url, signal } = {}) {
  const html = await fetchSection(getSectionId(section), url, signal);
  updateSectionHTML(section, html);
}
async function fetchSection(section, url = null, signal = null) {
  if (!url) {
    url = window.location.origin + window.location.pathname;
  }
  url = new URL(url);
  url.searchParams.append("section_id", section);
  const resp = await fetch(url.toString(), { signal });
  if (!resp.ok) {
    throw new Error(`Failed to fetch section #${section}`);
  }
  const html = await resp.text();
  return html;
}
function updateSectionHTML(section, html) {
  preserveSectionState(section, () => {
    section.innerHTML = getSection(html, "#" + section.id).innerHTML;
  });
}
function preserveSectionState(section, closure) {
  const state = saveComponentsState(section);
  const scroll = saveElementsScroll(section);
  closure();
  Object.entries(state).forEach(([id, state2]) => {
    var _a;
    (_a = document.getElementById(id)) == null ? void 0 : _a.loadComponentState(state2);
  });
  Object.entries(scroll).forEach(([id, options]) => {
    var _a;
    (_a = document.getElementById(id)) == null ? void 0 : _a.scrollTo(options);
  });
}
function saveComponentsState(section) {
  return Object.fromEntries(
    [...section.querySelectorAll("[data-preserve-state]")].map((el) => [
      el.id,
      el.saveComponentState()
    ])
  );
}
function saveElementsScroll(section) {
  return Object.fromEntries(
    [...section.querySelectorAll("[data-preserve-scroll]")].map((el) => [
      el.id,
      { top: el.scrollTop, left: el.scrollLeft }
    ])
  );
}
async function addToCart({ id, quantity }) {
  const resp = await fetch(window.routes.cart_add_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      id,
      quantity,
      sections: ["cart-bubble", "variant-added"],
      sections_url: `${window.Shopify.routes.root}variants/${id}`
    })
  });
  if (!resp.ok) {
    const json = await resp.json();
    showNotification({
      type: "danger",
      text: (json == null ? void 0 : json.description) || (json == null ? void 0 : json.message) || window.cartStrings.error
    });
    return false;
  }
  const body = await resp.json();
  updateCartBadge(body.sections["cart-bubble"].match(/\d+/));
  const mainCart = document.querySelector(".section-main-cart");
  if (mainCart) {
    reloadSection(mainCart);
  }
  document.dispatchEvent(
    new CustomEvent("product:added-to-cart", { detail: { id, quantity } })
  );
  return body;
}
function updateCartBadge(amount) {
  const el = document.getElementById("CartBubble");
  if (!amount) {
    el.classList.add("hidden");
    el.innerHTML = "";
  } else {
    el.classList.remove("hidden");
    el.innerHTML = amount;
  }
}
async function showAddedToCartNotification(cartResponse) {
  if (window.addedToCartNotification === "drawer") {
    await showCartModal();
  } else {
    await showVariantAddedToCartModal(cartResponse);
  }
}
async function showCartModal(params = {}) {
  var _a, _b;
  await ((_a = document.querySelector("cart-modal")) == null ? void 0 : _a.reloadContent());
  (_b = document.querySelector("cart-modal")) == null ? void 0 : _b.show(params);
}
function showQuickAddModal(infoEl) {
  const modal = document.getElementById("quick-add-modal");
  modal.setProductInfo(infoEl);
  modal.show();
}
async function showVariantAddedToCartModal({ html, key }) {
  const modal = document.getElementById("variant-added-modal");
  const content = modal.querySelector("[slot=content]");
  const el = createElementFromHtml(html);
  if (key) {
    el.querySelectorAll(
      `[data-cart-key]:not([data-cart-key="${key}"])`
    ).forEach((el2) => el2.remove());
  }
  await Promise.all(
    [...el.querySelectorAll("img")].map((img) => preloadImage(img))
  );
  content.replaceChildren(el);
  modal.show();
}
class CartForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }
  connectedCallback() {
    this.querySelectorAll("[data-button-remove]").forEach(
      (el) => el.addEventListener("click", this.onRemoveButtonClick.bind(this))
    );
    this.cartModal = this.closest("cart-modal");
    this.parentSection = this.closest(".shopify-section");
  }
  onRemoveButtonClick(e) {
    e.preventDefault();
    return this.updateQuantity(e.currentTarget.dataset.index, 0);
  }
  onChange(event) {
    if (event.target.id === "Cart-Note") {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    } else if (event.target.closest("qty-selector")) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  async updateQuantity(line, quantity) {
    this.setLoading(true);
    const curSection = this.closest(".shopify-section");
    const curSectionId = getSectionId(curSection);
    const body = JSON.stringify({
      line,
      quantity,
      sections: [curSectionId, "cart-bubble"],
      sections_url: window.location.pathname
    });
    try {
      const response = await fetch(`${window.routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body }
      });
      const state = await response.json();
      if (!response.ok) {
        if (state.description || state.message) {
          await this.reloadParentSection();
          this.displayError(state.description || state.message, line);
        } else {
          throw new Error("Unknown error response from cart api");
        }
      } else {
        if (this.cartModal) {
          this.cartModal.updateFromSectionHtml(state.sections[curSectionId]);
        } else {
          updateSectionHTML(curSection, state.sections[curSectionId]);
        }
        updateCartBadge(state.sections["cart-bubble"].match(/\d+/));
      }
    } catch (err) {
      console.error(err);
      await this.reloadParentSection();
      this.displayError(window.cartStrings.error, line);
    } finally {
      this.setLoading(false);
    }
  }
  async reloadParentSection() {
    if (!this.cartModal) {
      await reloadSection(this.closest(".shopify-section"));
    } else {
      await this.cartModal.reloadContent();
    }
  }
  setLoading(state) {
    if (this.cartModal) {
      state ? this.cartModal.showLoadingOverlay() : this.cartModal.hideLoadingOverlay();
    } else {
      setLoadingOverlay(state);
    }
  }
  displayError(error, line = null) {
    let target = this.parentSection.querySelector("#Cart-Errors");
    if (line !== null) {
      target = this.parentSection.querySelector(`[data-cart-item-index="${line}"] .message-danger`);
    }
    target.textContent = error;
  }
}
customElements.define("cart-form", CartForm);
function getAnimationByName(name) {
  if (!repo[name]) {
    throw new Error(`Unknown animation: ${name}`);
  }
  return repo[name];
}
function animate(element, animationName, params = {}) {
  return getAnimationByName(animationName)(element, params);
}
const repo = {
  "fade-in": function fadeIn(element, params = {}) {
    const keyframes = {
      opacity: [0, 1],
      transform: [`translate(${params.x ?? 0}, ${params.y ?? "1rem"})`, "none"]
    };
    const options = { duration: 375, easing: EaseOut, ...params };
    return element.animate(keyframes, options);
  },
  "fade-out": function fadeOut(element, params = {}) {
    const keyframes = {
      opacity: [1, 0],
      transform: ["none", `translate(${params.x ?? 0}, ${params.y ?? "1rem"})`]
    };
    const options = { duration: 375, easing: EaseIn, ...params };
    return element.animate(keyframes, options);
  },
  "scroll-slide-in": function scrollSlideIn(element, params = {}) {
    const keyframes = {
      opacity: [0, 1],
      transform: [`translate(${params.x ?? 0}, ${params.y ?? "2rem"})`, "none"]
    };
    const options = { duration: 600, easing: EaseOut, ...params };
    return element.animate(keyframes, options);
  },
  "clip-inset": function clipInset(element, params = {}) {
    const round2 = params.round ?? "0";
    const dir = params.clipDirection ?? "bottom";
    let startPath = null;
    switch (dir) {
      case "top":
        startPath = `inset(100% 0 0 0 round ${round2})`;
        break;
      case "right":
        startPath = `inset(0 100% 0 0 round ${round2})`;
        break;
      case "bottom":
        startPath = `inset(0 0 100% 0 round ${round2})`;
        break;
      case "left":
        startPath = `inset(0 0 0 100% round ${round2})`;
        break;
    }
    const endPath = `inset(0 0 0 0 round ${round2})`;
    const keyframes = { clipPath: [startPath, endPath] };
    const options = { duration: 250, easing: EaseInOut, ...params };
    return element.animate(keyframes, options);
  },
  "scale-in": function scaleIn(element, params = {}) {
    const scale = params.scale || 0.9;
    const keyframes = {
      transform: [`scale(${scale})`, "none"],
      opacity: [0, 1]
    };
    const options = { duration: 375, easing: EaseOut, ...params };
    return element.animate(keyframes, options);
  },
  "scale-out": function scaleOut(element, params = {}) {
    const scale = params.scale || 0.95;
    const keyframes = {
      transform: ["none", `scale(${scale})`],
      opacity: [1, 0]
    };
    const options = { duration: 375, easing: "linear", ...params };
    return element.animate(keyframes, options);
  }
};
function lockScroll() {
  document.body.classList.add("no-scroll");
}
function unlockScroll() {
  document.body.classList.remove("no-scroll");
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node && isInert2(node.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node) {
  var _node$getAttribute2;
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
  return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
  if (!node) {
    throw new Error("No node provided");
  }
  if (node.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
  var _nodeRoot;
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (isNodeAttached(node)) {
      return !node.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
var isKeyForward = function isKeyForward2(e) {
  return isTabEvent(e) && !e.shiftKey;
};
var isKeyBackward = function isKeyBackward2(e) {
  return isTabEvent(e) && e.shiftKey;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward,
    isKeyBackward
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : void 0;
    return state.containerGroups.findIndex(function(_ref) {
      var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
        return node === element;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0 || !isFocusable(node, config.tabbableOptions)) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : void 0;
      var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : void 0;
      var firstDomTabbableNode = focusableNodes.find(function(node) {
        return isTabbable(node);
      });
      var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
        return isTabbable(node);
      });
      var posTabIndexesFound = !!tabbableNodes.find(function(node) {
        return getTabIndex(node) > 0;
      });
      return {
        container,
        tabbableNodes,
        focusableNodes,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = tabbableNodes.indexOf(node);
          if (nodeIdx < 0) {
            if (forward) {
              return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                return isTabbable(el);
              });
            }
            return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
              return isTabbable(el);
            });
          }
          return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
    if (state.containerGroups.find(function(g) {
      return g.posTabIndexesFound;
    }) && state.containerGroups.length > 1) {
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
  };
  var getActiveElement = function getActiveElement2(el) {
    var activeElement = el.activeElement;
    if (!activeElement) {
      return;
    }
    if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
      return getActiveElement2(activeElement.shadowRoot);
    }
    return activeElement;
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === getActiveElement(document)) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var findNextNavNode = function findNextNavNode2(_ref2) {
    var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
    target = target || getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (isBackward) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var firstTabbableNode = _ref3.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref4) {
          var lastTabbableNode = _ref4.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    return destinationNode;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked (and if not focusable, to "nothing"); by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node), whether the
        //  outside click was on a focusable node or not
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(event) {
    var target = getActualTarget(event);
    var targetContained = findContainerIndex(target, event) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      event.stopImmediatePropagation();
      var nextNode;
      var navAcrossContainers = true;
      if (state.mostRecentlyFocusedNode) {
        if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
          var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
          var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
          if (tabbableNodes.length > 0) {
            var mruTabIdx = tabbableNodes.findIndex(function(node) {
              return node === state.mostRecentlyFocusedNode;
            });
            if (mruTabIdx >= 0) {
              if (config.isKeyForward(state.recentNavEvent)) {
                if (mruTabIdx + 1 < tabbableNodes.length) {
                  nextNode = tabbableNodes[mruTabIdx + 1];
                  navAcrossContainers = false;
                }
              } else {
                if (mruTabIdx - 1 >= 0) {
                  nextNode = tabbableNodes[mruTabIdx - 1];
                  navAcrossContainers = false;
                }
              }
            }
          }
        } else {
          if (!state.containerGroups.some(function(g) {
            return g.tabbableNodes.some(function(n) {
              return getTabIndex(n) > 0;
            });
          })) {
            navAcrossContainers = false;
          }
        }
      } else {
        navAcrossContainers = false;
      }
      if (navAcrossContainers) {
        nextNode = findNextNavNode({
          // move FROM the MRU node, not event-related node (which will be the node that is
          //  outside the trap causing the focus escape we're trying to fix)
          target: state.mostRecentlyFocusedNode,
          isBackward: config.isKeyBackward(state.recentNavEvent)
        });
      }
      if (nextNode) {
        tryFocus(nextNode);
      } else {
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }
    state.recentNavEvent = void 0;
  };
  var checkKeyNav = function checkKeyNav2(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    state.recentNavEvent = event;
    var destinationNode = findNextNavNode({
      event,
      isBackward
    });
    if (destinationNode) {
      if (isTabEvent(event)) {
        event.preventDefault();
      }
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
      return;
    }
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trapStack, trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  var checkDomRemoval = function checkDomRemoval2(mutations) {
    var isFocusedNodeRemoved = mutations.some(function(mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function(node) {
        return node === state.mostRecentlyFocusedNode;
      });
    });
    if (isFocusedNodeRemoved) {
      tryFocus(getInitialFocusNode());
    }
  };
  var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : void 0;
  var updateObservedNodes = function updateObservedNodes2() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function(container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      onActivate === null || onActivate === void 0 || onActivate();
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 || onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      onDeactivate === null || onDeactivate === void 0 || onDeactivate();
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (state.paused || !state.active) {
        return this;
      }
      var onPause = getOption(pauseOptions, "onPause");
      var onPostPause = getOption(pauseOptions, "onPostPause");
      state.paused = true;
      onPause === null || onPause === void 0 || onPause();
      removeListeners();
      updateObservedNodes();
      onPostPause === null || onPostPause === void 0 || onPostPause();
      return this;
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.paused || !state.active) {
        return this;
      }
      var onUnpause = getOption(unpauseOptions, "onUnpause");
      var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
      state.paused = false;
      onUnpause === null || onUnpause === void 0 || onUnpause();
      updateTabbableNodes();
      addListeners();
      updateObservedNodes();
      onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
window.activeModals = [];
class Modal extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    shadow.appendChild(document.querySelector("#template-modal").content.cloneNode(true));
    this.open = false;
    this.overlay = shadow.querySelector(".overlay");
    this.panelWrapper = shadow.querySelector(".panel-wrapper");
    this.panel = shadow.querySelector(".panel");
    this.panelInner = shadow.querySelector(".panel-inner");
    this.loadingOverlay = shadow.querySelector(".loading-overlay");
    this.spinner = shadow.querySelector(".spinner");
    this.activator = shadow.querySelector("slot[name=activator]");
    this.useFocusTrap = true;
    this.useLockScroll = true;
    this.useOverlay = true;
  }
  get appendToBody() {
    return this.getAttribute("append-to-body") !== null;
  }
  connectedCallback() {
    if (this.hasAttribute("disable-focus-trap")) {
      this.useFocusTrap = false;
      this.focusTrap = null;
    }
    this.content = this.shadowRoot.querySelector("slot[name=content]").assignedElements()[0] ?? null;
    this.activatorElement = this.activator.assignedElements()[0] ?? null;
    if (!this.activatorElement && this.id) {
      this.activatorElement = document.querySelector(`modal-trigger[target="#${this.id}"] > *`);
    }
    this.activator.addEventListener("click", (e) => this.onActivatorClick(e));
    this.overlay.addEventListener("click", () => this.hide());
    this.addEventListener("keydown", this.onEscapeKeyDown.bind(this));
    this.registerCloseButton();
    if (this.getAttribute("show-on") && this.content.querySelector(this.getAttribute("show-on"))) {
      this.show();
    }
    if (this.getAttribute("hide-scrollbar") !== null) {
      this.panel.classList.add("hide-scrollbar");
    }
    if (window.Shopify.designMode && this.appendToBody) {
      this.closest(".shopify-section").addEventListener("shopify:section:unload", () => {
        this.remove();
      });
    }
  }
  disconnectedCallback() {
    if (this.designModeInit) {
      this.disableDesignMode();
    }
  }
  onEscapeKeyDown(e) {
    if (this.open && e.key === "Escape") {
      e.stopPropagation();
      this.hide();
    }
  }
  saveComponentState() {
    return { open: this.open };
  }
  loadComponentState(data) {
    if (data == null ? void 0 : data.open) {
      this.show({ anim: false });
    }
  }
  setActivatorElement(el) {
    this.activatorElement = el;
  }
  registerCloseButton() {
    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-button-close]")) {
        // CB remove active button and active class from mobile menu
        if (e.target.closest('.mobile-menu')) {
          e.target.closest('.mobile-menu').classList.contains('active') ? e.target.closest('.mobile-menu').classList.remove('active') : null;
          e.target.closest('.mobile-menu').querySelector('.cb-active-menu-btn')?.classList.remove('cb-active-menu-btn');
        }
        // CB end remove active button and active class from mobile menu
        e.stopPropagation();
        this.hide();
      }
    });
    this.addEventListener("keydown", (e) => {
      if (e.target.getAttribute("data-button-close") !== null && e.key === "Enter") {
        e.stopPropagation();
        this.hide();
      }
    });
  }
  onActivatorClick(e) {
    e.preventDefault();
    this.show();
  }
  async beforeShow() {
    var _a;
    const parentModal = window.activeModals[window.activeModals.length - 1];
    if (parentModal) {
      this.inModalMode = true;
      this.setZIndex(parentModal.getZIndexMax() + 100);
      this.parentModal = parentModal;
    } else {
      this.inModalMode = false;
    }
    if (!this.focusTrap && this.useFocusTrap && !window.Shopify.designMode) {
      this.focusTrap = createFocusTrap(this.content, {
        allowOutsideClick: true,
        escapeDeactivates: false,
        preventScroll: true,
        initialFocus: this.getInitialFocus()
      });
    }
    window.activeModals.push(this);
    if (this.appendToBody) {
      this.storeOriginalPosition();
      document.body.appendChild(this);
    }
    this.open = true;
    (_a = this.activatorElement) == null ? void 0 : _a.classList.add("active");
    this.dispatchEvent(new CustomEvent("show"));
    this.lockScroll();
  }
  getInitialFocus() {
    const selector = this.getAttribute("initial-focus");
    if (selector) {
      return this.content.querySelector(selector);
    } else {
      return this.content;
    }
  }
  async show(anim = true) {
    if (this.open)
      return;
    await this.beforeShow();
    await this.showElements(anim);
    await this.afterShow();
  }
  async showElements({ anim = true } = {}) {
    this.fadeInOverlay(anim);
    this.panelWrapper.style.display = "flex";
    if (anim) {
      await this.animatePanelIn();
    }
  }
  async animatePanelIn() {
    await animate(this.panel, "fade-in", { duration: 250, y: "3rem" }).finished;
  }
  async afterShow() {
    if (this.useFocusTrap && this.focusTrap) {
      this.focusTrap.activate();
    } else {
      if (this.content.getAttribute("tabindex")) {
        this.content.focus();
      }
    }
  }
  async beforeHide() {
    var _a;
    window.activeModals = window.activeModals.filter((x) => x !== this);
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
    this.open = false;
    (_a = this.activatorElement) == null ? void 0 : _a.classList.remove("active");
    this.dispatchEvent(new CustomEvent("hide"));
  }
  async hide() {
    if (!this.open)
      return;
    await this.beforeHide();
    await this.hideElements();
    await this.afterHide();
  }
  async hideElements(anim = true) {
    if (anim) {
      await this.animatePanelOut();
    }
    this.panelWrapper.style.display = null;
    await this.fadeOutOverlay();
  }
  async animatePanelOut() {
    await animate(this.panel, "fade-out", { easing: "linear", duration: 150 }).finished;
  }
  async afterHide() {
    var _a;
    this.content.querySelectorAll(".modal").forEach((modal) => modal.hide && modal.hide());
    this.unlockScroll();
    if (this.appendToBody && ((_a = this.originalPosition) == null ? void 0 : _a.parent)) {
      this.restoreOriginalPosition();
    }
    this.dispatchEvent(new CustomEvent("hide-end"));
  }
  storeOriginalPosition() {
    this.originalPosition = {
      parent: this.parentElement,
      nextSibling: this.nextSibling
    };
  }
  restoreOriginalPosition() {
    this.originalPosition.parent.insertBefore(this, this.originalPosition.nextSibling);
  }
  async fadeInOverlay(anim = true) {
    if (!this.useOverlay)
      return;
    this.overlay.style.display = "block";
    if (anim) {
      await this.overlay.animate({ opacity: [0, 1] }, { duration: 200 }).finished;
    }
  }
  async fadeOutOverlay() {
    if (!this.useOverlay)
      return;
    await this.overlay.animate({ opacity: [1, 0] }, { duration: 200 }).finished;
    this.overlay.style.display = "none";
  }
  lockScroll() {
    if (!this.useLockScroll)
      return;
    lockScroll();
  }
  unlockScroll() {
    if (!this.useLockScroll)
      return;
    if (!this.inModalMode || this.parentModal && !this.parentModal.useLockScroll) {
      unlockScroll();
      setTimeout(setScrollbarWidth, 250);
    }
  }
  showLoadingOverlay() {
    this.loadingOverlay.style.display = null;
  }
  hideLoadingOverlay() {
    this.loadingOverlay.style.display = "none";
  }
  setZIndex(index) {
    this.overlay.style.zIndex = index;
    this.panelWrapper.style.zIndex = index + 100;
  }
  getZIndexMax() {
    return Number(getComputedStyle(this.panelWrapper).zIndex);
  }
  initDesignMode() {
    const section = this.closest(".shopify-section");
    this.onShopifySectionLoaded = this.onShopifySectionLoaded.bind(this);
    this.onShopifySectionSelected = this.onShopifySectionSelected.bind(this);
    this.onShopifySectionDeselected = this.onShopifySectionDeselected.bind(this);
    section.addEventListener("shopify:section:load", this.onShopifySectionLoaded);
    section.addEventListener("shopify:section:select", this.onShopifySectionSelected);
    section.addEventListener("shopify:section:deselect", this.onShopifySectionDeselected);
    this.designModeInit = true;
  }
  disableDesignMode() {
    const section = this.closest(".shopify-section");
    section.removeEventListener("shopify:section:load", this.onShopifySectionLoaded);
    section.removeEventListener("shopify:section:select", this.onShopifySectionSelected);
    section.removeEventListener("shopify:section:deselect", this.onShopifySectionDeselected);
    this.designModeInit = false;
  }
  onShopifySectionLoaded() {
    this.show();
  }
  onShopifySectionSelected({ detail: { load } }) {
    this.show({ anim: !load, load });
  }
  onShopifySectionDeselected() {
    this.hide();
  }
}
customElements.define("x-modal", Modal);
const breakpoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  hd: "1400px"
};
const breakpointsInt = Object.fromEntries(
  Object.entries(breakpoints).map(([key, value]) => [key, parseInt(value)])
);
function getSortedBreakpointKeys() {
  return Object.keys(breakpointsInt).sort((a, b) => breakpointsInt[b] - breakpointsInt[a]);
}
function getCurrentBreakpointKey(sortedBreakpointKeys) {
  const windowWidth = window.innerWidth;
  for (let i = 0; i < sortedBreakpointKeys.length; i++) {
    const breakpoint = sortedBreakpointKeys[i];
    const width = breakpointsInt[breakpoint];
    if (windowWidth >= width) {
      return breakpoint;
    }
  }
  return null;
}
function getResponsiveAttribute(el, name) {
  const sortedBreakpointKeys = getSortedBreakpointKeys();
  const currentBreakpointKey = getCurrentBreakpointKey(sortedBreakpointKeys);
  if (!currentBreakpointKey) {
    return el.getAttribute(name);
  }
  const currentIndex = sortedBreakpointKeys.indexOf(currentBreakpointKey);
  for (let i = currentIndex; i < sortedBreakpointKeys.length; i++) {
    const responsiveName = `${sortedBreakpointKeys[i]}:${name}`;
    if (el.hasAttribute(responsiveName)) {
      return el.getAttribute(responsiveName);
    }
  }
  return el.getAttribute(name);
}
function isBelow(breakpoint) {
  return window.innerWidth < breakpointsInt[breakpoint];
}
function isAbove(breakpoint) {
  return window.innerWidth >= breakpointsInt[breakpoint];
}
class ModalDrawer extends Modal {
  constructor() {
    super();
    this.isRoot = true;
    this.isChild = false;
    this.fadeOnMobile = true;
    this.parentDrawer = null;
    this.activeChildDrawer = null;
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.getAttribute("child") !== null) {
      this.parentDrawer = this.parentNode.closest("modal-drawer");
      this.isChild = true;
    }
  }
  onEscapeKeyDown(e) {
    if (!this.isChild) {
      super.onEscapeKeyDown(e);
    }
  }
  getPosition() {
    return getResponsiveAttribute(this, "position") ?? "right";
  }
  getPositionInverse() {
    switch (this.getPosition()) {
      case "top":
        return "bottom";
      case "bottom":
        return "top";
      case "left":
        return "right";
      case "right":
        return "left";
    }
  }
  async show({ anim = true, focusTrap = true } = {}) {
    if (this.open)
      return;
    await this.beforeShow();
    if (this.isChild && this.parentDrawer) {
      Object.assign(this.parentDrawer.panel.style, {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        overflow: "visible"
      });
      Object.assign(this.panel.style, {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      });
      if (this.parentDrawer.activeChildDrawer) {
        await this.parentDrawer.activeChildDrawer.animOutContentsAndHide();
        this.parentDrawer.activeChildDrawer = this;
        await this.animInPanelContents();
        return;
      } else {
        this.parentDrawer.activeChildDrawer = this;
      }
    }
    if (!this.isChild) {
      this.fadeInOverlay(anim);
      this.lockScroll();
    }
    if (anim) {
      await this.animInPanel();
    } else {
      this.panelWrapper.style.display = "flex";
    }
    if (!this.isChild && focusTrap && this.focusTrap) {
      this.focusTrap.activate();
    }
  }
  async hide({ anim = true } = {}) {
    if (!this.open) {
      return;
    }
    await this.beforeHide();
    const promises = [];
    if (anim) {
      promises.push(this.animOutPanel());
    } else {
      this.panelWrapper.style.display = null;
    }
    if (this.activeChildDrawer) {
      promises.push(this.activeChildDrawer.hide({ anim }));
      this.activeChildDrawer = null;
    }
    await Promise.all(promises);
    this.panel.removeAttribute("style");
    if (!this.isChild) {
      await this.fadeOutOverlay();
    }
    this.afterHide();
  }
  async animInPanel() {
    this.panelWrapper.style.display = "flex";
    void this.clientHeight;
    this.panel.scrollTo(0, 0);
    let anim = null;
    anim = animate(this.panel, "fade-in", {
      ...this.getFadeXY("50%"),
      duration: 400,
      easing: "ease"
    });
    animate(this.panelInner, "fade-in", {
      ...this.getFadeXY("1rem"),
      duration: 400,
      easing: "ease"
    });
    await anim.finished;
  }
  getCornerRadius() {
    return this.isChild ? "0" : "var(--block-corner-radius)";
  }
  async animInPanelContents() {
    this.panelWrapper.style.display = "flex";
    await this.panelInner.animate(
      { opacity: [0, 1], transform: ["translateY(-.5rem)", "none"] },
      { duration: 125, easing: "ease-out", fill: "backwards" }
    ).finished;
  }
  async animOutPanel() {
    if (this.isChild) {
      await delay$1(175);
      this.panelWrapper.style.display = null;
    } else {
      await animate(this.panel, "fade-out", {
        duration: 150,
        easing: "linear",
        ...this.getFadeXY()
      }).finished;
      this.panelWrapper.style.display = null;
    }
  }
  getFadeXY(distance = "1rem") {
    switch (this.getPosition()) {
      case "top":
        return { x: 0, y: `-${distance}` };
      case "bottom":
        return { x: 0, y: `${distance}` };
      case "left":
        return { x: `-${distance}`, y: 0 };
      case "right":
        return { x: `${distance}`, y: 0 };
    }
  }
  async animOutContentsAndHide() {
    await this.panelInner.animate(
      { opacity: [1, 0], transform: ["none", "translateY(.5rem)"] },
      { duration: 125, easing: "ease-in" }
    ).finished;
    this.hide({ anim: false });
  }
  get animation() {
    return this.getAttribute("animation");
  }
}
customElements.define("modal-drawer", ModalDrawer);
class CartModal extends ModalDrawer {
  constructor() {
    super();
    this.reloadContent = this.reloadContent.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("product:added-to-cart", this.reloadContent);
    this.addEventListener("order-note:updated", this.onOrderNoteUpdated.bind(this));
    if (window.Shopify.designMode)
      this.initDesignMode();
  }
  disconnectedCallback() {
    super.disconnectedCallback && super.disconnectedCallback();
    document.removeEventListener("product:added-to-cart", this.reloadContent);
  }
  get sectionId() {
    return getSectionId(this.closest(".shopify-section"));
  }
  async reloadContent() {
    const resp = await fetch(`${window.location.pathname}?section_id=${this.sectionId}`);
    const html = await resp.text();
    this.updateFromSectionHtml(html);
  }
  updateFromSectionHtml(html) {
    const el = createElementFromHtml(html);
    preserveSectionState(this, () => {
      this.content.replaceChildren(...el.querySelector("[slot=content]").children);
    });
  }
  onOrderNoteUpdated(e) {
    const label = this.content.querySelector(".order-note-button-label");
    if (e.detail.note.trim().length > 0) {
      label.textContent = window._t.sections.cart.edit_note;
    } else {
      label.textContent = window._t.sections.cart.add_note;
    }
  }
  // async show({ addedToCartAlert = false } = {}) {
  //   if (this.open) {
  //     return;
  //   }
  //   super.show(arguments);
  //   this.content.querySelector("[data-added-to-cart-alert]").style.display = addedToCartAlert
  //     ? null
  //     : "none";
  // }
}
customElements.define("cart-modal", CartModal);
class CopyToClipboard extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.copyToClipboard.bind(this));
  }
  async copyToClipboard() {
    await navigator.clipboard.writeText(this.dataset.text);
    await showNotification({
      text: window._t.share.copied_to_clipboard,
      time: 3e3
    });
  }
}
customElements.define("copy-to-clipboard", CopyToClipboard);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector("[data-poster]");
    this.poster && this.poster.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    this.poster.style.display = "none";
    pauseAllMedia();
    if (!this.loaded) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.loaded = true;
      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus)
        deferredElement.focus();
      if (deferredElement.tagName === "VIDEO") {
        deferredElement.play();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class DotsIndicator extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `<div class="dots-indicator"></div>`;
    this.itemCount = 0;
    this.dotsContainer = null;
    this.controlledElement = null;
  }
  connectedCallback() {
    this.itemCount = this.getAttribute("item-count");
    this.dotsContainer = this.querySelector(".dots-indicator");
    this.createDots();
    const controlledElementId = this.getAttribute("aria-controls");
    if (controlledElementId) {
      this.controlledElement = document.getElementById(controlledElementId);
      if (this.controlledElement) {
        this.controlledElement.addEventListener("carousel:change", (e) => {
          this.updateActiveDot(e.detail.index);
        });
      }
    }
  }
  createDots() {
    for (let i = 0; i < this.itemCount; i++) {
      const dot = document.createElement("button");
      dot.classList.add("dots-indicator__dot");
      dot.addEventListener("click", () => this.onDotClick(i));
      this.dotsContainer.appendChild(dot);
    }
    this.updateActiveDot(0);
  }
  onDotClick(index) {
    if (this.controlledElement) {
      this.controlledElement.dispatchEvent(new CustomEvent("control:change", { detail: { index } }));
    }
    this.updateActiveDot(index);
  }
  updateActiveDot(index) {
    const previousDot = this.dotsContainer.querySelector(".dots-indicator__dot.active");
    if (previousDot) {
      previousDot.classList.remove("active");
    }
    const newDot = this.dotsContainer.children[index];
    if (newDot) {
      newDot.classList.add("active");
    }
  }
}
customElements.define("dots-indicator", DotsIndicator);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$map$so;
              const placement2 = (_overflowsData$map$so = overflowsData.map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
const size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  return getCssDimensions(element);
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const window2 = getWindow(element);
  if (!isHTMLElement(element)) {
    return window2;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
const getElementRects = async function(_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...await getDimensionsFn(floating)
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root2.clientWidth - (left + width));
    const insetBottom = floor(root2.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
window.activeDropdowns = [];
class DropdownElement extends HTMLElement {
  constructor() {
    super();
    this.state = "close";
    this.currentAnim = null;
    this.hideTimer = null;
    this.onWindowClickBound = this.onWindowClick.bind(this);
    this.dynamicPosition = true;
    this.hoverShowDelay = 150;
    this.hideDelay = 250;
  }
  get isMinWidthFull() {
    return this.getAttribute("min-width-full") !== null;
  }
  get isHideMenuOnClick() {
    return this.getAttribute("hide-on-menu-click") !== null;
  }
  get maxWidth() {
    return Number(this.getAttribute("max-width") ?? Number.MAX_SAFE_INTEGER);
  }
  get maxHeight() {
    const attr = this.getAttribute("max-height");
    if (attr === "false")
      return Number.MAX_SAFE_INTEGER;
    return Number(attr ?? 500);
  }
  connectedCallback() {
    if (this.details)
      return;
    this.details = this.querySelector("details");
    this.summary = this.querySelector("details > summary");
    this.menu = this.summary.nextElementSibling;
    this.submenus = this.menu.querySelectorAll("details");
    if (this.getAttribute("hover-show-delay") !== null) {
      this.hoverShowDelay = Number(this.getAttribute("hover-show-delay"));
    }
    if ("ontouchstart" in window) {
      this.setInteractionHandler("click");
    } else {
      this.setInteractionHandler(this.getAttribute("interaction-handler") ?? "click");
    }
    if (this.isHideMenuOnClick) {
      this.menu.addEventListener("click", this.hide.bind(this));
    }
  }
  disconnectedCallback() {
    this.detachInteractionHandler();
  }
  setState(state) {
    this.state = state;
    this.classList.remove("fading-in", "fading-out");
    switch (this.state) {
      case "close":
        this.submenus.forEach((submenu) => submenu.open = false);
        void this.details.offsetTop;
        this.details.open = false;
        break;
      case "fading-in":
        this.classList.add("fading-in");
        this.details.open = true;
        break;
      case "open":
        this.details.open = true;
        break;
      case "fading-out":
        this.classList.add("fading-out");
        this.details.open = true;
        break;
    }
  }
  setInteractionHandler(handlerType) {
    this.interactionHandlerType = handlerType;
    this.attachInteractionHandler();
  }
  attachInteractionHandler() {
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));
    if (this.interactionHandlerType === "click") {
      window.addEventListener("click", this.onWindowClickBound);
    } else if (this.interactionHandlerType === "hover") {
      this.summary.addEventListener("mouseenter", this.onSummaryMouseEnter.bind(this));
      this.menu.addEventListener("mouseenter", this.cancelHide.bind(this));
      this.summary.addEventListener("mouseleave", this.onMouseLeave.bind(this));
      this.menu.addEventListener("mouseleave", this.onMouseLeave.bind(this));
      this.menu.addEventListener("click", this.onMenuClick.bind(this));
    }
  }
  detachInteractionHandler() {
    if (this.interactionHandlerType === "click") {
      window.removeEventListener("click", this.onWindowClickBound);
    }
  }
  // Hover handling
  onSummaryMouseEnter() {
    this.cancelHide();
    if (this.hoverShowDelay) {
      this.showTimer = setTimeout(() => {
        this.show({ trigger: "hover" });
      }, this.hoverShowDelay);
    } else {
      this.show({ trigger: "hover" });
    }
  }
  onMenuClick() {
    this.menuJustClicked = true;
    clearTimeout(this.menuJustClickedTimeout);
    this.menuJustClickedTimeout = setTimeout(() => this.menuJustClicked = false, 500);
  }
  onMouseLeave() {
    this.cancelShow();
    if (this.menuJustClicked)
      return;
    this.hideTimer = setTimeout(() => {
      this.hide();
    }, this.hideDelay);
  }
  cancelHide() {
    clearTimeout(this.hideTimer);
    this.hideTimer = null;
  }
  cancelShow() {
    clearTimeout(this.showTimer);
    this.showTimer = null;
  }
  // Save state
  saveComponentState() {
    return { state: this.state };
  }
  loadComponentState(data) {
    this.setState(data.state ?? "close");
    this.updatePosition();
  }
  // Click handling
  onWindowClick(e) {
    if (this.state === "open" && !this.details.contains(e.target)) {
      this.onSummaryClick(e, false);
    }
  }
  onSummaryClick(e, prevent = true) {
    var _a, _b;
    if (prevent && this.interactionHandlerType === "click") {
      e.preventDefault();
    }
    switch (this.state) {
      case "close":
      case "fading-out":
        (_a = this.currentAnim) == null ? void 0 : _a.cancel();
        this.state = "close";
        this.show({ trigger: "click" });
        break;
      case "open":
      case "fading-in":
        (_b = this.currentAnim) == null ? void 0 : _b.cancel();
        this.state = "open";
        this.hide();
        break;
    }
  }
  get offset() {
    return Number(this.getAttribute("offset") ?? 16);
  }
  get offsetCross() {
    return Number(getResponsiveAttribute(this, "offset-cross") ?? 0);
  }
  get placement() {
    return getResponsiveAttribute(this, "placement") ?? "bottom-start";
  }
  get appendToBody() {
    return this.getAttribute("append-to-body") !== null;
  }
  async updatePosition() {
    const self2 = this;
    const middleware = [
      offset({ mainAxis: this.offset, crossAxis: this.offsetCross }),
      shift({ padding: 16 }),
      size({
        padding: 16,
        apply({ availableWidth, availableHeight, elements }) {
          Object.assign(elements.floating.style, {
            maxHeight: `${Math.max(250, Math.min(availableHeight, self2.maxHeight))}px`,
            maxWidth: `${Math.max(150, Math.min(availableWidth, self2.maxWidth))}px`
          });
        }
      }),
      flip({ fallbackStrategy: "initialPlacement" })
    ];
    if (this.isMinWidthFull) {
      middleware.unshift(
        size({
          apply({ rects, elements }) {
            Object.assign(elements.floating.style, {
              minWidth: `${rects.reference.width}px`
            });
          }
        })
      );
    }
    const { x, y } = await computePosition(this.summary, this.menu, {
      middleware,
      placement: this.placement
    });
    Object.assign(this.menu.style, { left: `${x}px`, top: `${y}px` });
  }
  // Animation
  async show({ anim = true } = {}) {
    if (this.state === "open" || this.state === "fading-in")
      return;
    window.activeDropdowns.forEach((el) => el.hide());
    window.activeDropdowns.push(this);
    this.setState("fading-in");
    if (this.appendToBody) {
      document.body.append(this.menu);
    }
    if (this.dynamicPosition) {
      this.autoUpdatePositionEnd = autoUpdate(this.summary, this.menu, () => this.updatePosition());
    }
    if (anim) {
      this.currentAnim = this.runShowAnimation();
      try {
        await this.currentAnim.finished;
      } catch (_) {
      }
    }
    this.setState("open");
  }
  async hide() {
    if (this.state === "close" || this.state === "fading-out")
      return;
    window.activeDropdowns = window.activeDropdowns.filter((x) => x !== this);
    this.cancelHide();
    this.autoUpdatePositionEnd && this.autoUpdatePositionEnd();
    this.setState("fading-out");
    this.currentAnim = this.runHideAnimation();
    try {
      await this.currentAnim.finished;
    } catch (_) {
    }
    if (this.appendToBody) {
      this.summary.after(this.menu);
    }
    this.setState("close");
  }
  runShowAnimation() {
    switch (this.getAttribute("animation") ?? "fade-down") {
      case "fade-down":
        return animate(this.menu, "fade-in", { y: "-1rem", duration: 100, easing: EaseOut });
      case "fade-up":
        return animate(this.menu, "fade-in", { y: "1rem", duration: 100, easing: EaseOut });
      case "scale":
        return animate(this.menu, "scale-in", { duration: 150 });
    }
  }
  runHideAnimation() {
    switch (this.getAttribute("animation") ?? "fade-down") {
      case "fade-down":
        return animate(this.menu, "fade-out", { y: "-1rem", duration: 150, easing: "ease-in-out" });
      case "fade-up":
        return animate(this.menu, "fade-out", { y: "1rem", duration: 150, easing: "ease-in-out" });
      case "scale":
        return animate(this.menu, "scale-out", { duration: 150, easing: EaseOut });
    }
  }
}
customElements.define("dropdown-element", DropdownElement);
class DropdownList extends DropdownElement {
  connectedCallback() {
    super.connectedCallback();
    this.setupElements();
    this.setupEventListeners();
    if (this.activeOption) {
      this.updateInputAttributes(this.activeOption);
    }
  }
  setupElements() {
    this.valueInput = this.querySelector("[data-list-value]");
    this.dropdownActivator = this.querySelector("[data-dropdown-activator]");
    this.options = Array.from(this.querySelectorAll("[data-value]"));
  }
  setupEventListeners() {
    this.options.forEach((el) => el.addEventListener("click", this.onOptionClick.bind(this)));
    this.addEventListener("keydown", this.onKeyDownHandler.bind(this));
    if (this.focusOnly && this.appendToBody) {
      this.menu.addEventListener("keydown", this.onKeyDownHandler.bind(this));
    }
  }
  get focusOnly() {
    return this.getAttribute("focus-only") !== null;
  }
  get selectedOption() {
    return this.options.find((el) => el.dataset.value === this.valueInput.value);
  }
  async onOptionClick(e) {
    if (this.focusOnly) {
      await this.hide();
      return;
    }
    e.preventDefault();
    this.updateSelected(e.currentTarget);
    await this.hide();
  }
  onKeyDownHandler(e) {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      this.updateSelected(this.getPrevOption());
      this.setActiveClass();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      this.updateSelected(this.getNextOption());
      this.setActiveClass();
    } else if (this.state === "open" && (e.key === "Tab" || e.key === "Escape")) {
      e.stopPropagation();
      this.hide();
      if (this.focusOnly) {
        this.dropdownActivator.focus();
      }
    }
  }
  getNextOption() {
    const activeEl = this.getActiveElement();
    return this.options[mod(this.options.findIndex((el) => el === activeEl) + 1, this.options.length)];
  }
  getPrevOption() {
    const activeEl = this.getActiveElement();
    return this.options[mod(this.options.findIndex((el) => el === activeEl) - 1, this.options.length)];
  }
  getActiveElement() {
    if (this.focusOnly) {
      return this.menu.contains(document.activeElement) ? document.activeElement : null;
    }
    return this.querySelector("[data-value].active");
  }
  async show() {
    var _a;
    if (this.state === "open" || this.state === "fading-in")
      return;
    this.startValue = (_a = this.valueInput) == null ? void 0 : _a.value;
    this.setActiveClass();
    if (this.shouldShowMobileModal()) {
      await this.showMobileModal();
    } else {
      await super.show();
    }
  }
  async hide() {
    if (this.state === "close" || this.state === "fading-out")
      return;
    this.emitChange();
    if (this.mobileModal) {
      await this.hideMobileModal();
    } else {
      await super.hide();
    }
  }
  emitChange() {
    if (this.focusOnly) {
      return;
    }
    if (this.valueInput.value !== this.startValue) {
      this.startValue = this.valueInput.value;
      this.valueInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
  shouldShowMobileModal() {
    return window.innerWidth < 768 && !this.hasAttribute('data-trouser-selector');
  }
  async showMobileModal() {
    this.state = "open";
    this.menu.removeAttribute("style");
    Object.assign(this.menu.style, { position: "static", width: "100%" });
    const el = createElementFromHtml(`
      <x-modal class="modal bottom-modal modal-w-full">
        <div slot="content" tabindex="-1" class="cb-size-picker flex flex-col items-stretch">
          <div class="flex items-center p-4">
            <h3 class="h3">${this.getAttribute("list-title") ?? ""}</h3>
            <button class="modal-close ml-auto" data-button-close>${window.svgs.times}</button>
          </div>
          <div data-content class="grow overflow-y-auto custom-scrollbar"></div>
        </div>
      </x-modal>
    `);
    el.querySelector("[data-content]").append(this.menu);
    document.body.append(el);
    this.mobileModal = el;
    el.addEventListener("hide-end", () => {
      this.emitChange();
      this.cleanupMobileModal();
    });
    await el.show();
  }
  async hideMobileModal() {
    await this.mobileModal.hide();
    this.cleanupMobileModal();
  }
  cleanupMobileModal() {
    var _a;
    (_a = this.mobileModal) == null ? void 0 : _a.remove();
    this.mobileModal = null;
    Object.assign(this.menu.style, { position: null, width: null });
    this.summary.after(this.menu);
    this.state = "close";
  }
  onWindowClick(e) {
    if (this.mobileModal)
      return;
    super.onWindowClick(e);
  }
  setActiveClass() {
    var _a;
    if (this.focusOnly) {
      return;
    }
    this.options.forEach((el) => el.classList.remove("active"));
    (_a = this.activeOption) == null ? void 0 : _a.classList.add("active");
  }
  get activeOption() {
    if (!this.valueInput) {
      return null;
    }
    return this.options.find((el) => el.dataset.value === this.valueInput.value);
  }
  updateSelected(option) {
    if (this.focusOnly) {
      option.focus();
      return;
    }
    if (this.dropdownActivator) {
      this.dropdownActivator.textContent = option.dataset.text ?? option.textContent;
    }
    this.updateInputAttributes(option);
  }
  updateInputAttributes(option) {
    if (!this.valueInput) {
      return;
    }
    for (let key in this.valueInput.dataset) {
      delete this.valueInput.dataset[key];
    }
    Object.assign(this.valueInput.dataset, option.dataset);
    this.valueInput.value = option.dataset.value;
  }
  get isMinWidthFull() {
    return true;
  }
  get offset() {
    return Number(this.getAttribute("offset") ?? 8);
  }
}
customElements.define("dropdown-list", DropdownList);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.facetForm = this.querySelector("form");
    if (this.getAttribute("manual") === null) {
      this.facetForm.addEventListener("change", this.onSubmit.bind(this));
    }
    this.parentSection = this.closest(".shopify-section");
    this.otherForms = Array.from(
      document.querySelectorAll(`facet-filters-form:not([type="${this.getAttribute("type")}"])`)
    ).filter((form) => form !== this);
  }
  async onSubmit() {
    var _a;
    this.parentSection.classList.add("loading");
    if (this.abortController) {
      this.abortController.abort();
      const ac = new AbortController();
      this.abortController = ac;
      await delay$1(500);
      if (ac.signal.aborted) {
        return;
      }
    } else {
      this.abortController = new AbortController();
    }
    const allFormData = this.otherForms.reduce((formData, form) => {
      const data = new FormData(form.facetForm);
      for (const entry of data.entries()) {
        formData.append(entry[0], entry[1]);
      }
      return formData;
    }, new FormData(this.facetForm));
    const url = `${window.location.origin}${window.location.pathname}?${new URLSearchParams(
      [...allFormData.entries()].filter((x) => x[1])
    ).toString()}`;
    try {
      await reloadSection(this.parentSection, { url, signal: this.abortController.signal });
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error(err);
      }
      return;
    }
    void this.parentSection.offsetTop;
    this.parentSection.classList.remove("loading");
    if (isAbove("lg")) {
      scrollIntoViewIfNeeded(
        document.querySelector(".active-facets") ?? this.parentSection,
        ((_a = document.querySelector(".header")) == null ? void 0 : _a.clientHeight) + 16
      );
    }
    history.replaceState({}, "", url);
    this.abortController = null;
  }
}
customElements.define("facet-filters-form", FacetFiltersForm);
class FacetsDrawerModal extends ModalDrawer {
  constructor() {
    super();
    this.formChanged = false;
  }
  show(params) {
    const form = this.querySelector("facet-filters-form");
    form.addEventListener("input", this.handleFormChange.bind(this));
    return super.show(params);
  }
  hide(params) {
    const form = this.querySelector("facet-filters-form");
    form.removeEventListener("input", this.handleFormChange.bind(this));
    if (this.formChanged) {
      form.onSubmit();
    }
    this.formChanged = false;
    return super.hide(params);
  }
  handleFormChange() {
    this.formChanged = true;
  }
}
customElements.define("facets-drawer-modal", FacetsDrawerModal);
class ImageComparison extends HTMLElement {
  constructor() {
    super();
    this.isMoving = false;
    this.progress = 0.5;
    this.startMove = this.startMove.bind(this);
    this.stopMove = this.stopMove.bind(this);
    this.move = this.move.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }
  connectedCallback() {
    this.handle = this.querySelector(".image-comparison__handle");
    this.bar = this.querySelector(".image-comparison__bar");
    this.handle.addEventListener("mousedown", this.startMove);
    this.handle.addEventListener("touchstart", this.startMove);
    document.addEventListener("mouseup", this.stopMove);
    document.addEventListener("touchend", this.stopMove);
    document.addEventListener("mousemove", this.move);
    document.addEventListener("touchmove", this.move);
    this.addEventListener("keydown", this.handleKeydown);
  }
  disconnectedCallback() {
    this.handle.removeEventListener("mousedown", this.startMove);
    this.handle.removeEventListener("touchstart", this.startMove);
    document.removeEventListener("mouseup", this.stopMove);
    document.removeEventListener("touchend", this.stopMove);
    document.removeEventListener("mousemove", this.move);
    document.removeEventListener("touchmove", this.move);
    this.removeEventListener("keydown", this.handleKeydown);
  }
  startMove(event) {
    event.preventDefault();
    this.isMoving = true;
  }
  stopMove() {
    this.isMoving = false;
  }
  move(event) {
    if (!this.isMoving)
      return;
    let clientX = event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
    let rect = this.getBoundingClientRect();
    let progress = (clientX - rect.left) / rect.width;
    this.setProgress(Math.max(0, Math.min(1, progress)));
  }
  // Method to handle keydown event
  handleKeydown(event) {
    if (event.key === "ArrowLeft") {
      this.setProgress(this.progress - 0.1);
    } else if (event.key === "ArrowRight") {
      this.setProgress(this.progress + 0.1);
    }
  }
  setProgress(progress) {
    this.progress = Math.max(0, Math.min(1, progress));
    this.style.setProperty("--image-comparison-progress", this.progress * 100 + "%");
  }
}
customElements.define("image-comparison", ImageComparison);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
    this.querySelectorAll("button").forEach(
      (item) => item.addEventListener("click", (event) => {
        event.preventDefault();
        const form = this.querySelector("form");
        this.input.value = event.currentTarget.dataset.value;
        if (form)
          form.submit();
      })
    );
  }
}
customElements.define("localization-form", LocalizationForm);
class LQIPElement extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      const images = Array.from(this.querySelectorAll("img"));
      this.actualImage = images[0];
      this.placeholderImage = images[1];
      if (!this.actualImage) {
        return;
      }
      if (this.actualImage.complete) {
        this.classList.add("loaded");
        if (this.placeholderImage) {
          this.placeholderImage.remove();
        }
        return;
      }
      this.classList.add("loading");
      if (!this.actualImage.complete || this.placeholderImage && !this.placeholderImage.complete) {
        this.loadingBar = this.appendChild(
          tap(document.createElement("div"), (div) => {
            div.classList.add("loading-bar");
          })
        );
      }
      if (this.placeholderImage) {
        imageLoaded(this.placeholderImage).then(() => this.showPlaceholder());
      }
      imageLoaded(this.actualImage).then(() => this.showActaulImage());
    });
  }
  showPlaceholder() {
    var _a, _b;
    (_a = this.placeholderImage) == null ? void 0 : _a.animate({ opacity: [0, 1] }, { duration: 200 }).finished.finally(() => {
      if (this.placeholderImage) {
        this.placeholderImage.style.opacity = "1";
      }
    });
    (_b = this.loadingBar) == null ? void 0 : _b.animate({ opacity: [1, 0] }, { duration: 100 }).finished.finally(() => {
      var _a2;
      (_a2 = this.loadingBar) == null ? void 0 : _a2.remove();
    });
  }
  showActaulImage() {
    var _a;
    (_a = this.loadingBar) == null ? void 0 : _a.remove();
    this.actualImage.animate({ opacity: [0, 1] }, { duration: 200 }).finished.finally(() => {
      this.classList.remove("loading");
      this.classList.add("loaded");
      this.actualImage.style.opacity = "1";
      if (this.placeholderImage) {
        this.placeholderImage.remove();
        this.placeholderImage = null;
      }
    });
  }
}
customElements.define("lqip-element", LQIPElement);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var pubsub = { exports: {} };
pubsub.exports;
(function(module2, exports2) {
  (function(root2, factory) {
    var PubSub = {};
    if (root2.PubSub) {
      PubSub = root2.PubSub;
      console.warn("PubSub already loaded, using existing version");
    } else {
      root2.PubSub = PubSub;
      factory(PubSub);
    }
    {
      if (module2 !== void 0 && module2.exports) {
        exports2 = module2.exports = PubSub;
      }
      exports2.PubSub = PubSub;
      module2.exports = exports2 = PubSub;
    }
  })(typeof window === "object" && window || commonjsGlobal, function(PubSub) {
    var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
    function hasKeys(obj) {
      var key;
      for (key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          return true;
        }
      }
      return false;
    }
    function throwException(ex) {
      return function reThrowException() {
        throw ex;
      };
    }
    function callSubscriberWithDelayedExceptions(subscriber, message, data) {
      try {
        subscriber(message, data);
      } catch (ex) {
        setTimeout(throwException(ex), 0);
      }
    }
    function callSubscriberWithImmediateExceptions(subscriber, message, data) {
      subscriber(message, data);
    }
    function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
      var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
      if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
        return;
      }
      for (s in subscribers) {
        if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
          callSubscriber(subscribers[s], originalMessage, data);
        }
      }
    }
    function createDeliveryFunction(message, data, immediateExceptions) {
      return function deliverNamespaced() {
        var topic = String(message), position = topic.lastIndexOf(".");
        deliverMessage(message, message, data, immediateExceptions);
        while (position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          deliverMessage(message, topic, data, immediateExceptions);
        }
        deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
      };
    }
    function hasDirectSubscribersFor(message) {
      var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
      return found;
    }
    function messageHasSubscribers(message) {
      var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
      while (!found && position !== -1) {
        topic = topic.substr(0, position);
        position = topic.lastIndexOf(".");
        found = hasDirectSubscribersFor(topic);
      }
      return found;
    }
    function publish(message, data, sync, immediateExceptions) {
      message = typeof message === "symbol" ? message.toString() : message;
      var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
      if (!hasSubscribers) {
        return false;
      }
      if (sync === true) {
        deliver();
      } else {
        setTimeout(deliver, 0);
      }
      return true;
    }
    PubSub.publish = function(message, data) {
      return publish(message, data, false, PubSub.immediateExceptions);
    };
    PubSub.publishSync = function(message, data) {
      return publish(message, data, true, PubSub.immediateExceptions);
    };
    PubSub.subscribe = function(message, func) {
      if (typeof func !== "function") {
        return false;
      }
      message = typeof message === "symbol" ? message.toString() : message;
      if (!Object.prototype.hasOwnProperty.call(messages, message)) {
        messages[message] = {};
      }
      var token = "uid_" + String(++lastUid);
      messages[message][token] = func;
      return token;
    };
    PubSub.subscribeAll = function(func) {
      return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };
    PubSub.subscribeOnce = function(message, func) {
      var token = PubSub.subscribe(message, function() {
        PubSub.unsubscribe(token);
        func.apply(this, arguments);
      });
      return PubSub;
    };
    PubSub.clearAllSubscriptions = function clearAllSubscriptions() {
      messages = {};
    };
    PubSub.clearSubscriptions = function clearSubscriptions(topic) {
      var m;
      for (m in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
          delete messages[m];
        }
      }
    };
    PubSub.countSubscriptions = function countSubscriptions(topic) {
      var m;
      var token;
      var count = 0;
      for (m in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
          for (token in messages[m]) {
            count++;
          }
          break;
        }
      }
      return count;
    };
    PubSub.getSubscriptions = function getSubscriptions(topic) {
      var m;
      var list = [];
      for (m in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
          list.push(m);
        }
      }
      return list;
    };
    PubSub.unsubscribe = function(value) {
      var descendantTopicExists = function(topic) {
        var m2;
        for (m2 in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
            return true;
          }
        }
        return false;
      }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction2 = typeof value === "function", result = false, m, message, t;
      if (isTopic) {
        PubSub.clearSubscriptions(value);
        return;
      }
      for (m in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, m)) {
          message = messages[m];
          if (isToken && message[value]) {
            delete message[value];
            result = value;
            break;
          }
          if (isFunction2) {
            for (t in message) {
              if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                delete message[t];
                result = true;
              }
            }
          }
        }
      }
      return result;
    };
  });
})(pubsub, pubsub.exports);
var pubsubExports = pubsub.exports;
const PRODUCT_GALLERY_CHANGED = "product.gallery.changed";
const PRODUCT_GALLERY_INDICATOR_CHANGED = "product.gallery.indicator_changed";
const COLLAPSE_CHANGED = "collapse.changed";
class MediaCarouselBar extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }

        .container {
          display: flex;
          align-items: center;
          width: 100%;
          height: .25rem;
          background-color: rgb(0 0 0 / 8%);
          position: relative;
        }

        .indicator {
          position: absolute;
          height: .25rem;
          background-color: rgb(var(--color-base-accent));
          transition: transform 300ms;
        }
      </style>
      <div class="container">
        <div class="indicator"></div>
      </div>
    `;
  }
  connectedCallback() {
    var _a;
    this.sectionId = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    this.mediaCount = this.getAttribute("media-count");
    this.indicator = this.shadowRoot.querySelector(".indicator");
    this.container = this.shadowRoot.querySelector(".container");
    this.indicator.style.width = `${100 / this.mediaCount}%`;
    this.resizeObserver = new ResizeObserver(() => this.calculateX(this.currentIndex));
    this.resizeObserver.observe(this);
    this.container.addEventListener("click", (e) => this.onContainerClick(e));
    this.subs = [];
    this.subs.push(pubsubExports.subscribe(PRODUCT_GALLERY_CHANGED, (_, data) => {
      if (data.sectionId === this.sectionId) {
        this.onIndexChanged(data);
      }
    }));
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
    this.subs.forEach((x) => pubsubExports.unsubscribe(x));
  }
  onContainerClick(e) {
    const containerWidth = this.container.clientWidth;
    const indicatorWidth = this.indicator.clientWidth;
    const clickPosition = e.clientX - this.container.getBoundingClientRect().left;
    const newIndex = Math.floor(
      clickPosition / (containerWidth - indicatorWidth) * (this.mediaCount - 1)
    );
    this.currentIndex = newIndex;
    pubsubExports.publish(PRODUCT_GALLERY_INDICATOR_CHANGED, {
      index: newIndex,
      sectionId: this.sectionId
    });
    this.calculateX(newIndex);
  }
  onIndexChanged({ index }) {
    this.currentIndex = index;
    this.calculateX(index);
  }
  calculateX(index) {
    const x = (this.clientWidth - this.indicator.clientWidth) * (index / (this.mediaCount - 1));
    this.indicator.style.transform = `translateX(${x}px)`;
  }
}
customElements.define("media-carousel-bar", MediaCarouselBar);
class MediaCarouselDots extends DotsIndicator {
  constructor() {
    super();
    this.subs = [];
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.sectionId = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    this.subs.push(
      pubsubExports.subscribe(PRODUCT_GALLERY_CHANGED, (_, data) => {
        if (data.sectionId === this.sectionId) {
          this.onIndexChanged(data);
        }
      })
    );
  }
  disconnectedCallback() {
    this.subs.forEach((x) => pubsubExports.unsubscribe(x));
  }
  onDotClick(index) {
    super.onDotClick(index);
    pubsubExports.publish(PRODUCT_GALLERY_INDICATOR_CHANGED, {
      index,
      sectionId: this.sectionId
    });
  }
  onIndexChanged({ index }) {
    this.updateActiveDot(index);
  }
}
customElements.define("media-carousel-dots", MediaCarouselDots);
const scriptRel = "modulepreload";
const assetsURL = function(dep) {
  return "/" + dep;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  if (!deps || deps.length === 0) {
    return baseModule();
  }
  const links = document.getElementsByTagName("link");
  return Promise.all(deps.map((dep) => {
    dep = assetsURL(dep);
    if (dep in seen)
      return;
    seen[dep] = true;
    const isCss = dep.endsWith(".css");
    const cssSelector = isCss ? '[rel="stylesheet"]' : "";
    const isBaseRelative = !!importerUrl;
    if (isBaseRelative) {
      for (let i = links.length - 1; i >= 0; i--) {
        const link2 = links[i];
        if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
          return;
        }
      }
    } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
      return;
    }
    const link = document.createElement("link");
    link.rel = isCss ? "stylesheet" : scriptRel;
    if (!isCss) {
      link.as = "script";
      link.crossOrigin = "";
    }
    link.href = dep;
    document.head.appendChild(link);
    if (isCss) {
      return new Promise((res, rej) => {
        link.addEventListener("load", res);
        link.addEventListener("error", () => rej(new Error(`Unable to preload CSS for ${dep}`)));
      });
    }
  })).then(() => baseModule()).catch((err) => {
    const e = new Event("vite:preloadError", { cancelable: true });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  });
};
class MediaLightbox {
  constructor(container) {
    this.container = container;
    this.cssLoaded = false;
    this.loading = false;
  }
  async showLightbox({ mediaId = null, init = true } = {}) {
    if (this.loading)
      return;
    this.loading = true;
    const promises = [];
    promises.push(__vitePreload(() => import("./photoswipe.esm.mjs"), true ? [] : void 0));
    if (!this.cssLoaded) {
      promises.push(this.loadCss());
    }
    const PhotoSwipe = (await Promise.all(promises))[0].default;
    this.loading = false;
    this.cssLoaded = true;
    const dataSource = [...this.container.querySelectorAll("[data-media-type=image], [data-media-type=lookbook]")].map(
      (el) => ({
        src: el.querySelector("img").src,
        alt: el.querySelector("img").alt,
        width: el.dataset.mediaWidth,
        height: el.dataset.mediaHeight,
        mediaId: el.dataset.mediaId,
        lookbookHandle: el.dataset.lookbookHandle || "",
        lookbookNumber: el.dataset.lookbookNumber || ""
      })
    );
    const pswp = new PhotoSwipe({
      bgOpacity: 1,
      mainClass: "pswp--custom-bg",
      dataSource,
      index: dataSource.findIndex((x) => x.mediaId === mediaId) ?? 0,
      returnFocus: false,
      arrowPrevSVG: window.svgs.chevron,
      arrowNextSVG: window.svgs.chevron,
      closeSVG: window.svgs.times,
      zoomSVG: window.svgs.zoom_in
    });
    if (dataSource.some((item) => item.lookbookHandle)) {
      pswp.on("uiRegister", () => {
        pswp.ui.registerElement({
          name: "lookbookCta",
          className: "pswp__lookbook-cta",
          title: "See this look",
          ariaLabel: "See this look",
          order: 9,
          isButton: true,
          appendTo: "wrapper",
          html: "SEE THIS LOOK",
          onInit: (element, instance) => {
            const update = () => {
              const data = instance.currSlide == null ? void 0 : instance.currSlide.data;
              const visible = Boolean(data == null ? void 0 : data.lookbookHandle);
              element.hidden = !visible;
              element.setAttribute("aria-hidden", String(!visible));
              if (visible) {
                element.setAttribute("aria-label", `See look ${data.lookbookNumber || ""}`.trim());
              }
            };
            instance.on("change", update);
            update();
          },
          onClick: (event, _element, instance) => {
            const data = instance.currSlide == null ? void 0 : instance.currSlide.data;
            if (!(data == null ? void 0 : data.lookbookHandle))
              return;
            const trigger = this.container.querySelector(
              `[data-media-id="${data.mediaId}"] [data-lbk-open]`
            );
            if (!trigger)
              return;
            event.preventDefault();
            event.stopPropagation();
            let opened = false;
            const openLook = () => {
              if (opened)
                return;
              opened = true;
              trigger.click();
            };
            instance.on("destroy", openLook);
            instance.close();
            setTimeout(openLook, 500);
          }
        });
      });
    }
    pswp.addFilter("thumbEl", (thumbEl, data) => {
      const el = this.container.querySelector(`[data-media-id="${data.mediaId}"] img`);
      return el ?? thumbEl;
    });
    pswp.addFilter("thumbBounds", (_, data) => {
      const wrapper = this.container.querySelector(`[data-media-id="${data.mediaId}"]`);
      const bounds = wrapper.getBoundingClientRect();
      return this.calculateThumbBounds(data, bounds);
    });
    pswp.addFilter("placeholderSrc", (placeholderSrc, slide) => {
      const el = this.container.querySelector(`[data-media-id="${slide.data.mediaId}"] img`);
      return el ? el.currentSrc : placeholderSrc;
    });
    init && pswp.init();
    return pswp;
  }
  calculateThumbBounds(data, bounds) {
    const realWidth = parseInt(data.width, 10);
    const realHeight = parseInt(data.height, 10);
    const wrapperRatio = bounds.width / bounds.height;
    const realRatio = realWidth / realHeight;
    let imgWidth, imgHeight;
    if (realRatio > wrapperRatio) {
      imgWidth = bounds.width;
      imgHeight = bounds.width / realRatio;
    } else {
      imgHeight = bounds.height;
      imgWidth = bounds.height * realRatio;
    }
    const x = bounds.x + (bounds.width - imgWidth) / 2;
    const y = bounds.y + (bounds.height - imgHeight) / 2;
    const w = imgWidth;
    return { x, y, w };
  }
  async loadCss() {
    if (document.querySelector("[data-pswp-css]"))
      return;
    const { default: css } = await __vitePreload(() => import("./photoswipe.mjs"), true ? [] : void 0);
    document.head.insertAdjacentHTML("beforeend", `<style data-pswp-css>${css}</style>`);
  }
}
class MediaCarouselLightbox extends MediaLightbox {
  constructor(carousel) {
    super(carousel);
    carousel.querySelectorAll("[data-media-type=image], [data-media-type=lookbook]").forEach(
      (el) => el.addEventListener("click", (event) => {
        if (event.target.closest("[data-lbk-open]"))
          return;
        this.showLightbox();
      })
    );
  }
  async showLightbox() {
    const currentItem = this.container.items[this.container.currentIndex];
    try {
      const pswp = await super.showLightbox({ mediaId: currentItem.dataset.mediaId, init: false });
      if (!pswp) {
        return;
      }
      const carouselScrollBehavior = this.container.scrollBehavior;
      this.container.scrollBehavior = "instant";
      this.container.pauseMedia();
      pswp.on("change", () => {
        pubsubExports.publish(PRODUCT_GALLERY_INDICATOR_CHANGED, {
          mediaId: pswp.currSlide.data.mediaId,
          sectionId: this.container.sectionId
        });
      });
      pswp.on("close", () => {
        this.container.scrollBehavior = carouselScrollBehavior;
      });
      pswp.init();
      return pswp;
    } finally {
    }
  }
}
class MediaCarousel extends Carousel {
  constructor() {
    super();
    this.currentIndex = 0;
    this.subs = [];
    this.scrollBehavior = "auto";
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }
  connectedCallback() {
    this.scrollLeft = 0;
    super.connectedCallback();
    this.loader = this.querySelector("[data-media-carousel-loading-overlay]");
    this.quickAdd = this.closest(".quick-add-modal");
    if (this.lightboxEnabled) {
      this.lightbox = new MediaCarouselLightbox(this);
    }
    this.setupLoadListeners();
    this.updateMaxHeight();
    this.preloadNextMedia();
    this.updateItemOffsets();
    this.connectWithThumbnails();
    this.section.addEventListener("variant:change", this.handleVariantChange);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.subs.forEach((x) => pubsubExports.unsubscribe(x));
    this.section.removeEventListener("variant:change", this.handleVariantChange);
  }
  get lightboxEnabled() {
    return this.getAttribute("lightbox") !== "false";
  }
  get videoAutoplay() {
    return this.getAttribute("video-autoplay") === "true";
  }
  get section() {
    return this.closest(".shopify-section");
  }
  handleVariantChange(e) {
    var _a, _b;
    if ((_b = (_a = e.detail.variant) == null ? void 0 : _a.featured_media) == null ? void 0 : _b.id) {
      this.goToMediaId(e.detail.variant.featured_media.id);
    }
  }
  updateMaxHeight() {
    if (this.getAttribute("adaptive-height") !== null) {
      const maxHeight = Math.max(
        isBelow("lg") || this.quickAdd ? 0 : this.items[this.currentIndex].clientWidth,
        this.items[this.currentIndex].clientHeight
      );
      if (maxHeight > 0) {
        this.style.maxHeight = `${maxHeight}px`;
      }
    } else {
      this.style.maxHeight = null;
    }
  }
  updateItemOffsets() {
    this.itemOffsets = this.items.map((item) => item.parentElement.offsetLeft);
  }
  connectWithThumbnails() {
    this.subs.push(
      pubsubExports.subscribe(PRODUCT_GALLERY_INDICATOR_CHANGED, (_, data) => {
        if (data.sectionId !== this.sectionId)
          return;
        if ("index" in data) {
          this.updateCurrentIndex(data.index);
          this.syncScroll();
        } else if (data.mediaId) {
          this.goToMediaId(data.mediaId);
        }
      })
    );
  }
  calculateCurrentIndex() {
    const scrollLeft = this.scrollLeft;
    let closestIdx = 0;
    let closestDist = Math.abs(scrollLeft - this.itemOffsets[0]);
    for (let i = 1; i < this.itemOffsets.length; i++) {
      const currentOffset = this.itemOffsets[i];
      const currentDist = Math.abs(scrollLeft - currentOffset);
      if (currentDist < closestDist) {
        closestDist = currentDist;
        closestIdx = i;
      }
    }
    return closestIdx;
  }
  onScroll() {
    super.onScroll();
    if (this.userScroll) {
      this.updateCurrentIndex(this.calculateCurrentIndex());
    }
  }
  onScrollEnd() {
    super.onScrollEnd();
    if (!this.touching) {
      this.updateMaxHeight();
    }
  }
  onResize() {
    super.onResize();
    this.updateMaxHeight();
    this.updateItemOffsets();
  }
  goPrev() {
    this.updateCurrentIndex(this.currentIndex - 1);
    this.syncScroll();
  }
  goNext() {
    this.updateCurrentIndex(this.currentIndex + 1);
    this.syncScroll();
  }
  goToMediaId(id) {
    const index = this.items.findIndex((el) => el.dataset.mediaId == id);
    if (index === -1 || index === this.currentIndex)
      return;
    this.updateCurrentIndex(index);
    this.syncScroll();
  }
  updateCurrentIndex(n) {
    var _a, _b;
    const newIndex = this.loop ? mod(n, this.items.length) : Math.max(0, Math.min(this.items.length - 1, n));
    if (newIndex === this.currentIndex)
      return;
    this.pauseMedia();
    this.currentIndex = newIndex;
    this.preloadNextMedia();
    const curMedia = this.items[this.currentIndex];
    if (["video", "external_video"].includes(curMedia.dataset.mediaType) && this.videoAutoplay) {
      this.handleVideoAutoplay(curMedia);
    }
    if (curMedia.dataset.mediaType === "model") {
      const xrButton = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.querySelector("[data-shopify-xr]");
      if (xrButton) {
        xrButton.setAttribute("data-shopify-model3d-id", curMedia.dataset.mediaId);
        (_b = window.ShopifyXR) == null ? void 0 : _b.setupXRElements();
      }
    }
    pubsubExports.publish(PRODUCT_GALLERY_CHANGED, {
      index: this.currentIndex,
      mediaId: curMedia.dataset.mediaId,
      sectionId: this.sectionId
    });
  }
  handleVideoAutoplay(curMedia) {
    curMedia.play();
  }
  async syncScroll() {
    const index = this.currentIndex;
    const item = this.items[index];
    if (!item.dataset.loaded) {
      const img = item.querySelector("img");
      if (img && !img.complete) {
        this.setLoadingOverlay(true);
        const itemLoader = item.querySelector("[data-loader]");
        if (itemLoader)
          itemLoader.remove();
        const startTime = Date.now();
        await new Promise((resolve) => {
          img.addEventListener("load", () => resolve());
          img.setAttribute("loading", "eager");
        });
        const elapsed = Date.now() - startTime;
        if (elapsed < 133)
          await delay$1(133 - elapsed);
        if (index !== this.currentIndex) {
          return;
        }
        this.setLoadingOverlay(false);
      }
    } else {
      this.setLoadingOverlay(false);
    }
    this.triggerScroll(item.parentElement.offsetLeft);
  }
  setLoadingOverlay(visible) {
    this.loader.style.opacity = visible ? 1 : null;
  }
  pauseMedia() {
    this.querySelectorAll("video-player").forEach((el) => el.pause());
    this.querySelectorAll("product-model").forEach((model) => {
      if (model.modelViewerUI)
        model.modelViewerUI.pause();
    });
  }
  preloadNextMedia() {
    var _a, _b;
    (_b = (_a = this.items[this.currentIndex]) == null ? void 0 : _a.parentElement.nextElementSibling) == null ? void 0 : _b.querySelectorAll("img[loading=lazy]").forEach((el) => el.setAttribute("loading", "eager"));
  }
  setupLoadListeners() {
    this.items.filter((x) => !x.querySelector("img")).forEach((x) => x.dataset.loaded = true);
    this.querySelectorAll("img").forEach((img) => {
      const parentItem = img.closest(this.itemSelector);
      if (img.complete && parentItem) {
        parentItem.dataset.loaded = true;
      } else {
        img.addEventListener("load", () => {
          if (parentItem) {
            parentItem.dataset.loaded = true;
          }
        });
      }
    });
  }
}
customElements.define("media-carousel", MediaCarousel);
if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", class MediaGallery extends HTMLElement {
    constructor() {
      super();
    }
    setActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia)
        return;
      activeMedia.parentElement.prepend(activeMedia);
    }
  });
}
class MediaGrid extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }
  connectedCallback() {
    var _a;
    this.media = this.querySelectorAll("[data-media-position]");
    this.parentSection = this.closest(".shopify-section");
    (_a = this.parentSection) == null ? void 0 : _a.addEventListener("variant:change", this.handleVariantChange);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.parentSection) == null ? void 0 : _a.removeEventListener("variant:change", this.handleVariantChange);
  }
  handleVariantChange(e) {
    var _a;
    const currentMediaId = (_a = e.detail.variant.featured_media) == null ? void 0 : _a.id;
    if (!currentMediaId)
      return;
    const mediaArray = Array.from(this.media);
    const currentMediaIndex = mediaArray.findIndex((media) => media.dataset.mediaId == currentMediaId);
    if (currentMediaIndex > -1) {
      const currentMediaElement = mediaArray.splice(currentMediaIndex, 1)[0];
      mediaArray.sort((a, b) => parseFloat(a.dataset.mediaPosition) - parseFloat(b.dataset.mediaPosition));
      mediaArray.unshift(currentMediaElement);
      const gridContainer = this;
      mediaArray.forEach((media) => gridContainer.appendChild(media));
    }
  }
}
customElements.define("media-grid", MediaGrid);
class MediaLightboxElement extends HTMLElement {
  constructor() {
    super();
    this.lightbox = new MediaLightbox(this);
  }
  connectedCallback() {
    this.querySelectorAll("[data-media-type=image], [data-media-type=lookbook]").forEach(
      (el) => el.addEventListener("click", this.onImageClick.bind(this))
    );
  }
  onImageClick(e) {
    if (e.target.closest("[data-lbk-open]"))
      return;
    this.lightbox.showLightbox({ mediaId: e.currentTarget.dataset.mediaId });
  }
}
customElements.define("media-lightbox", MediaLightboxElement);
window.activeMegaMenuHorizontal = null;
class MegaMenuHorizontal extends DropdownElement {
  constructor() {
    super();
    this.dynamicPosition = false;
    this.hoverShowDelay = null;
    this.hideDelay = 150;
  }
  connectedCallback() {
    super.connectedCallback();
    this.headerComponent = this.closest("sticky-header");
    this.inner = this.querySelector(".mega-menu-horizontal__inner");
    this.container = this.querySelector(".container");
  }
  onWindowClick(e) {
    if (e.target.closest("mega-menu-horizontal")) {
      return;
    }
    super.onWindowClick(e);
  }
  async show({ anim = true, trigger } = {}) {
    var _a;
    if (this.state !== "close")
      return;
    (_a = this.currentAnim) == null ? void 0 : _a.cancel();
    if (anim && window.activeMegaMenuHorizontal && !window.activeMegaMenuHorizontal.hoverDelay) {
      const active = window.activeMegaMenuHorizontal;
      window.activeMegaMenuHorizontal = this;
      await this.transitionWith(active);
      return;
    }
    window.activeMegaMenuHorizontal = this;
    if (anim && trigger === "hover") {
      this.hoverDelay = true;
      await delay$1(100);
      this.hoverDelay = false;
      if (window.activeMegaMenuHorizontal !== this) {
        return;
      }
      if (this.hideTimer) {
        if (window.activeMegaMenuHorizontal === this) {
          window.activeMegaMenuHorizontal = null;
        }
        return;
      }
    }
    this.adjustHeaderTransition();
    this.headerComponent.showOverlay();
    this.headerComponent.disableTransparent();
    lockScroll();
    await super.show(...arguments);
  }
  async transitionWith(active) {
    this.cancelHide();
    active.cancelHide();
    this.getAnimations({ subtree: true }).forEach((x) => x.cancel());
    active.getAnimations({ subtree: true }).forEach((x) => x.cancel());
    active.setState("open");
    const activeInnerHeight = active.inner.clientHeight;
    this.setState("open");
    const targetHeight = this.inner.clientHeight;
    this.setState("close");
    const fadeOut2 = active.container.animate({ opacity: [1, 0] }, { duration: 120 });
    active.container.style.opacity = "0";
    if (activeInnerHeight != targetHeight) {
      active.inner.style.overflow = "hidden";
      await active.inner.animate(
        { height: [`${activeInnerHeight}px`, `${targetHeight}px`] },
        { duration: 200, easing: EaseOut }
      ).finished;
      active.inner.style.overflow = null;
    } else {
      await fadeOut2.finished;
    }
    active.setState("close");
    active.container.style.opacity = null;
    this.setState("open");
    await this.container.animate({ opacity: [0, 1] }, { duration: 120 }).finished;
  }
  async hide() {
    var _a;
    if (this.state !== "open")
      return;
    (_a = this.currentAnim) == null ? void 0 : _a.cancel();
    if (window.activeMegaMenuHorizontal === this) {
      window.activeMegaMenuHorizontal = null;
    }
    this.adjustHeaderTransition();
    this.headerComponent.enableTransparent();
    await super.hide();
    if (!window.activeMegaMenuHorizontal) {
      this.headerComponent.hideOverlay();
      if (window.activeModals.length === 0 || !window.activeModals[window.activeModals.length - 1].useLockScroll) {
        unlockScroll();
      }
    }
  }
  runShowAnimation() {
    return animate(this.inner, "fade-in", { duration: 200, easing: EaseOut, y: "-1rem" });
  }
  runHideAnimation() {
    return animate(this.inner, "fade-out", { duration: 150, easing: EaseInOut, y: "-1rem" });
  }
  adjustHeaderTransition() {
    if (this.adjustHeaderTransitionTimeout) {
      clearTimeout(this.adjustHeaderTransitionTimeout);
    }
    const headerElement = this.headerComponent.querySelector(".header");
    Object.assign(headerElement.style, {
      transitionDuration: "140ms",
      transitionProperty: "background-color, color"
    });
    this.adjustHeaderTransitionTimeout = setTimeout(() => {
      Object.assign(headerElement.style, { transitionDuration: null, transitionProperty: null });
      this.adjustHeaderTransitionTimeout = null;
    }, 300);
  }
  // onSummaryClick() {
  //   if (this.interactionHandlerType === "hover") {
  //     return;
  //   }
  //   super.onSummaryClick(...arguments);
  // }
}
customElements.define("mega-menu-horizontal", MegaMenuHorizontal);
class Hamburger extends HTMLButtonElement {
  constructor() {
    super();
    this.active = false;
    this.addEventListener("click", () => {
      this.active = !this.active;
      this.update();
    });
  }
  connectedCallback() {
    this.mobileMenu = document.querySelector("[data-mobile-menu]");
    this.mobileMenu.addEventListener("hide", () => this.active = false);
  }
  update() {
    if (this.mobileMenu) {
      if (this.active) {
        this.mobileMenu.show();
      } else {
        this.mobileMenu.hide();
      }
    }
  }
}
customElements.define("menu-hamburger", Hamburger, { extends: "button" });
class MiniGallery extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }
  connectedCallback() {
    var _a;
    this.media = [...this.querySelectorAll("[data-media-id]")];
    this.parentSection = this.closest(".shopify-section");
    (_a = this.parentSection) == null ? void 0 : _a.addEventListener("variant:change", this.handleVariantChange);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.parentSection) == null ? void 0 : _a.removeEventListener("variant:change", this.handleVariantChange);
  }
  handleVariantChange(e) {
    var _a;
    if (!e.detail.variant) {
      return;
    }
    const currentMediaId = (_a = e.detail.variant.featured_media) == null ? void 0 : _a.id;
    this.media.forEach(
      (item) => item.classList.toggle("hidden", item.dataset.mediaId != currentMediaId)
    );
    if (this.media.every((item) => item.classList.contains("hidden"))) {
      this.media[0].classList.remove("hidden");
    }
  }
}
customElements.define("mini-gallery", MiniGallery);
class MobileMenuPage extends HTMLElement {
  constructor() {
    super();
    this.open = false;
    const shadow = this.attachShadow({ mode: "open" });
    shadow.appendChild(
      document.querySelector("#cb-template-mobile-menu-page").content.cloneNode(true)
    );
    // CB add flags for adding events to elements
    this.activatorsEventAdded = false;
    this.hideEventAdded = false;
    // CB end add flags for adding events to elements
  }
  connectedCallback() {
    this.setupElements(this.shadowRoot);
    this.setupEventListeners();
  }
  setupElements(shadow) {
    this.content = shadow.querySelector(".content");
    this.wrapper = shadow.querySelector(".wrapper");
    this.backButton = this.querySelector(".back-button");
    this.activator = shadow.querySelector("slot[name=activator]");
  }
  
  setupEventListeners() {
    if (this.activatorsEventAdded === false){
      this.activatorsEventAdded = true;
      this.activator.addEventListener("click", (e) => this.onActivatorClick(e));
    }
    if (this.hideEventAdded === false){
      this.hideEventAdded = true;
      this.backButton.addEventListener("click", this.hide.bind(this));
    }
    this.backButton.addEventListener('click', () =>  document.querySelector('.cb-menu-btn.cb-active-menu-btn')?.classList.remove('cb-active-menu-btn'));
  }
  // CB end change setupEventListeners() method
  onActivatorClick(e) {
    e.preventDefault();
    this.show();
  }
  getAnimInElements() {
    return this.querySelectorAll(
      "[data-menu-anim-in]:not(:scope [data-menu-anim-in] [data-menu-anim-in])"
    );
  }
  async show() {
    if (this.open)
      return;
    // CB code for hide all submenus when clicked on memu icons
    
    const parentMenu = this.closest('.mobile-menu');
    parentMenu.classList.add('active');
    document.querySelector('.cb-menu-btn.cb-active-menu-btn')?.classList.remove('cb-active-menu-btn');
    this.querySelector('.cb-menu-btn').classList.add('cb-active-menu-btn');
    if (parentMenu) {
      const allMenuPages = parentMenu.querySelectorAll('mobile-menu-page');
      for (const menuPage of allMenuPages) {
        if (menuPage !== this && menuPage.open) {
          await menuPage.hide({ anim: false });
        }
      }
    }
    // CB end code for hide all submenus when clicked on memu icons
    this.open = true;
    this.wrapper.style.display = null;
    this.wrapper.style.transform = "translateX(100%)";
    this.getAnimInElements().forEach(
      (el, i) => animate(el, "fade-in", { delay: i * 60 + 120, fill: "backwards" })
    );
    const parent = this.closest(".mobile-menu-content");
    const keyframes = [
      { transform: ["none", "translateX(-100%)"] },
      {
        duration: 251,
        easing: "ease"
      }
    ];
    await parent.animate(...keyframes).finished.catch(() => {
    });
    this.wrapper.style.transform = null;
  }
  async hide({ anim = true } = {}) {
    if (!this.open)
      return;
    event?.target.closest(".back-button") ? this.closest('.mobile-menu').classList.remove('active') : null;
    this.open = false;
    if (anim) {
      this.wrapper.style.transform = "translateX(100%)";
      const parent = this.closest(".mobile-menu-content");
      const keyframes = [
        { transform: ["translateX(-100%)", "none"] },
        {
          duration: 250,
          easing: "ease"
        }
      ];
      await parent.animate(...keyframes).finished.catch(() => {
      });
    }
    this.wrapper.style.display = "none";
  }
  hideMenu() {
    this.closest("[data-mobile-menu]").hide();
    this.closest('.mobile-menu').classList.remove('active');
  }
  isRootPage() {
    return !this.parentElement.closest("mobile-menu-page");
  }
}
customElements.define("mobile-menu-page", MobileMenuPage);
class MobileMenu extends ModalDrawer {
  afterHide() {
    super.afterHide();
    this.querySelectorAll("mobile-menu-page").forEach((el) => el.hide({ anim: false }));
  }
  getAnimInElements() {
    return this.querySelectorAll(
      "[data-menu-anim-in]:not(:scope [data-menu-anim-in] [data-menu-anim-in])"
    );
  }
  async show() {
    if (this.open)
      return;
    const inner = this.querySelector(".mobile-menu-inner");
    inner.classList.add("anim-in");
    const animations = [];
    this.getAnimInElements().forEach(
      (el, i) => animations.push(animate(el, "fade-in", { delay: i * 60 + 70, fill: "backwards" }))
    );
    Promise.all(animations.map((x) => x.finished)).finally(() => inner.classList.remove("anim-in"));
    await super.show(...arguments);
  }
}
customElements.define("mobile-menu", MobileMenu);
class ModalTrigger extends HTMLElement {
  connectedCallback() {
    this.activator = this.children[0];
    this.activator.addEventListener("click", this.onClickHandler.bind(this));
  }
  onClickHandler(e) {
    if (this.getAttribute("enabled") === "false")
      return;
    const target = this.getTarget();
    if (target && target.show) {
      e.preventDefault();
      target.setActivatorElement(this.activator);
      target.show();
    }
  }
  getTarget() {
    return document.querySelector(this.getAttribute("target"));
  }
}
customElements.define("modal-trigger", ModalTrigger);
const KEY_DISMISSED = "essence:newsletter-popup-dismissed";
const KEY_SUBSCRIBED = "essence:newsletter-subscribed";
class NewsletterModal extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (this.getAttribute("overlay") === "false") {
      this.useFocusTrap = false;
      this.useLockScroll = false;
      this.useOverlay = false;
    }
    if (this.getAttribute("test-mode") === "true" && !window.Shopify.designMode) {
      this.show();
      return;
    }
    if (window.location.pathname === "/challenge") {
      return;
    }
    if (window.Shopify.designMode) {
      this.initDesignMode();
      return;
    }
    if (this.content.querySelector(".message-success, .message-error")) {
      this.show();
    } else if (!this.isSubscribed()) {
      const timestamp = localStorage.getItem(KEY_DISMISSED);
      if (!timestamp || this.isTimestampExpired(timestamp)) {
        this.preloadImages();
        setTimeout(() => this.show(), this.showDelay);
      }
    }
  }
  isTimestampExpired(timestamp) {
    const daysSinceLastShown = ((/* @__PURE__ */ new Date()).getTime() - timestamp) / (1e3 * 60 * 60 * 24);
    return daysSinceLastShown >= this.frequency;
  }
  isSubscribed() {
    return localStorage.getItem(KEY_SUBSCRIBED);
  }
  async show() {
    await super.show(...arguments);
  }
  afterHide() {
    localStorage.setItem(KEY_DISMISSED, (/* @__PURE__ */ new Date()).getTime());
    return super.afterHide(...arguments);
  }
  preloadImages() {
    this.querySelectorAll("img[loading=lazy]").forEach((x) => x.setAttribute("loading", "eager"));
  }
  get showDelay() {
    return Number(this.getAttribute("show-delay") ?? 5e3);
  }
  get frequency() {
    return Number(this.getAttribute("frequency") ?? 30);
  }
}
customElements.define("newsletter-modal", NewsletterModal);
class NotificationWrapper extends HTMLElement {
  constructor() {
    super();
    this.currentToken = null;
  }
  connectedCallback() {
    this.notification = this.firstElementChild;
  }
  async showNotification({ text, type = null, time = 4e3 }) {
    const token = Symbol();
    this.currentToken = token;
    switch (type) {
      case "danger":
        this.notification.innerHTML = `<div class="message-danger text-danger">${text}</div>`;
        break;
      default:
        this.notification.textContent = text;
        break;
    }
    this.style.display = null;
    const showAnimation = this.animate(
      { transform: ["translateY(150%)", "none"] },
      { duration: 250, easing: EaseOut }
    );
    await showAnimation.finished;
    if (this.currentToken !== token) {
      return;
    }
    await delay$1(time);
    if (this.currentToken !== token) {
      return;
    }
    const hideAnimation = this.animate(
      { transform: ["none", "translateY(150%)"] },
      { duration: 250, easing: EaseIn }
    );
    await hideAnimation.finished;
    if (this.currentToken !== token) {
      return;
    }
    this.style.display = "none";
  }
}
customElements.define("notification-wrapper", NotificationWrapper);
function setButtonLoading(button, loading) {
  const spinner = `<svg
      aria-hidden="true"
      focusable="false"
      class="spinner"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
  `;
  if (loading && !button.dataset.loading) {
    for (const child of button.children) {
      child.style.opacity = "0";
    }
    button.style.color = "transparent";
    button.insertAdjacentHTML("beforeend", spinner);
    button.classList.add("pointer-events-none");
    button.dataset.loading = true;
    button.setAttribute("aria-loading", true);
  } else if (!loading && button.dataset.loading) {
    const spinnerElement = button.querySelector(".spinner");
    spinnerElement == null ? void 0 : spinnerElement.remove();
    button.classList.remove("pointer-events-none");
    button.style.color = null;
    for (const child of button.children) {
      child.style.opacity = null;
    }
    delete button.dataset.loading;
    button.removeAttribute("aria-loading");
  }
}
function setupFormButtonLoading() {
  document.addEventListener("submit", (e) => {
    if ("formButtonLoading" in e.target.dataset) {
      const submitButton = e.target.querySelector('button[type="submit"], input[type="submit"]');
      if (submitButton) {
        setButtonLoading(submitButton, true);
      }
    }
  });
}
class OrderNoteDrawer extends ModalDrawer {
  connectedCallback() {
    super.connectedCallback();
    this.submitButton = this.content.querySelector("[type=submit]");
    this.content.addEventListener("submit", this.onSubmit.bind(this));
  }
  async onSubmit(e) {
    e.preventDefault();
    setButtonLoading(this.submitButton, true);
    e.target.querySelector(".message-danger").classList.add("hidden");
    const data = Object.fromEntries([...new FormData(e.target)]);
    const resp = await fetch(window.routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify(data)
    });
    setButtonLoading(this.submitButton, false);
    if (!resp.ok) {
      e.target.querySelector(".message-danger").classList.remove("hidden");
    } else {
      this.hide();
      this.dispatchEvent(new CustomEvent("order-note:updated", { detail: data, bubbles: true }));
    }
  }
}
customElements.define("order-note-drawer", OrderNoteDrawer);
class SectionDynamicLinks extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.parentSection = this.closest(".shopify-section");
    this.querySelectorAll("a").forEach(
      (el) => el.addEventListener("click", this.onLinkClicked.bind(this))
    );
  }
  async onLinkClicked(e) {
    e.preventDefault();
    this.updateActive(e);
    const url = e.currentTarget.href;
    this.parentSection.classList.add("loading");
    await reloadSection(this.parentSection, { url });
    void this.parentSection.offsetTop;
    this.parentSection.classList.remove("loading");
    history.replaceState({}, "", url);
  }
  updateActive(e) {
    var _a;
    (_a = e.currentTarget.parentElement.querySelector(".active")) == null ? void 0 : _a.classList.remove("active");
    e.currentTarget.classList.add("active");
  }
}
customElements.define("section-dynamic-links", SectionDynamicLinks);
class PaginationDynamic extends SectionDynamicLinks {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.paginationEl = this.querySelector(".pagination");
    this.headerSection = document.querySelector(".section-site-header");
  }
  async onLinkClicked(e) {
    const curActive = this.paginationEl.querySelector(".active");
    const followingActive = curActive.compareDocumentPosition(e.currentTarget) & Node.DOCUMENT_POSITION_FOLLOWING;
    await super.onLinkClicked(e);
    const scrollToTargetSelector = this.getAttribute("scroll-to-target");
    if (scrollToTargetSelector && followingActive) {
      const scrollToTarget = document.querySelector(scrollToTargetSelector);
      if (scrollToTarget && scrollToTarget.getBoundingClientRect().top < 0) {
        window.scrollTo({
          top: window.scrollY + scrollToTarget.getBoundingClientRect().top - this.headerSection.clientHeight - 64,
          behavior: "smooth"
        });
      }
    }
  }
  updateActive(e) {
    const curActive = this.paginationEl.querySelector(".active");
    curActive == null ? void 0 : curActive.classList.remove("active");
    if (e.currentTarget.classList.contains("pagination-prev")) {
      curActive.previousElementSibling.classList.add("active");
    } else if (e.currentTarget.classList.contains("pagination-next")) {
      curActive.nextElementSibling.classList.add("active");
    } else {
      e.currentTarget.parentElement.classList.add("active");
    }
  }
}
customElements.define("pagination-dynamic", PaginationDynamic);
class PaginationLoadMore extends HTMLElement {
  connectedCallback() {
    this.loadMoreButton = this.querySelector(".button");
    this.messageError = this.querySelector(".message-danger");
    this.loadMoreButton.addEventListener("click", this.onLoadMoreClick.bind(this));
  }
  async onLoadMoreClick(e) {
    e.preventDefault();
    this.messageError.textContent = "";
    setButtonLoading(this.loadMoreButton, true);
    const currentSection = this.closest(".shopify-section");
    const currentSectionId = currentSection.id;
    const currentItems = currentSection.querySelectorAll("[data-container-load-more] > *");
    try {
      const scrollTopBefore = scrollTop();
      await reloadSection(this.closest(".shopify-section"), { url: this.loadMoreButton.href });
      document.getElementById(currentSectionId).querySelector("[data-container-load-more]").prepend(...Array.from(currentItems));
      if (scrollTop() !== scrollTopBefore) {
        window.scrollTo(0, scrollTopBefore);
      }
    } catch (err) {
      console.error(err);
      this.messageError.textContent = window._t.pagination.load_more_error;
    } finally {
      setButtonLoading(this.loadMoreButton, false);
    }
  }
}
customElements.define("pagination-load-more", PaginationLoadMore);
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeMin = this.querySelector("[data-range-min]");
    this.rangeMax = this.querySelector("[data-range-max]");
    this.rangeGroup = this.querySelector(".range-group");
    this.inputMin = this.querySelector("[data-input-min]");
    this.inputMax = this.querySelector("[data-input-max]");
    this.rangeMin.addEventListener("input", this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener("input", this.onRangeMaxInput.bind(this));
    this.inputMin.addEventListener("change", this.onInputMinChange.bind(this));
    this.inputMax.addEventListener("change", this.onInputMaxChange.bind(this));
    this.updateRangeBackground();
  }
  onRangeMinInput(e) {
    e.target.value = Math.min(e.target.value, Number(this.rangeMax.value) - 1);
    this.updateRangeBackground();
    this.inputMin.value = e.target.value;
  }
  onRangeMaxInput(e) {
    e.target.value = Math.max(e.target.value, Number(this.rangeMin.value) + 1);
    this.updateRangeBackground();
    this.inputMax.value = e.target.value;
  }
  onInputMinChange(e) {
    if (e.target.value && Number(e.target.value) >= Number(this.inputMax.value || this.inputMax.max)) {
      e.target.value = Number(this.inputMax.value || this.inputMax.max) - 1;
    }
    this.rangeMin.value = e.target.value || this.rangeMin.min;
    this.updateRangeBackground();
  }
  onInputMaxChange(e) {
    if (e.target.value && Number(e.target.value) <= Number(this.inputMin.value || this.inputMin.min)) {
      e.target.value = Number(this.inputMin.value || this.inputMin.min) + 1;
    }
    this.rangeMax.value = e.target.value || this.rangeMax.max;
    this.updateRangeBackground();
  }
  getRangePercentage(range) {
    return (range.value - range.min) / (range.max - range.min) * 100;
  }
  updateRangeBackground() {
    this.rangeGroup.style.setProperty(
      "--range-min",
      this.getRangePercentage(this.rangeMin) + "%"
    );
    this.rangeGroup.style.setProperty(
      "--range-max",
      this.getRangePercentage(this.rangeMax) + "%"
    );
  }
}
customElements.define("price-range", PriceRange);
class PrivacyBanner extends Modal {
  constructor() {
    super();
    this.useFocusTrap = false;
    this.useLockScroll = false;
    this.useOverlay = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.buttonAccept = this.querySelector(".button-accept");
    this.buttonDecline = this.querySelector(".button-decline");
    if (window.Shopify.designMode) {
      this.initDesignMode();
    } else {
      this.buttonAccept.addEventListener("click", () => this.handleAccept());
      this.buttonDecline.addEventListener("click", () => this.handleDecline());
      this.loadShopifyFeatures();
    }
  }
  loadShopifyFeatures() {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1"
        }
      ],
      (error) => {
        if (error) {
          throw error;
        } else {
          this.api = window.Shopify.customerPrivacy;
          this.checkForBanner();
        }
      }
    );
  }
  async checkForBanner() {
    const consent = this.api.currentVisitorConsent();
    if (this.api.shouldShowBanner() && (consent.marketing === "" || consent.analytics === "" || consent.preferences === "")) {
      await delay$1(1500);
      if (document.getElementById("shopify-pc__banner")) {
        return;
      }
      this.show();
    }
  }
  handleAccept() {
    setButtonLoading(this.buttonAccept, true);
    this.api.setTrackingConsent(
      {
        analytics: true,
        marketing: true,
        preferences: true
      },
      () => {
        this.hide();
        setButtonLoading(this.buttonAccept, false);
      }
    );
  }
  handleDecline() {
    setButtonLoading(this.buttonDecline, true);
    this.api.setTrackingConsent(
      {
        analytics: false,
        marketing: false,
        preferences: false
      },
      () => {
        this.hide();
        setButtonLoading(this.buttonDecline, false);
      }
    );
  }
}
customElements.define("privacy-banner", PrivacyBanner);
class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();
    this.currentToken = null;
    this.loadedImages = /* @__PURE__ */ new Map();
    this.preloadedTemplates = /* @__PURE__ */ new Set();
  }
  connectedCallback() {
    this.target = this.closest(".product-card");
    this.addEventListener("change", (e) => {
      if (e.target.type === "radio") {
        this.changeProductImage(e.target);
      }
    });
    this.querySelectorAll("input[type=radio] + label").forEach(
      (el) => el.addEventListener("mouseover", (e) => {
        if ("ontouchstart" in window)
          return;
        const associatedInput = document.getElementById(e.currentTarget.htmlFor);
        this.preloadTemplate(associatedInput.parentNode.querySelector("template"));
      })
    );
  }
  changeProductImage(target) {
    var _a, _b;
    if (target.dataset.url) {
      this.updateCardHref(target);
    }
    const template = target.parentNode.querySelector("template");
    if (!template)
      return;
    const token = Symbol();
    this.currentToken = token;
    const productImage = this.target.querySelector(".product-card__image");
    if (productImage && this.loadedImages.has(template.id)) {
      productImage.replaceWith(this.loadedImages.get(template.id));
      return;
    }
    const newImage = (_a = template.content.querySelector("img")) == null ? void 0 : _a.cloneNode(true);
    if (!newImage)
      return;
    this.target.classList.add("product-card--media-loading");
    productImage.replaceWith(newImage);
    (_b = this.target.querySelector(".product-card__second-image")) == null ? void 0 : _b.remove();
    newImage.addEventListener("load", () => {
      this.loadedImages.set(template.id, newImage);
      if (token === this.currentToken) {
        this.target.classList.remove("product-card--media-loading");
      }
    });
  }
  async preloadTemplate(template) {
    if (!template)
      return;
    if (this.preloadedTemplates.has(template.id))
      return;
    const image = template.content.querySelector("img");
    if (!image)
      return;
    preloadImage(image);
    this.preloadedTemplates.add(template.id);
  }
  updateCardHref(input) {
    this.target.querySelectorAll("a:not([data-size-link])").forEach((a) => a.href = input.dataset.url);
  }
}
customElements.define("product-card-swatches", ProductCardSwatches);
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
  }
  connectedCallback() {
    this.quickAddModal = this.closest("#quick-add-modal");
  }
  async onSubmitHandler(e) {
    e.preventDefault();
    if (!e.target.reportValidity())
      return;
    const variantId = this.querySelector("[name=id]").value;
    this.setErrorMessage();
    setButtonLoading(this.submitButton, true);
    const formData = new FormData(this.form);
    // CB add swap trouser add to cart logic
    const trouserSwapVariantId = document.querySelector('[data-trouser-selector] input')?.getAttribute('data-variant-id');
    if (trouserSwapVariantId && trouserSwapVariantId != 0){
      const formProductId =  formData.get('product-id');
      formData.delete('id');
      formData.delete('product-id');;
      formData.append('items[0][id]', trouserSwapVariantId);
      formData.append('items[1][product-id]', formProductId)
      formData.append('items[1][id]', variantId)
    }
    // CB end add swap trouser add to cart logic
    // CB add  bundle start
    const bundles = document.querySelector('.cb-bundles');
    if (bundles) {
      const formProductId =  formData.get('product-id');
      formData.delete('id');
      formData.delete('product-id');
      document.querySelectorAll('.cb-bundle:has(.cb-input:checked) variant-picker input').forEach((input, index) => {
        formData.append(`items[${index}][id]`, input.dataset.variantId);
      });
    }
    // CB add  bundle end
    const sections = ["cart-bubble"];
    if (window.addedToCartNotification !== "drawer" || this.quickAddModal) {
      sections.push("variant-added");
    }
    formData.append("sections", sections);
    formData.append("sections_url", `${window.Shopify.routes.root}variants/${variantId}`);
    try {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig("form-data"),
        body: formData
      });
      const json = await response.json();
      if (json.status) {
        this.setErrorMessage(json.description);
        this.error = true;
        if (json.message.toLowerCase().includes('trouser swap')){
          showCartModal();
        }
        return;
      }
      document.dispatchEvent(
        new CustomEvent("product:added-to-cart", {
          detail: { id: variantId, quantity: formData.get("quantity") }
        })
      );
      json.sections["cart-bubble"] && updateCartBadge(json.sections["cart-bubble"].match(/\d+/));
      if (this.quickAddModal) {
        const mainCart = document.querySelector(".section-main-cart");
        if (mainCart) {
          reloadSection(mainCart);
        }
        if (!this.isCartModalOpen()) {
          await this.quickAddModal.showAddedToCartView({
            html: getSection(json.sections["variant-added"]).innerHTML,
            key: json.key
          });
        } else {
          this.quickAddModal.hide();
        }
      } else {
        if (window.addedToCartNotification === "drawer") {
          await showCartModal();
        } else {
          await showVariantAddedToCartModal({
            html: json.sections["variant-added"],
            key: json.key
          });
        }
      }
      this.error = false;
    } catch (error) {
      console.error(error);
    } finally {
      setButtonLoading(this.submitButton, false);
    }
  }
  setErrorMessage(errorText = false) {
    this.errorMessage = this.errorMessage || this.querySelector(".message-danger");
    if (!this.errorMessage)
      return;
    this.errorMessage.classList.toggle("hidden", !errorText);
    if (typeof errorText === "object") {
      this.errorMessage.replaceChildren(
        ...Object.values(errorText).map((x) => [document.createTextNode(x), document.createElement("br")]).flat().slice(0, -1)
      );
    } else {
      this.errorMessage.textContent = errorText ? errorText : "";
    }
    if (errorText) {
      scrollIntoViewIfNeeded(this.errorMessage);
    }
  }
  isCartModalOpen() {
    var _a;
    return (_a = document.querySelector("cart-modal")) == null ? void 0 : _a.open;
  }
}
customElements.define("product-form", ProductForm);
class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }
  loadContent() {
    super.loadContent();
    window.Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }
    ]);
  }
  setupModelViewerUI(errors) {
    if (errors)
      return;
    this.modelViewerUI = new window.Shopify.ModelViewerUI(this.querySelector("model-viewer"));
  }
}
customElements.define("product-model", ProductModel);
window.ProductModel = {
  loadShopifyXR() {
    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },
  setupShopifyXR(errors) {
    if (errors)
      return;
    if (!window.ShopifyXR) {
      document.addEventListener(
        "shopify_xr_initialized",
        () => this.setupShopifyXR()
      );
      return;
    }
    document.querySelectorAll('[id^="Product-JSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  }
};
window.addEventListener("DOMContentLoaded", () => {
  if (window.ProductModel)
    window.ProductModel.loadShopifyXR();
});
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.setupObserver();
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  setupObserver() {
    if (this.observer)
      this.observer.disconnect();
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: `0px 0px ${this.threshold} 0px`
    });
    this.observer.observe(this);
  }
  async handleIntersection([entry], observer) {
    var _a;
    if (!entry.isIntersecting)
      return;
    observer.unobserve(this);
    try {
      if ((_a = window.Shopify) == null ? void 0 : _a.designMode) {
        await delay$1(250);
      }
      const response = await fetch(this.getURL());
      const text = await response.text();
      this.replaceChildren(
        ...createElementFromHtml(text).querySelectorAll("product-recommendations > *")
      );
    } catch (e) {
      console.error(e);
    }
  }
  getURL() {
    const url = new URL(window.routes.product_recommendations_url, window.location.origin);
    url.searchParams.append("section_id", this.getAttribute("section-id"));
    url.searchParams.append("product_id", this.getAttribute("product-id"));
    url.searchParams.append("limit", this.getAttribute("limit"));
    url.searchParams.append("intent", this.getAttribute("intent"));
    return url;
  }
  get threshold() {
    return `${this.getAttribute("threshold") ?? 600}px`;
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class ProductSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
  }
}
customElements.define("product-section", ProductSection);
class ProductThumbnails extends HTMLElement {
  constructor() {
    super();
    this.subs = [];
  }
  connectedCallback() {
    var _a;
    this.sectionId = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    this.thumbs = Array.from(this.querySelectorAll("button"));
    this.thumbs.forEach((el) => el.addEventListener("click", this.onThumbnailClick.bind(this)));
    this.connectWithCarousel();
  }
  disconnectedCallback() {
    this.subs.forEach((x) => pubsubExports.unsubscribe(x));
  }
  connectWithCarousel() {
    this.carousel = document.querySelector("media-carousel");
    if (!this.carousel)
      return;
    this.subs.push(
      pubsubExports.subscribe(PRODUCT_GALLERY_CHANGED, (_, data) => {
        if (data.sectionId === this.sectionId) {
          this.updateActiveThumbnail(data.mediaId);
        }
      })
    );
  }
  onThumbnailClick(e) {
    this.updateActiveThumbnail(e.currentTarget.dataset.mediaId);
    pubsubExports.publish(PRODUCT_GALLERY_INDICATOR_CHANGED, {
      mediaId: e.currentTarget.dataset.mediaId,
      sectionId: this.sectionId
    });
  }
  updateActiveThumbnail(mediaId) {
    const activeEl = this.thumbs.find((el) => el.dataset.mediaId === mediaId);
    this.thumbs.forEach((el) => el.classList.remove("active"));
    activeEl.classList.add("active");
    this.dispatchEvent(
      new CustomEvent("carousel:update-active", {
        detail: { el: activeEl },
        bubbles: true
      })
    );
  }
}
customElements.define("product-thumbnails", ProductThumbnails);
class ProvinceSelector extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.countrySelect = this.querySelector("[data-country-select]");
    this.provinceSelect = this.querySelector("[data-province-select]");
    this.provinceWrapper = this.provinceSelect.parentElement;
    this.addEventListeners();
    this.populateProvinces();
  }
  addEventListeners() {
    this.countrySelect.addEventListener("change", () => {
      this.populateProvinces();
    });
  }
  populateProvinces() {
    const selectedCountry = this.countrySelect.options[this.countrySelect.selectedIndex];
    const provinces = JSON.parse(selectedCountry.getAttribute("data-provinces"));
    this.provinceSelect.innerHTML = "";
    if (provinces.length === 0) {
      this.provinceWrapper.classList.add("hidden");
    } else {
      provinces.forEach((province) => {
        const option = document.createElement("option");
        option.value = province[0];
        option.text = province[1];
        this.provinceSelect.add(option);
      });
      this.provinceWrapper.classList.remove("hidden");
    }
  }
}
customElements.define("province-selector", ProvinceSelector);
class QtySelector extends HTMLElement {
  connectedCallback() {
    this.decButton = this.querySelector("[data-dec]");
    this.incButton = this.querySelector("[data-inc]");
    this.input = this.querySelector(":scope > input");
    const changeEv = new Event("change", { bubbles: true });
    this.decButton.addEventListener("click", () => {
      this.input.stepDown();
      this.input.dispatchEvent(changeEv);
    });
    this.incButton.addEventListener("click", () => {
      this.input.stepUp();
      this.input.dispatchEvent(changeEv);
    });
    this.input.addEventListener("change", (e) => {
      if (this.input.value.trim() === "") {
        e.stopPropagation();
        this.input.value = "1";
        this.input.dispatchEvent(changeEv);
      }
    });
  }
}
customElements.define("qty-selector", QtySelector);
async function renderProductHtml(handle, variantId = null) {
  let url = `${window.Shopify.routes.root}products/${handle}`;
  if (variantId) {
    url += `?variant=${variantId}`;
  }
  return await (await fetch(url)).text();
}
function prepareQuickAddContent(productHtml) {
  const section = new DOMParser().parseFromString(productHtml, "text/html").querySelector(".section-main-product");
  const sectionId = getSectionId(section);
  section.innerHTML = section.innerHTML.replace(
    new RegExp(sectionId, "g"),
    "product-quick-add-modal"
  );
  const variantPicker = section.querySelector("variant-picker");
  if (variantPicker) {
    variantPicker.dataset.section = sectionId;
  }
  return section;
}
class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickHandler.bind(this));
  }
  get button() {
    return this.querySelector("button");
  }
  get inCartModal() {
    return this.closest("cart-modal");
  }
  get inProductCard() {
    return this.closest(".product-card");
  }
  async onClickHandler() {
    const variantId = this.getAttribute("variant-id");
    try {
      setButtonLoading(this.button, true);
      if (variantId) {
        const resp = await addToCart({ id: variantId, quantity: 1 });
        if (!resp) {
          return;
        }
        if (!this.inCartModal) {
          await showAddedToCartNotification({
            html: resp.sections["variant-added"],
            key: resp.key
          });
        }
      } else {
        const html = await renderProductHtml(
          this.getAttribute("handle"),
          this.getSelectedVariantId()
        );
        const infoEl = prepareQuickAddContent(html).querySelector(".product-info");
        showQuickAddModal(infoEl);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setButtonLoading(this.button, false);
    }
  }
  getSelectedVariantId() {
    var _a, _b;
    return (_b = (_a = this.inProductCard) == null ? void 0 : _a.querySelector("[data-variant-id]:checked")) == null ? void 0 : _b.getAttribute("data-variant-id");
  }
}
customElements.define("quick-add-button", QuickAddButton);
class QuickAddModal extends Modal {
  constructor() {
    super();
    this.productInfoContainer = this.querySelector(
      "[data-product-info-container]"
    );
    this.mediaContainer = this.querySelector("[data-media-container]");
  }
  get cartModal() {
    return document.querySelector("cart-modal");
  }
  connectedCallback() {
    super.connectedCallback();
    this.closeButton = this.querySelector("[data-button-close]");
  }
  setProductInfo(el) {
    var _a, _b;
    el.querySelectorAll(
      `.product-info-inner > *:not(
        .product-quick-add-header-template,
        .product-variant-picker,
        .product-stock-info,
        .product-buy-buttons
      )`
    ).forEach((el2) => el2.remove());
    const headerTemplate = el.querySelector(
      ".product-quick-add-header-template"
    );
    if (headerTemplate) {
      (_a = el.querySelector(".product-info-inner")) == null ? void 0 : _a.prepend(
        headerTemplate.content.firstElementChild.cloneNode(true)
      );
    }
    const carouselTemplate = el.querySelector("#quick-add-media");
    carouselTemplate.remove();
    this.mediaContainer.replaceChildren(...carouselTemplate.content.children);
    this.productInfoContainer.innerHTML = el.outerHTML;
    this.mediaContainer.style.display = null;
    this.content.style.display = null;
    this.panel.classList.remove("md:max-w-[640px]");
    (_b = window.Shopify) == null ? void 0 : _b.PaymentButton.init();
    const carousel = this.querySelector("media-carousel");
    if (carousel && !this.open) {
      this.panelWrapper.style.display = "flex";
      carousel.updateMaxHeight();
      this.panelWrapper.style.display = null;
    }
  }
  async showAddedToCartView({ html, key }) {
    var _a, _b;
    if (window.addedToCartNotification === "drawer") {
      await ((_a = this.cartModal) == null ? void 0 : _a.reloadContent());
      await this.hide();
      await ((_b = this.cartModal) == null ? void 0 : _b.show());
      return;
    }
    createElementFromHtml(html).querySelectorAll("img").forEach((img) => preloadImage(img));
    await animate(this.panel, "fade-out", {
      duration: 250,
      y: "1rem",
      easing: EaseIn
    }).finished;
    this.mediaContainer.style.display = "none";
    this.content.style.display = "block";
    this.productInfoContainer.innerHTML = `<div class="w-full">${html}</div>`;
    this.panel.classList.add("md:max-w-[640px]");
    if (key) {
      this.productInfoContainer.querySelectorAll(`[data-cart-key]:not([data-cart-key="${key}"])`).forEach((el) => el.remove());
    }
    await animate(this.panel, "fade-in", {
      duration: 250,
      delay: 70,
      fill: "backwards",
      y: window.matchMedia("(min-width: 768px)").matches ? "-1rem" : "1rem",
      easing: EaseOut
    }).finished;
  }
  afterHide() {
    super.afterHide();
    this.closeButton.style.opacity = null;
  }
}
customElements.define("quick-add-modal", QuickAddModal);
class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    if (this.getViewedProductIds().length === 0)
      return;
    this.setupObserver();
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  setupObserver() {
    if (this.observer)
      this.observer.disconnect();
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: `0px 0px ${this.threshold} 0px`
    });
    this.observer.observe(this);
  }
  async handleIntersection([entry], observer) {
    var _a;
    if (!entry.isIntersecting)
      return;
    observer.unobserve(this);
    try {
      if ((_a = window.Shopify) == null ? void 0 : _a.designMode) {
        await delay$1(250);
      }
      const response = await fetch(this.getURL());
      const text = await response.text();
      this.replaceChildren(
        ...createElementFromHtml(text).querySelectorAll("recently-viewed-products > *")
      );
    } catch (e) {
      console.error(e);
    }
  }
  getViewedProductIds() {
    const currentProductIds = new Set(this.getAttribute("product-id").split(","));
    return JSON.parse(localStorage.getItem("essence:recently-viewed-products") ?? "[]").filter(
      (x) => !currentProductIds.has(x.toString())
    );
  }
  getSearchQuery() {
    return this.getViewedProductIds().map((x) => `id:${x}`).join(" OR ");
  }
  getURL() {
    const url = new URL(window.routes.search_url, window.location.origin);
    url.searchParams.append("section_id", this.getAttribute("section-id"));
    url.searchParams.append("q", this.getSearchQuery());
    url.searchParams.append("type", "product");
    return url;
  }
  get threshold() {
    return `${this.getAttribute("threshold") ?? 600}px`;
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);
class RecipientForm extends HTMLElement {
  connectedCallback() {
    this.checkboxInput = this.querySelector(".recipient-form__input-checkbox");
    this.checkboxInput.disabled = false;
    this.hiddenControlField = this.querySelector(".recipient-form__input-hidden-control");
    this.hiddenControlField.disabled = true;
    this.offsetProperty = this.querySelector(".recipient-form__input-offset");
    if (this.offsetProperty)
      this.offsetProperty.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
    this.inputsWrapper = this.querySelector(".recipient-form__inputs");
    this.addEventListener("change", this.onChange.bind(this));
    this.onChange();
  }
  onChange() {
    if (this.checkboxInput.checked) {
      this.enableInputFields();
      this.showForm();
    } else {
      this.disableInputFields();
      this.hideForm();
    }
  }
  disableableFields() {
    return [...this.querySelectorAll(".input"), this.offsetProperty];
  }
  enableInputFields() {
    this.disableableFields().forEach((field) => field.disabled = false);
  }
  disableInputFields() {
    this.disableableFields().forEach((field) => field.disabled = true);
  }
  showForm() {
    this.inputsWrapper.style.display = "block";
  }
  hideForm() {
    this.inputsWrapper.style.display = null;
  }
}
customElements.define("recipient-form", RecipientForm);
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
const root$1 = root;
var Symbol$1 = root$1.Symbol;
const Symbol$2 = Symbol$1;
var objectProto$c = Object.prototype;
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
var nativeObjectToString$1 = objectProto$c.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$b = Object.prototype;
var nativeObjectToString = objectProto$b.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var symbolTag$1 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}
function arrayMap(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var isArray = Array.isArray;
const isArray$1 = isArray;
var INFINITY$2 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$1(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
function identity(value) {
  return value;
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$a = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var WeakMap = getNative(root$1, "WeakMap");
const WeakMap$1 = WeakMap;
function noop() {
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
}();
const defineProperty$1 = defineProperty;
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
var objectProto$9 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$9;
  return value === proto;
}
function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
var objectProto$8 = Object.prototype;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$7.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
const isArguments$1 = isArguments;
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer2 = moduleExports$1 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
const isBuffer$1 = isBuffer;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$5.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var nativeCreate = getNative(Object, "create");
const nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : void 0;
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$3.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$1, "Map");
const Map$2 = Map$1;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size2 = data.size;
  data.set(key, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
const stringToPath$1 = stringToPath;
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString(value));
}
var INFINITY$1 = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : void 0;
}
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
function arrayPush(array, values) {
  var index = -1, length = values.length, offset2 = array.length;
  while (++index < length) {
    array[offset2 + index] = values[index];
  }
  return array;
}
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function arrayFilter(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
const getSymbols$1 = getSymbols;
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}
var DataView = getNative(root$1, "DataView");
const DataView$1 = DataView;
var Promise$1 = getNative(root$1, "Promise");
const Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
const Set$2 = Set$1;
var mapTag$1 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$1 = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$1 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$1 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$1;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$1;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
var Uint8Array2 = root$1.Uint8Array;
const Uint8Array$1 = Uint8Array2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache, key) {
  return cache.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result = true, seen2 = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen2) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen2, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen2.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
function mapToArray(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
function setToArray(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + "";
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag$1(object), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$1.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length, length = index, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject(value);
}
function getMatchData(object) {
  var result = keys(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1, length = path.length, result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
}
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == "object") {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var baseFor = createBaseFor();
const baseFor$1 = baseFor;
function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
const baseEach$1 = baseEach;
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach$1(collection, function(value, key, collection2) {
    setter(accumulator, value, iteratee(value), collection2);
  });
  return accumulator;
}
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray$1(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}
function arrayIncludesWith(array, value, comparator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});
const groupBy$1 = groupBy;
var INFINITY = 1 / 0;
var createSet = !(Set$2 && 1 / setToArray(new Set$2([, -0]))[1] == INFINITY) ? noop : function(values) {
  return new Set$2(values);
};
const createSet$1 = createSet;
var LARGE_ARRAY_SIZE = 200;
function baseUniq(array, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen2 = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet$1(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen2 = new SetCache();
  } else {
    seen2 = iteratee ? [] : result;
  }
  outer:
    while (++index < length) {
      var value = array[index], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen2.length;
        while (seenIndex--) {
          if (seen2[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen2.push(computed);
        }
        result.push(value);
      } else if (!includes(seen2, computed, comparator)) {
        if (seen2 !== result) {
          seen2.push(computed);
        }
        result.push(value);
      }
    }
  return result;
}
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}
class ScrollAnimate extends HTMLElement {
  get threshold() {
    return Number(this.getAttribute("threshold") ?? 0);
  }
  get rootMargin() {
    return this.getAttribute("root-margin") ?? "0px";
  }
  get staggerDelay() {
    return Number(this.getAttribute("stagger-delay") ?? 83.33);
  }
  constructor() {
    super();
    this.animationTypes = {
      default: "scroll-slide-in",
      "fade-in": "fade-in"
    };
    this.init = this.init.bind(this);
  }
  connectedCallback() {
    if (!window.enableRevealOnScrollAnimations)
      return;
    this.mainObserver = new IntersectionObserver(this.handleEntries.bind(this), {
      threshold: this.threshold,
      rootMargin: this.rootMargin
    });
    this.initialLoadObserver = new IntersectionObserver(this.handleInitialLoad.bind(this), {
      threshold: 0
    });
    this.mutationObserver = new MutationObserver(this.handleMutations.bind(this));
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.init);
    } else {
      this.init();
    }
  }
  disconnnectedCallback() {
    this.initialLoadObserver.disconnect();
    this.mainObserver.disconnect();
    this.mutationObserver.disconnect();
    document.removeEventListener("DOMContentLoaded", this.init);
  }
  getTargetElements() {
    return [...this.querySelectorAll("[data-animation]")].filter(
      (x) => x.closest("scroll-animate") === this
    );
  }
  init() {
    this.getTargetElements().forEach((element) => {
      this.initialLoadObserver.observe(element);
    });
    this.mutationObserver.observe(this, { childList: true, subtree: true });
  }
  async handleEntries(entries) {
    const groups = /* @__PURE__ */ new Set();
    const lazyGroupEntries = entries.filter(
      (entry) => entry.isIntersecting && entry.target.dataset.animationGroupLazy !== void 0
    );
    entries = entries.filter((entry) => {
      if (!entry.isIntersecting || entry.target.dataset.animationGroupLazy !== void 0) {
        return false;
      }
      const group = entry.target.dataset.animationGroup;
      if (group && !groups.has(group)) {
        groups.add(group);
        return true;
      }
      return !group;
    });
    entries.forEach((entry) => this.animateElement(entry.target));
    if (lazyGroupEntries.length > 0) {
      Object.values(groupBy$1(lazyGroupEntries, (x) => x.target.dataset.animationGroup)).forEach(
        (group) => this.animateStagger(group.map((x) => x.target))
      );
    }
  }
  handleInitialLoad(entries) {
    this.handleEntries(entries);
    this.initialLoadObserver.disconnect();
    this.getTargetElements().forEach((element) => {
      this.mainObserver.observe(element);
    });
  }
  async animateElement(el) {
    if (el.dataset.animation === void 0 || el.dataset.animationPlaying)
      return;
    const animationGroup = el.dataset.animationGroup;
    const animation = this.getAnimationFromElement(el);
    if (animationGroup) {
      const groupElements = this.querySelectorAll(`[data-animation-group="${animationGroup}"]`);
      this.animateStagger(groupElements, animation);
    } else {
      el.dataset.animationPlaying = true;
      await animation(el, {
        delay: Number(el.dataset.animationDelay ?? 0),
        ...el.dataset.animationParams ? JSON.parse(el.dataset.animationParams) : {}
      }).finished;
      this.finishElement(el);
    }
  }
  getAnimationFromElement(el) {
    const animationType = el.dataset.animation || "default";
    const animationName = this.animationTypes[animationType] ?? "scroll-slide-in";
    const animation = getAnimationByName(animationName);
    return animation;
  }
  animateStagger(els) {
    var _a;
    let curStaggerDelay = 0;
    if ((_a = els[0]) == null ? void 0 : _a.closest("[data-animation-auto-order]")) {
      els = this.orderElementsForAnimation([...els]);
    }
    for (let el of els) {
      if (el.dataset.animationPlaying)
        return;
      el.dataset.animationPlaying = true;
      const animation = this.getAnimationFromElement(el);
      const params = el.dataset.animationParams ? JSON.parse(el.dataset.animationParams) : {};
      animation(el, { ...params, delay: (params.delay ?? 0) + curStaggerDelay }).finished.then(
        () => this.finishElement(el)
      );
      curStaggerDelay += this.staggerDelay;
    }
  }
  finishElement(el) {
    this.mainObserver.unobserve(el);
    delete el.dataset.animation;
    delete el.dataset.animationGroup;
    delete el.dataset.animationPlaying;
  }
  async handleMutations(mutations) {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            let elements = [...node.querySelectorAll("[data-animation]")];
            if (node.hasAttribute("data-animation")) {
              elements.push(node);
            }
            elements.filter((el) => el.closest("scroll-animate") === this).forEach((element) => {
              if (this.shouldAnimateAddedElement(element)) {
                this.mainObserver.observe(element);
              } else {
                this.finishElement(element);
              }
            });
          }
        });
      }
    });
  }
  shouldAnimateAddedElement(element) {
    return element.dataset.animationOnInitOnly === void 0;
  }
  orderElementsForAnimation(elements) {
    const distance = (x1, y1, x2, y2) => Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    const orderedElements = [];
    const animationParent = elements[0].closest("[data-animation-auto-order]");
    const parentRect = animationParent.getBoundingClientRect();
    elements = elements.map((el) => {
      const rect = el.getBoundingClientRect();
      return {
        el,
        rect,
        distance: distance(parentRect.left, parentRect.top, rect.left, rect.top)
      };
    });
    elements.sort((a, b) => a.distance - b.distance);
    orderedElements.push(elements[0]);
    while (elements.length > 1) {
      const currentEl = orderedElements[orderedElements.length - 1];
      elements = elements.slice(1).map((el) => ({
        ...el,
        distance: distance(currentEl.rect.left, currentEl.rect.top, el.rect.left, el.rect.top)
      }));
      elements.sort((a, b) => a.distance - b.distance);
      orderedElements.push(elements[0]);
    }
    return orderedElements.map((x) => x.el);
  }
}
customElements.define("scroll-animate", ScrollAnimate);
class ScrollCarousel extends Carousel {
  get rtl() {
    return getComputedStyle(this).direction === "rtl";
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("carousel:update-active", this.onCarouselUpdateActive.bind(this));
  }
  goPrev() {
    this.goItem(this.getPrevItemTarget());
  }
  goNext() {
    this.goItem(this.getNextItemTarget());
  }
  goItem(item) {
    this.triggerScroll(this.scrollAmount() + this.getDistance(item));
  }
  getDistance(item) {
    const a = item.getBoundingClientRect();
    const b = this.getBoundingClientRectWithoutPadding();
    return this.vertical ? a.top - b.top : this.rtl ? (b.right - a.right) * -1 : a.left - b.left;
  }
  getBoundingClientRectWithoutPadding() {
    const style = getComputedStyle(this);
    const rect = this.getBoundingClientRect().toJSON();
    const pLeft = parseFloat(style.paddingLeft);
    const pRight = parseFloat(style.paddingRight);
    const pTop = parseFloat(style.paddingTop);
    const pBottom = parseFloat(style.paddingBottom);
    return {
      left: rect.left + pLeft,
      right: rect.right - pRight,
      top: rect.top + pTop,
      bottom: rect.bottom - pBottom,
      width: rect.width - pLeft - pRight,
      height: rect.height - pTop - pBottom
    };
  }
  detectSpacing() {
    if (this.items.length < 2)
      return 0;
    const a = this.items[0].getBoundingClientRect();
    const b = this.items[1].getBoundingClientRect();
    return this.vertical ? Math.abs(b.top - a.bottom) : this.rtl ? Math.abs(b.right - a.left) : Math.abs(b.left - a.right);
  }
  getPrevItemTarget() {
    const view = this.getBoundingClientRectWithoutPadding();
    const spacing = this.detectSpacing();
    for (let item of this.items) {
      const rect = item.getBoundingClientRect();
      if (this.vertical) {
        if (rect.top + 1 >= view.top - view.height - spacing && rect.bottom + 1 >= view.top - view.height - spacing) {
          return item;
        }
      } else {
        if (!this.rtl && rect.left + 1 >= view.left - view.width - spacing && rect.right + 1 >= view.left - view.width - spacing) {
          return item;
        } else if (this.rtl && rect.right - 1 <= view.right + view.width + spacing && rect.left - 1 <= view.right + view.width + spacing) {
          return item;
        }
      }
    }
    return this.items[0];
  }
  getNextItemTarget() {
    const view = this.getBoundingClientRectWithoutPadding();
    for (let item of this.items) {
      const rect = item.getBoundingClientRect();
      if (this.vertical) {
        if (rect.top - 1 >= view.bottom || rect.bottom - 1 >= view.bottom) {
          return item;
        }
      } else {
        if (!this.rtl && (rect.left - 1 >= view.right || rect.right - 1 >= view.right)) {
          return item;
        } else if (this.rtl && (rect.right + 1 <= view.left || rect.left + 1 <= view.left)) {
          return item;
        }
      }
    }
    return this.items[this.items.length - 1];
  }
  onCarouselUpdateActive(e) {
    e.stopPropagation();
    const activeElementRect = e.detail.el.getBoundingClientRect();
    const carouselRect = this.getBoundingClientRectWithoutPadding();
    let isInside;
    const epsilon = 0.1;
    if (this.vertical) {
      isInside = activeElementRect.top + epsilon >= carouselRect.top && activeElementRect.bottom - epsilon <= carouselRect.bottom;
    } else {
      isInside = activeElementRect.left + epsilon >= carouselRect.left && activeElementRect.right - epsilon <= carouselRect.right;
    }
    if (!isInside) {
      this.goItem(e.detail.el);
    }
  }
}
customElements.define("scroll-carousel", ScrollCarousel);
class SearchModal extends ModalDrawer {
  constructor() {
    super();
    this.performSearchDebounced = debounce(this.performSearch.bind(this), 250);
    this.searchCache = /* @__PURE__ */ new Map();
    this.fadeOnMobile = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setupElements();
    this.setupListeners();
    if (window.Shopify.designMode)
      this.initDesignMode();
  }
  setupElements() {
    this.searchInput = this.content.querySelector("input[type=search]");
    this.resultsContainer = this.content.querySelector("[data-results-container]");
    this.skeleton = this.content.querySelector("[data-skeleton]");
    this.placeholder = this.content.querySelector("[data-placeholder]");
  }
  setupListeners() {
    this.searchInput.addEventListener("input", this.onSearchInput.bind(this));
  }
  onSearchInput() {
    var _a;
    if (!this.searchInput.value.trim()) {
      (_a = this.abortController) == null ? void 0 : _a.abort();
      this.hideSkeleton();
      this.clearResults();
      return;
    }
    if (this.trySearchCache()) {
      return;
    }
    this.clearResults();
    this.showSkeleton();
    this.performSearchDebounced();
  }
  trySearchCache() {
    const query = this.getSearchQuery();
    if (this.searchCache.has(query)) {
      this.showResults(this.searchCache.get(query));
      return true;
    }
    return false;
  }
  async performSearch() {
    var _a;
    (_a = this.abortController) == null ? void 0 : _a.abort();
    this.abortController = new AbortController();
    const query = this.getSearchQuery();
    if (!query.trim()) {
      return;
    }
    const resp = await fetch(this.getSearchURL(query), {
      signal: this.abortController.signal
    });
    const html = await resp.text();
    this.searchCache.set(query, html);
    this.showResults(html);
  }
  getSearchQuery() {
    return this.searchInput.value;
  }
  showSkeleton() {
    this.hidePlaceholder();
    this.skeleton.classList.remove("hidden");
  }
  hideSkeleton() {
    this.skeleton.classList.add("hidden");
  }
  showPlaceholder() {
    var _a;
    (_a = this.placeholder) == null ? void 0 : _a.classList.remove("hidden");
  }
  hidePlaceholder() {
    var _a;
    (_a = this.placeholder) == null ? void 0 : _a.classList.add("hidden");
  }
  showResults(html) {
    this.hideSkeleton();
    this.hidePlaceholder();
    this.resultsContainer.classList.remove("hidden");
    this.resultsContainer.replaceChildren(...createElementFromHtml(html).children);
  }
  clearResults() {
    this.resultsContainer.classList.add("hidden");
    this.resultsContainer.replaceChildren();
    this.showPlaceholder();
  }
  clearInput() {
    this.searchInput.value = "";
  }
  getSearchURL(query) {
    const url = new URL(window.routes.predictive_search_url, window.location.origin);
    url.searchParams.append("q", query);
    url.searchParams.append("resources[type]", 'product');
    url.searchParams.append("resources[options][unavailable_products]", 'hide');
    url.searchParams.append("resources[options][fields]", 'title,product_type,variants.title,variants.sku,variants.barcode');
    url.searchParams.append("section_id", "predictive-search");
    return url;
  }
  async afterHide() {
    await super.afterHide();
    this.clearInput();
    this.clearResults();
    this.hideSkeleton();
    this.showPlaceholder();
    this.savedFilterValue = null;
  }
  async show({ load } = {}) {
    await super.show(...arguments);
    if (window.Shopify.designMode && !load) {
      this.searchInput.focus();
    }
  }
  getCornerRadius() {
    if (isBelow("xl") || this.classList.contains("modal-search--full-width")) {
      return "0";
    } else {
      return "0 0 var(--block-corner-radius) var(--block-corner-radius)";
    }
  }
}
customElements.define("search-modal", SearchModal);
class SelectDynamicWidth extends HTMLElement {
  constructor() {
    super();
    this.selectEl = this.querySelector("select");
    this.updateSelectWidth = this.updateSelectWidth.bind(this);
    this.updateSelectWidthDebounce = debounce(this.updateSelectWidth, 100);
  }
  connectedCallback() {
    this.selectEl.addEventListener("change", this.updateSelectWidth);
    window.addEventListener("load", this.updateSelectWidth);
    window.addEventListener("resize", this.updateSelectWidthDebounce);
    this.updateSelectWidth();
  }
  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.updateSelectWidth);
    window.removeEventListener("load", this.updateSelectWidth);
    window.removeEventListener("resize", this.updateSelectWidthDebounce);
  }
  updateSelectWidth() {
    const selectedOption = this.selectEl.options[this.selectEl.selectedIndex];
    const clonedOption = selectedOption.cloneNode(true);
    const clonedText = document.createElement("span");
    clonedText.textContent = clonedOption.textContent;
    const computedStyle = window.getComputedStyle(this.selectEl);
    clonedText.style.font = computedStyle.font;
    clonedText.style.padding = computedStyle.padding;
    clonedText.style.display = "inline-block";
    clonedText.style.visibility = "hidden";
    clonedText.style.position = "absolute";
    clonedText.style.top = "-9999px";
    this.appendChild(clonedText);
    const selectedOptionWidth = clonedText.offsetWidth;
    this.removeChild(clonedText);
    this.selectEl.style.width = selectedOptionWidth + "px";
  }
}
customElements.define("select-dynamic-width", SelectDynamicWidth);
class ShareDropdown extends DropdownList {
  async show() {
    if (navigator.share) {
      const data = {
        title: this.getAttribute("text"),
        url: this.getAttribute("url")
      };
      await navigator.share(data).catch(() => {
      });
      return;
    }
    return super.show(...arguments);
  }
}
customElements.define("share-dropdown", ShareDropdown);
class UserError extends Error {
  // An error message that can be displayed to the user.
}
class ShippingEstimator extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.form = this.querySelector("form");
    this.countrySelect = this.querySelector("[name=country]");
    this.provinceSelect = this.querySelector("[name=province]");
    this.zipcodeInput = this.querySelector("[name=zipcode]");
    this.shippingRates = this.querySelector("[data-shipping-rates-container]");
    this.errorMessageTemplate = this.querySelector("template");
    this.submitButton = this.querySelector("button");
    this.addEventListeners();
  }
  addEventListeners() {
    this.form.addEventListener("submit", async (event) => {
      var _a;
      try {
        event.preventDefault();
        (_a = this.errorMessage) == null ? void 0 : _a.remove();
        this.displayShippingRates();
        setButtonLoading(this.submitButton, true);
        const rates = await this.getShippingRates();
        this.displayShippingRates(rates);
      } catch (err) {
        this.errorMessage = this.errorMessageTemplate.content.cloneNode(true).children[0];
        if (err instanceof UserError) {
          this.errorMessage.textContent = err.message;
        }
        this.errorMessageTemplate.after(this.errorMessage);
      } finally {
        setButtonLoading(this.submitButton, false);
      }
    });
  }
  // async prepareShippingRates() {
  //   const shippingInfo = {
  //     shipping_address: {
  //       country: this.countrySelect.value,
  //       province: this.provinceSelect.value,
  //       zip: this.zipcodeInput.value,
  //     },
  //   };
  //   await fetch(`/cart/prepare_shipping_rates.json`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(shippingInfo),
  //   });
  // }
  // async getShippingRates() {
  //   return new Promise((resolve, reject) => {
  //     const checkRates = async () => {
  //       try {
  //         const url = new URL(window.location.origin + "/cart/async_shipping_rates.json");
  //         url.searchParams.append("shipping_address[country]", this.countrySelect.value);
  //         url.searchParams.append("shipping_address[province]", this.provinceSelect.value);
  //         url.searchParams.append("shipping_address[zip]", this.zipcodeInput.value);
  //         const response = await fetch(url);
  //         const data = await response.json();
  //         if (!response.ok) {
  //           throw new Error("Failed to fetch shipping rates.");
  //         } else if (data?.shipping_rates) {
  //           resolve(data.shipping_rates);
  //         } else {
  //           setTimeout(checkRates, 1000);
  //         }
  //       } catch (err) {
  //         reject(err);
  //       }
  //     };
  //     checkRates();
  //   });
  // }
  async getShippingRates() {
    const url = new URL(window.location.origin + "/cart/shipping_rates.json");
    url.searchParams.append("shipping_address[country]", this.countrySelect.value);
    url.searchParams.append("shipping_address[province]", this.provinceSelect.value);
    url.searchParams.append("shipping_address[zip]", this.zipcodeInput.value);
    const response = await fetch(url);
    const data = await response.json();
    if (!response.ok || !(data == null ? void 0 : data.shipping_rates)) {
      if (response.status === 422 && (data == null ? void 0 : data.zip[0])) {
        throw new UserError(data == null ? void 0 : data.zip[0]);
      } else {
        throw new Error("Failed to fetch shipping rates.");
      }
    }
    return data.shipping_rates;
  }
  displayShippingRates(rates) {
    if (!rates) {
      this.shippingRates.textContent = "";
      return;
    }
    if (rates.length === 0) {
      this.shippingRates.textContent = window._t.sections.shipping_estimator.no_rates;
      return;
    }
    this.shippingRates.textContent = "";
    rates.forEach((rate) => {
      const listItem = document.createElement("li");
      let rateNameTranslation = rate.name;
      if (rate.name === 'Free'){
        rateNameTranslation = this.shippingRates.dataset.freeDeliveryTranslation
      } else if (rate.name === 'Fastest Delivery') {
        rateNameTranslation = this.shippingRates.dataset.fastestDeliveryTranslation
      }
      else if (rate.name === 'Delivery') {
        rateNameTranslation = this.shippingRates.dataset.standartDeliveryTranslation
      }
      listItem.textContent = `${rateNameTranslation}: ${rate.price} ${rate.currency}`;
      this.shippingRates.appendChild(listItem);
    });
  }
}
customElements.define("shipping-estimator", ShippingEstimator);
class ShoppableImageController extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.carousels = this.querySelectorAll("slide-carousel");
    this.targets = this.querySelectorAll("[data-index]");
    this.targets.forEach((el) => {
      el.addEventListener("click", (e) => e.detail > 0 ? this.changeSlide(e) : null);
      if ("ontouchend" in window === false) {
        el.addEventListener("mouseover", (e) => this.changeSlide(e));
      }
      el.addEventListener("focus", (e) => this.changeSlide(e));
    });
  }
  changeSlide(e) {
    e.preventDefault();
    this.targets.forEach((el) => el.classList.remove("is-active"));
    e.currentTarget.classList.add("is-active");
    this.carousels.forEach((carousel) => {
      carousel.changeSlide(Number(e.currentTarget.dataset.index));
    });
  }
}
window.customElements.define("shoppable-image-controller", ShoppableImageController);
class SlideCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = [];
    this.autoplayTimer = null;
    this.animationDuration = 200;
    this.interval = 5e3;
    this.currentAnimation = null;
    this.observer = null;
  }
  connectedCallback() {
    this.slides = Array.from(this.children);
    this.updateActive();
    this.addEventListener("control:prev", this.prev.bind(this));
    this.addEventListener("control:next", this.next.bind(this));
    this.addEventListener("control:change", this.change.bind(this));
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.getAttribute("autoplay") === "true") {
            this.startAutoplay(this.interval);
          }
        } else {
          this.stopAutoplay();
        }
      });
    });
    this.observer.observe(this);
    if (this.getAttribute("autoplay") === "true") {
      this.interval = this.getAttribute("interval") || this.interval;
      this.startAutoplay(this.interval);
    }
  }
  disconnectedCallback() {
    this.stopAutoplay();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  async changeSlide(newIndex) {
    if (newIndex == this.currentIndex)
      return;
    cancelAnims(...this.slides);
    this.updateActive();
    const prevSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[newIndex];
    prevSlide.style.opacity = null;
    nextSlide.style.opacity = null;
    this.currentIndex = newIndex;
    this.dispatchEvent(
      new CustomEvent("carousel:change", { detail: { index: this.currentIndex }, bubbles: true })
    );
    nextSlide.classList.add("is-active");
    prevSlide.style.opacity = 0;
    await Promise.all([this.animateOut(prevSlide), this.animateIn(nextSlide)]);
    prevSlide.style.opacity = null;
    prevSlide.classList.remove("is-active");
  }
  updateActive() {
    this.slides.forEach(
      (slide, index) => index === this.currentIndex ? slide.classList.add("is-active") : slide.classList.remove("is-active")
    );
  }
  async animateIn(element) {
    await animate(element, "fade-in", { x: 0, y: 0, duration: 150, easing: "linear" }).finished;
  }
  async animateOut(element) {
    await animate(element, "fade-out", { x: 0, y: 0, duration: 150, easing: "linear" }).finished;
  }
  next() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.changeSlide(nextIndex);
  }
  prev() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.changeSlide(prevIndex);
  }
  change(event) {
    this.changeSlide(event.detail.index);
  }
  startAutoplay(interval) {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.next();
    }, interval);
  }
  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}
customElements.define("slide-carousel", SlideCarousel);
class SlideshowControlArrows extends HTMLElement {
  connectedCallback() {
    if (this.init)
      return;
    this.init = true;
    this.parentSlideshow = this.closest("slideshow-element");
    this.slideCounterProgressCircle = this.querySelector(
      "[data-slide-counter] svg > circle:nth-child(2)"
    );
    this.slideCounterText = this.querySelector("[data-slider-counter-text]");
    this.slideCounter = this.querySelector("[data-slide-counter]");
    this.buttonPrev = this.querySelector("[data-slider-button-prev]");
    this.buttonNext = this.querySelector("[data-slider-button-next]");
    this.buttonPrev.addEventListener(
      "click",
      throttle(() => {
        this.dispatchEvent(new CustomEvent("slideshow:controls:prev", { bubbles: true }));
      }, 500)
    );
    this.buttonNext.addEventListener(
      "click",
      throttle(() => {
        this.dispatchEvent(new CustomEvent("slideshow:controls:next", { bubbles: true }));
      }, 500)
    );
    this.parentSlideshow.addEventListener("slideshow:update", (event) => {
      const { currentIndex, slidesLength } = event.detail;
      this.updateView(currentIndex, slidesLength);
      if (this.parentSlideshow.playing) {
        this.spinTheWheel();
      }
    });
    this.parentSlideshow.addEventListener("slideshow:play", () => {
      this.spinTheWheel();
    });
  }
  spinTheWheel() {
    if (this.spinTheWheelAnim) {
      this.spinTheWheelAnim.cancel();
    }
    this.spinTheWheelAnim = this.slideCounterProgressCircle.animate(
      { strokeDashoffset: [100, 0] },
      { duration: this.parentSlideshow.speed }
    );
  }
  updateView(currentIndex, slidesLength) {
    this.slideCounterText.textContent = `${currentIndex + 1}/${slidesLength}`;
  }
}
customElements.define("slideshow-control-arrows", SlideshowControlArrows);
class SlideshowControlDots extends DotsIndicator {
  connectedCallback() {
    if (this.init)
      return;
    this.init = true;
    super.connectedCallback();
    this.parentSlideshow = this.closest("slideshow-element");
    this.parentSlideshow.addEventListener("slideshow:update", (event) => {
      this.updateActiveDot(event.detail.currentIndex);
    });
  }
  onDotClick(index) {
    super.onDotClick(index);
    this.dispatchEvent(
      new CustomEvent("slideshow:controls:changed", { detail: { index }, bubbles: true })
    );
  }
}
customElements.define("slideshow-control-dots", SlideshowControlDots);
class SlideshowElementBackground extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slidesLength = 0;
    this.handleSlideshowUpdate = this.handleSlideshowUpdate.bind(this);
  }
  connectedCallback() {
    this.closest(".shopify-section").addEventListener(
      "slideshow:update",
      this.handleSlideshowUpdate
    );
  }
  disconnectedCallback() {
    this.closest(".shopify-section").removeEventListener(
      "slideshow:update",
      this.handleSlideshowUpdate
    );
  }
  handleSlideshowUpdate(event) {
    const { slide } = event.detail;
    const bg = slide.getAttribute("block-background");
    this.style.backgroundColor = bg ? bg : null;
  }
}
customElements.define("slideshow-element-background", SlideshowElementBackground);
class Slideshow extends HTMLElement {
  constructor() {
    super();
    this.playing = false;
    this.currentIndex = 0;
    this.animateOnLoad = true;
    this.onDocumentVisibilityChange = this.onDocumentVisibilityChange.bind(this);
    this.onResizeDebounced = debounce(this.onResize.bind(this), 100);
  }
  async connectedCallback() {
    if (!this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(this.onResizeDebounced);
      this.resizeObserver.observe(this);
    }
    if (this.init)
      return;
    this.init = true;
    this.slides = [...this.querySelectorAll("slideshow-slide")];
    this.speed = window.parseInt(this.getAttribute("speed") ?? 5e3);
    this.autoplay = this.getAttribute("autoplay") == "true";
    this.addEventListener("slideshow:controls:prev", () => {
      this.pause();
      this.prev();
    });
    this.addEventListener("slideshow:controls:next", () => {
      this.pause();
      this.next();
    });
    this.addEventListener("slideshow:controls:changed", (e) => {
      if (e.detail.index == this.currentIndex)
        return;
      this.pause();
      this.swap(this.getCurrentSlide(), this.slides[e.detail.index], e.detail.index);
    });
    document.addEventListener("visibilitychange", this.onDocumentVisibilityChange);
    if (this.autoplay) {
      this.pauseObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.play();
        } else {
          this.pause();
        }
      });
      this.pauseObserver.observe(this);
    }
    this.addEventListener("touchstart", (e) => this.handleTouchStart(e), { passive: true });
    this.addEventListener("touchend", (e) => this.handleTouchEnd(e));
    if (window.Shopify.designMode) {
      this.slides[0].classList.remove("slide-loading");
      this._initDesignMode();
      await this.finishInit();
    } else {
      if (this.slides[0].querySelector("img") && !this.slides[0].querySelector("video")) {
        this.createImageObserver();
      } else {
        await this.finishInit();
      }
    }
  }
  disconnectedCallback() {
    document.removeEventListener("visibilitychange", this.onDocumentVisibilityChange);
    this.resizeObserver.disconnect();
    this.resizeObserver = null;
    if (this.pauseObserver) {
      this.pauseObserver.disconnect();
    }
  }
  onDocumentVisibilityChange() {
    if (document.visibilityState == "visible") {
      const video = this.getCurrentSlide().getCurrentVideo();
      if (video && video.paused)
        video.play();
    }
  }
  onResize() {
    const video = this.getCurrentSlide().getCurrentVideo();
    if (video && video.paused) {
      this.getCurrentSlide().querySelectorAll("video").forEach((x) => x.pause());
      video.play();
    }
  }
  createImageObserver() {
    const observer = new IntersectionObserver(async (entries) => {
      const intersecting = entries.filter((x) => x.isIntersecting);
      if (intersecting.length == 0)
        return;
      observer.disconnect();
      try {
        await waitForImagesToLoad(intersecting.map((x) => x.target));
      } catch (err) {
        console.error(err);
      }
      await this.finishInit();
    });
    this.getCurrentSlide().querySelectorAll("img").forEach((el) => observer.observe(el));
  }
  async finishInit() {
    await Promise.all([
      customElements.whenDefined("slideshow-slide"),
      customElements.whenDefined("slideshow-control-arrows"),
      customElements.whenDefined("slideshow-control-dots"),
      customElements.whenDefined("split-lines")
    ]);
    await Promise.all(Array.from(this.querySelectorAll("split-lines")).map((x) => x.ready));
    if (this.slides.length > 1) {
      this.showControls();
    }
    this.slides[0].classList.remove("slide-loading");
    if (this.startIndex) {
      this.slides[0].classList.remove("active");
      this.slides[this.startIndex].classList.add("active");
      this.currentIndex = this.startIndex;
    }
    const video = this.slides[this.currentIndex].getCurrentVideo();
    if (video) {
      video.play();
    }
    if (this.animateOnLoad) {
      this.getCurrentSlide().getContentAnimation().run(this.getCurrentSlide());
    }
    if (this.autoplay) {
      this.play();
    } else {
      this.pause();
    }
    this.emitUpdated();
    this.isInitFinished = true;
  }
  showControls() {
    this.querySelector("[data-slideshow-controls]").classList.add("show");
  }
  play() {
    if (!this.playing && this.slides.length > 1) {
      this.playing = true;
      this.classList.remove("autoplay-paused");
      this.autoplayInterval = setInterval(() => this.autoplayLoop(), this.speed);
      this.dispatchEvent(new CustomEvent("slideshow:play"));
    }
  }
  pause() {
    this.playing = false;
    this.classList.add("autoplay-paused");
    clearInterval(this.autoplayInterval);
  }
  prev() {
    this.swap(this.getCurrentSlide(), this.getPrevSlide(), this.getPrevIndex());
  }
  next() {
    this.swap(this.getCurrentSlide(), this.getNextSlide(), this.getNextIndex());
  }
  async swap(cur, next, nextIndex, animate2 = true) {
    if (cur === next || nextIndex === this.currentIndex) {
      return;
    }
    const swapToken = Symbol();
    this.swapToken = swapToken;
    if (document.hidden) {
      this.slides.forEach((slide) => slide.classList.remove("anim-in", "anim-out", "active"));
      next.classList.add("active");
      this.currentIndex = nextIndex;
      this.emitUpdated();
      return;
    }
    cancelAnims(cur, next);
    this.slides.forEach((slide) => slide.classList.remove("anim-in", "anim-out", "active"));
    if (animate2) {
      cur.classList.add("active", "anim-out");
      next.classList.add("active", "anim-in");
      next.animateIn().then(() => {
        if (swapToken !== this.swapToken)
          return;
        if (curVideo)
          curVideo.pause();
        cur.classList.remove("active", "anim-out");
        next.classList.remove("anim-in");
      }).catch(() => {
      });
    } else {
      next.classList.add("active");
    }
    const nextVideo = next.getCurrentVideo();
    const curVideo = cur.getCurrentVideo();
    if (nextVideo) {
      nextVideo.play();
    }
    this.currentIndex = nextIndex;
    this.emitUpdated();
    if (this.slides[this.currentIndex + 1]) {
      this.slides[this.currentIndex + 1].classList.add("preload");
    }
  }
  emitUpdated() {
    this.dispatchEvent(
      new CustomEvent("slideshow:update", {
        detail: {
          currentIndex: this.currentIndex,
          slidesLength: this.slides.length,
          slide: this.slides[this.currentIndex]
        },
        bubbles: true
      })
    );
  }
  autoplayLoop() {
    if (this.playing) {
      this.next();
    }
  }
  getPrevSlide() {
    return this.slides[this.getPrevIndex()];
  }
  getCurrentSlide() {
    return this.slides[this.currentIndex];
  }
  getNextSlide() {
    return this.slides[this.getNextIndex()];
  }
  getPrevIndex() {
    return mod(this.currentIndex - 1, this.slides.length);
  }
  getNextIndex() {
    return mod(this.currentIndex + 1, this.slides.length);
  }
  handleTouchStart(e) {
    this.touchStart = e.changedTouches[0];
  }
  handleTouchEnd(e) {
    this.touchEnd = e.changedTouches[0];
    this.handleSwipeGesture();
  }
  handleSwipeGesture() {
    if (!this.touchStart || !this.touchEnd) {
      return;
    }
    const xDistance = this.touchEnd.screenX - this.touchStart.screenX;
    const yDistance = this.touchEnd.screenY - this.touchStart.screenY;
    if (Math.abs(xDistance) > Math.abs(yDistance) && Math.abs(xDistance) > 10) {
      this.pause();
      if (xDistance < 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }
  _initDesignMode() {
    this.addEventListener("shopify:block:select", async (event) => {
      if (!this.isInitFinished) {
        this.startIndex = this.slides.indexOf(event.target);
        this.animateOnLoad = !event.detail.load;
        this.autoplay = false;
        return;
      }
      this.pause();
      if (this.currentIndex === this.slides.indexOf(event.target)) {
        return;
      }
      this.swap(
        this.getCurrentSlide(),
        event.target,
        this.slides.indexOf(event.target),
        !event.detail.load
      );
    });
  }
}
customElements.define("slideshow-element", Slideshow);
class BackgroundAnimation {
  constructor() {
    this.duration = 333;
  }
  setDuration(duration) {
    this.duration = duration;
  }
  getContentAnimationDelay() {
    return this.duration;
  }
  // eslint-disable-next-line no-unused-vars
  run(slide, callback = null) {
  }
}
class Clip extends BackgroundAnimation {
  constructor() {
    super();
    this.setDuration(500);
  }
  async run(slide) {
    this.animation = slide.animate(
      { clipPath: this.getClipPathKeyframes(slide) },
      { duration: this.duration, easing: "ease-in-out" }
    );
    await this.animation.finished;
  }
  getClipPathKeyframes(slide) {
    const aspectRatio = slide.clientWidth / slide.clientHeight;
    let percentage = 50 / aspectRatio;
    return [
      `polygon(${percentage + 100}% 0, 100% 0, 100% 100%, 100% 100%)`,
      `polygon(0 0, 100% 0, 100% 100%, -${percentage}% 100%)`
    ];
  }
}
class Fade extends BackgroundAnimation {
  constructor() {
    super();
    this.setDuration(375);
  }
  async run(slide) {
    this.animation = slide.animate(
      { opacity: [0, 1] },
      { duration: this.duration, easing: "ease-in-out" }
    );
    await this.animation.finished;
  }
}
class ZoomOut extends BackgroundAnimation {
  constructor() {
    super();
    this.setDuration(500);
  }
  async run(slide) {
    this.animation = slide.animate(
      { opacity: [0, 1], transform: ["scale(1.075)", "none"] },
      { duration: this.duration, easing: EaseOut }
    );
    await this.animation.finished;
  }
}
class ContentAnimation {
  constructor(slide) {
    this.slide = slide;
  }
  getAnimationElements() {
    return [...this.slide.getAnimationElements()].map((el) => {
      if (el.tagName === "SPLIT-LINES") {
        return [...el.shadowRoot.children];
      } else {
        return el;
      }
    }).flat();
  }
  // eslint-disable-next-line no-unused-vars
  run(slide) {
    throw new Error("Not implemented");
  }
}
class FadeIn extends ContentAnimation {
  async run(slide) {
    var _a;
    await slide.querySelector(".slide-content").animate(
      { opacity: [0, 1], transform: ["translateY(1rem)", "none"] },
      {
        fill: "backwards",
        duration: 500,
        delay: ((_a = slide.backgroundAnimation) == null ? void 0 : _a.getContentAnimationDelay()) ?? 0,
        easing: "cubic-bezier(0, 0, .1, 1)"
      }
    ).finished;
  }
}
class AppearLineByLine extends ContentAnimation {
  async run(slide) {
    const count = this.getAnimationElements().length;
    await Promise.all(
      this.getAnimationElements().map(
        (el, i) => {
          var _a;
          return el.animate(
            { opacity: [0, 1], transform: ["translateY(1rem)", "none"] },
            {
              duration: 600,
              delay: (((_a = slide.backgroundAnimation) == null ? void 0 : _a.getContentAnimationDelay()) ?? 0) + 200 / Math.log(count * 2 + 2) * i,
              fill: "backwards",
              easing: "cubic-bezier(0, 0, .1, 1)"
            }
          ).finished;
        }
      )
    );
  }
}
class ClipLineByLine extends ContentAnimation {
  async run(slide) {
    const count = this.getAnimationElements().length;
    await Promise.all(
      this.getAnimationElements().map((el, i) => {
        var _a;
        const target = el.firstElementChild ?? el;
        el.style.overflow = "hidden";
        return target.animate(
          { transform: ["translateY(calc(100% + 9px))", "none"] },
          {
            duration: 800,
            delay: (((_a = slide.backgroundAnimation) == null ? void 0 : _a.getContentAnimationDelay()) ?? 0) + 200 / Math.log(count * 2 + 2) * i,
            fill: "backwards",
            easing: "cubic-bezier(0, 1, .5, 1)"
          }
        ).finished.finally(() => {
          el.style.overflow = null;
        });
      })
    );
  }
}
class SlideshowSlide extends HTMLElement {
  constructor() {
    super();
    this.backgroundAnimations = { Fade, Clip, ZoomOut };
    this.contentAnimations = { FadeIn, AppearLineByLine, ClipLineByLine };
  }
  getAnimationElements() {
    return this.querySelectorAll("[data-slide-animation-element]");
  }
  getBackgroundAnimation() {
    if (!this.backgroundAnimation) {
      const animationType = this.getAttribute("background-animation");
      const AnimationClass = this.backgroundAnimations[animationType];
      this.backgroundAnimation = new AnimationClass(this);
    }
    return this.backgroundAnimation;
  }
  getContentAnimation() {
    if (!this.contentAnimation) {
      const animationType = this.getAttribute("content-animation");
      if (animationType === "none")
        return null;
      const AnimationClass = this.contentAnimations[animationType];
      this.contentAnimation = new AnimationClass(this);
    }
    return this.contentAnimation;
  }
  async animateIn() {
    this.cancelAnims();
    const slideAnim = this.getBackgroundAnimation();
    const contentAnim = this.getContentAnimation();
    await Promise.all([slideAnim.run(this), contentAnim == null ? void 0 : contentAnim.run(this)]);
  }
  animateOut() {
    this.getAnimations().forEach((x) => x.cancel());
    this.classList.remove("anim-in");
  }
  cancelAnims() {
    var _a, _b;
    this.getAnimations().forEach((x) => x.cancel());
    (_b = (_a = this.getContentAnimation()) == null ? void 0 : _a.getAnimationElements()) == null ? void 0 : _b.forEach((el) => {
      el.getAnimations().forEach((el2) => el2.cancel());
    });
  }
  getCurrentVideo() {
    return [...this.querySelectorAll("video")].find((x) => getComputedStyle(x).display !== "none");
  }
}
customElements.define("slideshow-slide", SlideshowSlide);
class SmoothCollapse extends HTMLElement {
  constructor() {
    super();
    this.subs = [];
  }
  connectedCallback() {
    if (this.details)
      return;
    this.details = this.querySelector("details");
    this.summary = this.querySelector("details > summary");
    this.content = this.querySelector("details > summary + *");
    this.summary.addEventListener("click", async (e) => await this.onClickSummary(e));
    if (this.getAttribute("group")) {
      this.setupGroupListeners();
    }
    if (window.Shopify.designMode) {
      this.initDesignMode();
    }
  }
  disconnectedCallback() {
    this.subs.forEach((x) => pubsubExports.unsubscribe(x));
  }
  setupGroupListeners() {
    this.subs.push(
      pubsubExports.subscribe(COLLAPSE_CHANGED, (_, data) => {
        if (data.el !== this && data.group === this.getAttribute("group") && data.open) {
          this.collapse();
        }
      })
    );
  }
  getAnim() {
    return this.getAttribute("animation") ?? "fade-up";
  }
  async show() {
    this.getAnimations({ subtree: true }).forEach((anim2) => anim2.cancel());
    this.content.style.overflow = "hidden";
    this.details.open = true;
    const targetHeight = this.content.offsetHeight;
    this.classList.remove("collapsing");
    this.classList.add("expanding");
    const anim = this.content.animate(
      { height: [0, targetHeight + "px"] },
      { duration: 250, easing: EaseOut }
    );
    if (this.getAnim() === "fade-up") {
      this.content.animate(
        { opacity: [0, 1], transform: ["translateY(1rem)", "none"] },
        { duration: 250, delay: 50, fill: "backwards", easing: EaseInOut }
      );
    }
    await anim.finished;
    this.content.style.overflow = null;
    this.classList.remove("expanding");
    this.details.open = true;
  }
  async collapse() {
    this.getAnimations({ subtree: true }).forEach((anim2) => anim2.cancel());
    this.content.style.overflow = "hidden";
    const targetHeight = this.content.offsetHeight;
    this.classList.remove("expanding");
    this.classList.add("collapsing");
    const anim = this.content.animate(
      { height: [targetHeight + "px", 0] },
      { duration: 250, easing: EaseOut }
    );
    if (this.getAnim() === "fade-up") {
      this.content.animate({ opacity: [1, 0, 0] }, { duration: 250, easing: EaseInOut });
    }
    await anim.finished;
    this.content.style.overflow = null;
    this.classList.remove("collapsing");
    this.details.open = false;
  }
  async onClickSummary(e) {
    e.preventDefault();
    if (this.getAttribute("group")) {
      pubsubExports.publish(COLLAPSE_CHANGED, {
        el: this,
        group: this.getAttribute("group"),
        open: !this.details.open
      });
    }
    if (!this.details.open || this.classList.contains("collapsing")) {
      await this.show();
    } else {
      await this.collapse();
    }
  }
  saveComponentState() {
    return { open: this.details.open };
  }
  loadComponentState(data) {
    this.details.open = data.open;
  }
  initDesignMode() {
    this.addEventListener("shopify:block:select", () => {
      this.show();
    });
    this.addEventListener("shopify:block:deselect", () => {
      if (this.getAttribute("default-open") === null) {
        this.collapse();
      }
    });
  }
}
customElements.define("smooth-collapse", SmoothCollapse);
class SplitLines extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    const template = document.createElement("template");
    template.innerHTML = "<slot></slot>";
    shadow.appendChild(template.content.cloneNode(true));
    this.splitDebounced = debounce(this.split.bind(this), 250);
    this.ready = new Promise((resolve) => this._readyResolve = resolve);
  }
  connectedCallback() {
    this.split();
    this.resizeObserver = new ResizeObserver(() => {
      this.splitDebounced();
    });
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
  async split() {
    if (this.splitRunning)
      return;
    this.splitRunning = true;
    const font = getComputedStyle(this).font;
    await document.fonts.load(font).catch(() => {
    });
    await Promise.all(
      this.shadowRoot.getAnimations({ subtree: true }).map((x) => x.finished.catch(() => {
      }))
    );
    await delay$1(100);
    this.shadowRoot.innerHTML = this.textContent.trim().split("\n").map(
      (line) => line.split("").map((char) => `<span>${char}</span>`).join("")
    ).join("<br />");
    const lines = /* @__PURE__ */ new Map();
    const linesCharAdd = (y, char) => lines.has(y) ? lines.set(y, lines.get(y) + char) : lines.set(y, char);
    [...this.shadowRoot.children].forEach(
      (letter) => linesCharAdd(letter.getBoundingClientRect().y, letter.textContent)
    );
    this.shadowRoot.innerHTML = [...lines.values()].map(
      (x) => `<div style="display:block;overflow:hidden;padding-bottom:8px;margin-bottom:-8px;">
            <div style="display: inline-block">${x}</div>
          </div>`
    ).join("");
    this.splitRunning = false;
    this.splitAt = this.clientWidth;
    if (this._readyResolve) {
      this._readyResolve();
      this._readyResolve = null;
    }
  }
}
customElements.define("split-lines", SplitLines);
class SPRReviewsCustom extends HTMLElement {
  connectedCallback() {
    if (this.observer) {
      return;
    }
    this.observer = new MutationObserver(this.observerCallback.bind(this));
    this.observer.observe(this, { childList: true, subtree: true });
    if (window.Shopify.designMode) {
      this.initDesignMode();
    }
  }
  disconnectedCallback() {
    this.observer.disconnect();
    this.observer = null;
  }
  observerCallback(entries) {
    entries.forEach(
      (entry) => Array.from(entry.addedNodes).filter((x) => x.classList && x.classList.contains("spr-review")).forEach(this.modifyReview.bind(this))
    );
  }
  modifyReview(el) {
    var _a;
    this.modifiedReview = true;
    (_a = el.querySelector(".spr-review-footer")) == null ? void 0 : _a.prepend(el.querySelector(".spr-review-header-byline"));
  }
  initDesignMode() {
    this.closest(".shopify-section").addEventListener("shopify:section:load", () => {
      window.SPR.loadProducts();
    });
  }
}
customElements.define("spr-reviews-custom", SPRReviewsCustom);
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "addToCartVisible", false);
    __publicField(this, "footerVisible", false);
    __publicField(this, "debouncedHide", debounce(() => {
      if (this.classList.contains("show")) {
        this.classList.add("hide");
        this.classList.remove("show");
      }
    }, 500));
    this.observer = new IntersectionObserver(
      this.handleIntersections.bind(this),
      {
        threshold: 0.2
      }
    );
  }
  get section() {
    return this.closest(".shopify-section");
  }
  get addToCartButton() {
    return this.section.querySelector(".button-add-to-cart");
  }
  get footer() {
    return document.querySelector(".footer");
  }
  connectedCallback() {
    if (this.addToCartButton) {
      this.observer.observe(this.addToCartButton);
    }
    if (this.footer) {
      this.observer.observe(this.footer);
    }
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersections(entries) {
    for (let entry of entries) {
      if (entry.target === this.addToCartButton) {
        this.addToCartVisible = entry.isIntersecting;
      } else if (entry.target === this.footer) {
        this.footerVisible = entry.isIntersecting;
      }
    }
    this.setVisible(
      !this.addToCartVisible && !this.footerVisible && this.addToCartButton.getBoundingClientRect().y < 0
    );
  }
  setVisible(visible) {
    if (visible && this.isAboveThreshold()) {
      this.debouncedHide.cancel();
      this.classList.add("show");
      this.classList.remove("hide");
    } else {
      this.debouncedHide();
    }
  }
  isAboveThreshold() {
    const viewportHeight = window.innerHeight;
    const thresholdDistance = viewportHeight * 0.75;
    const addToCartRect = this.addToCartButton.getBoundingClientRect();
    const footerRect = this.footer.getBoundingClientRect();
    const scrollDistance = footerRect.top - addToCartRect.bottom - viewportHeight;
    return scrollDistance > thresholdDistance;
  }
}
customElements.define("sticky-add-to-cart", StickyAddToCart);
const DIR_DOWN$1 = 1;
const DIR_UP$1 = -1;
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.section)
      return;
    this.section = this.closest(".shopify-section");
    this.header = this.querySelector(".header");
    this.headerBounds = {};
    this.lastScrollTop = scrollTop();
    this.lastScrollDir = 0;
    this.lastScrollDirChange = scrollTop();
    this.overlay = this.querySelector(".header-overlay");
    this.alwaysVisible = false;
    this.disabled = true;
    this.onScrollHandler = this.onScroll.bind(this);
    switch (this.getAttribute("mode")) {
      case "scroll-up":
        this.disabled = false;
        break;
      case "always-visible":
        this.disabled = false;
        this.alwaysVisible = true;
        break;
    }
    if (!this.disabled) {
      this.createObserver();
    }
    if (window.Shopify.designMode) {
      this.initShopifyDesignMode();
    }
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }
  addScrollListener() {
    window.addEventListener("scroll", this.onScrollHandler, false);
  }
  async showOverlay() {
    var _a, _b;
    (_a = this.overlayAnim) == null ? void 0 : _a.finish();
    await ((_b = this.overlayAnim) == null ? void 0 : _b.finished);
    this.overlay.classList.add("active");
    this.overlayAnim = this.overlay.animate({ opacity: [0, 1] }, { duration: 250 });
    await this.overlayAnim.finished.finally(() => {
      this.overlay.classList.add("active");
    });
  }
  async hideOverlay() {
    var _a, _b;
    (_a = this.overlayAnim) == null ? void 0 : _a.finish();
    await ((_b = this.overlayAnim) == null ? void 0 : _b.finished);
    this.overlayAnim = this.overlay.animate({ opacity: [1, 0] }, { duration: 250 });
    await this.overlayAnim.finished.finally(() => {
      this.overlay.classList.remove("active");
    });
  }
  createObserver() {
    let observer = new IntersectionObserver((entries) => {
      const target = entries[0].target;
      this.headerBounds = {
        top: target.offsetTop,
        bottom: target.offsetTop + target.clientHeight
      };
      observer.disconnect();
      this.addScrollListener();
      if (!this.alwaysVisible && scrollTop() > this.headerBounds.bottom) {
        this.hide();
      }
    });
    observer.observe(this.section);
  }
  onScroll() {
    const currentScrollTop = scrollTop();
    const currentScrollDir = currentScrollTop > this.lastScrollTop ? DIR_DOWN$1 : DIR_UP$1;
    if (currentScrollDir != this.lastScrollDir) {
      this.lastScrollDirChange = currentScrollTop;
    }
    if (this.alwaysVisible) {
      if (currentScrollDir == DIR_DOWN$1 && currentScrollTop > this.headerBounds.top) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (currentScrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
    } else {
      if (currentScrollDir == DIR_DOWN$1 && currentScrollTop > this.headerBounds.bottom) {
        if (currentScrollTop - this.lastScrollDirChange >= 4) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (currentScrollDir == DIR_UP$1 && currentScrollTop > this.headerBounds.bottom) {
        if (this.lastScrollDirChange - currentScrollTop >= 4) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (currentScrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
    }
    this.lastScrollTop = currentScrollTop;
    this.lastScrollDir = currentScrollDir;
  }
  hide() {
    this.section.classList.add("section-site-header--hidden", "section-site-header--sticky");
    this.updateCssVar();
  }
  reveal() {
    this.section.classList.add("section-site-header--sticky", "animate");
    this.section.classList.remove("section-site-header--hidden");
    this.updateCssVar();
  }
  reset() {
    this.updateCssVar();
    this.section.classList.remove(
      "section-site-header--hidden",
      "section-site-header--sticky",
      "animate"
    );
  }
  updateCssVar() {
    if (this.section.classList.contains("section-site-header--sticky") && !this.section.classList.contains("section-site-header--hidden")) {
      document.documentElement.style.setProperty("--header-height-sticky", "var(--header-height)");
    } else {
      document.documentElement.style.removeProperty("--header-height-sticky");
    }
  }
  disableTransparent() {
    if (this.header.classList.contains("header--transparent")) {
      this.header.classList.remove("header--transparent");
      this.transparentDisabled = true;
    }
  }
  enableTransparent() {
    if (this.transparentDisabled) {
      this.header.classList.add("header--transparent");
      this.transparentDisabled = false;
    }
  }
  initShopifyDesignMode() {
    this.addEventListener("shopify:block:select", (e) => {
      const el = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
      if (el && el.show)
        el.show({ anim: false });
    });
    this.addEventListener("shopify:block:deselect", (e) => {
      const el = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
      if (el && el.hide)
        el.hide({ anim: false });
    });
  }
}
customElements.define("sticky-header", StickyHeader);
const DIR_UP = "DIR_UP";
const DIR_DOWN = "DIR_DOWN";
const STATE_DEFAULT = "STATE_DEFAULT";
const STATE_STICKY_TOP = "STATE_STICKY_TOP";
const STATE_STICKY_BOTTOM = "STATE_STICKY_BOTTOM";
const STATE_STATIC = "STATE_STATIC";
class StickySidebar extends HTMLElement {
  connectedCallback() {
    if (this.init)
      return;
    this.init = true;
    this.state = STATE_DEFAULT;
    this.enabled = false;
    this.onScrollThis = this.onScroll.bind(this);
    this.onWindowResizeDebounced = debounce(this.onWindowResize.bind(this), 50);
    this.header = document.querySelector(".section-site-header");
    this.sidebar = this.firstElementChild;
    window.addEventListener("resize", this.onWindowResizeDebounced);
    this.updateEnabled();
    this.resizeObserver = new ResizeObserver(() => {
      if (this.state === STATE_STATIC) {
        this.makeSidebarStickyTop();
      }
    });
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.onWindowResizeDebounced);
    window.removeEventListener("scroll", this.onScrollThis);
    this.resizeObserver.disconnect();
    this.init = false;
  }
  setEnabled(val) {
    if (this.enabled === val)
      return;
    this.enabled = val;
    if (this.enabled) {
      window.addEventListener("scroll", this.onScrollThis, { passive: true });
      this.lastScrollTop = scrollTop();
      this.sidebar.style.transition = "top 250ms";
      this.onScroll();
    } else {
      window.removeEventListener("scroll", this.onScrollThis);
      this.cleanUpSidebar();
    }
  }
  onWindowResize() {
    this.updateEnabled();
  }
  updateEnabled() {
    const breakpointAttr = this.getAttribute("disable-below");
    if (breakpointAttr === null)
      this.setEnabled(true);
    const breakpoint = Number(breakpointAttr);
    this.setEnabled(window.innerWidth >= breakpoint);
  }
  onScroll() {
    const scrollTop$1 = scrollTop();
    const direction = scrollTop$1 > this.lastScrollTop ? DIR_DOWN : DIR_UP;
    this.updateScrollbar(direction);
    this.lastScrollTop = scrollTop$1;
    this.lastDirection = direction;
  }
  updateScrollbar(direction) {
    if (!this.enabled)
      return;
    if (this.getSidebarHeight() < this.getViewportHeight()) {
      this.makeSidebarStickyTop();
      return;
    }
    const rect = this.sidebar.getBoundingClientRect();
    switch (this.state) {
      case STATE_DEFAULT:
        if (this.getViewportHeight() - rect.bottom >= this.getStickyBottomOffset()) {
          this.makeSidebarStickyBottom();
        }
        break;
      case STATE_STICKY_BOTTOM:
        if (direction === DIR_UP && this.getViewportHeight() - rect.bottom - 1 <= this.getStickyBottomOffset()) {
          this.makeSidebarStatic();
        }
        break;
      case STATE_STATIC:
        if (direction === DIR_UP && rect.top >= this.getStickyTopOffset()) {
          this.makeSidebarStickyTop();
        } else if (direction === DIR_DOWN && this.getViewportHeight() - rect.bottom >= this.getStickyBottomOffset()) {
          this.makeSidebarStickyBottom();
        }
        break;
      case STATE_STICKY_TOP:
        if (direction === DIR_DOWN) {
          this.makeSidebarStatic();
        } else if (this.lastStickyTopOffset !== this.getStickyTopOffset()) {
          this.makeSidebarStickyTop();
        }
        break;
    }
  }
  getSidebarHeight() {
    return this.sidebar.clientHeight + this.getStickyTopOffset(false) + this.getStickyBottomOffset();
  }
  getViewportHeight() {
    return window.innerHeight;
  }
  makeSidebarStickyTop() {
    this.sidebar.style.position = "sticky";
    this.sidebar.style.top = `${this.getStickyTopOffset()}px`;
    this.sidebar.style.bottom = null;
    this.sidebar.style.alignSelf = null;
    this.sidebar.style.transform = null;
    this.lastStickyTopOffset = this.getStickyTopOffset();
    this.state = STATE_STICKY_TOP;
  }
  makeSidebarStickyBottom() {
    this.sidebar.style.position = "sticky";
    this.sidebar.style.top = "auto";
    this.sidebar.style.bottom = `${this.getStickyBottomOffset()}px`;
    this.sidebar.style.alignSelf = "flex-end";
    this.sidebar.style.transform = null;
    this.state = STATE_STICKY_BOTTOM;
  }
  makeSidebarStatic() {
    const before = this.sidebar.getBoundingClientRect();
    this.sidebar.style.position = null;
    this.sidebar.style.top = null;
    this.sidebar.style.bottom = null;
    this.sidebar.style.alignSelf = null;
    const after = this.sidebar.getBoundingClientRect();
    this.sidebar.style.transform = `translateY(${before.y - after.y}px)`;
    this.state = STATE_STATIC;
  }
  cleanUpSidebar() {
    this.sidebar.style.position = null;
    this.sidebar.style.top = null;
    this.sidebar.style.bottom = null;
    this.sidebar.style.alignSelf = null;
    this.sidebar.style.transform = null;
    this.sidebar.style.transition = null;
    this.state = STATE_DEFAULT;
  }
  getStickyTopOffset(headerOffset = true) {
    if (headerOffset && this.header.classList.contains("section-site-header--sticky") && !this.header.classList.contains("section-site-header--hidden")) {
      return Number(this.getAttribute("top-offset") ?? 24) + 96;
    } else {
      return Number(this.getAttribute("top-offset") ?? 24);
    }
  }
  getStickyBottomOffset() {
    return Number(this.getAttribute("bottom-offset") ?? 24);
  }
  saveComponentState() {
    return { state: this.state, sidebarCss: this.sidebar.style.cssText };
  }
  loadComponentState(data) {
    this.state = data.state;
    this.sidebar.style.cssText = data.sidebarCss;
  }
}
customElements.define("sticky-sidebar", StickySidebar);
const responseCache = /* @__PURE__ */ new Map();
class ProductRenderer {
  constructor(variantPicker) {
    this.variantPicker = variantPicker;
  }
  clearCache() {
    responseCache.clear();
  }
  buildUrl({ productUrl, variantId, sectionId = null, optionValueIds = null }) {
    const url = new URL(productUrl, window.location.origin);
    if (variantId) {
      url.searchParams.set("variant", variantId);
    } else {
      optionValueIds ?? (optionValueIds = this.variantPicker.getSelectedOptionValueIds());
      url.searchParams.set("option_values", optionValueIds.join(","));
    }
    if (sectionId) {
      url.searchParams.set("section_id", sectionId);
    }
    return url;
  }
  async fetchUrl(url) {
    if (!responseCache.has(url)) {
      responseCache.set(
        url,
        new Promise(
          (resolve) => fetch(url).then((resp) => resp.text().then(resolve))
        ).catch((e) => {
          console.error("Failed to fetch product", e);
          responseCache.delete(url);
          return false;
        })
      );
    }
    return responseCache.get(url);
  }
  async switchVariant(variantId) {
    const url = this.buildUrl({
      productUrl: this.variantPicker.productUrl,
      variantId,
      sectionId: this.variantPicker.dataset.section
    });
    const html = await this.fetchUrl(url.toString());
    const doc = this.variantPicker.quickAddModal ? prepareQuickAddContent(html) : new DOMParser().parseFromString(html, "text/html");
    this.updateDOM(doc);
    this.variantPicker.section.querySelectorAll("input[name=id]").forEach((el) => el.removeAttribute("disabled"));
    this.variantPicker.updateCurrentVariant();
    this.updateURL();
    this.preloadOptions();
  }
  async switchProduct(productUrl, variantId) {
    const url = this.buildUrl({ productUrl, variantId });
    const html = await this.fetchUrl(url.toString());
    if (this.variantPicker.quickAddModal) {
      const productInfo = prepareQuickAddContent(html).querySelector(".product-info");
      preserveFocus(
        () => this.variantPicker.quickAddModal.setProductInfo(productInfo)
      );
      return;
    }
    const doc = new DOMParser().parseFromString(html, "text/html");
    const mainContent = doc.querySelector("main");
    if (!mainContent) {
      return;
    }
    preserveFocus(() => {
      document.querySelector("main").innerHTML = mainContent.innerHTML;
    });
    window.history.replaceState({}, "", url);
  }
  updateDOM(newSection) {
    const curElements = this.variantPicker.section.querySelectorAll(
      "[data-variant-info]"
    );
    const newElements = newSection.querySelectorAll("[data-variant-info]");
    const newTemplateElements = newSection.querySelectorAll("template");
    const newElementsMap = /* @__PURE__ */ new Map();
    newElements.forEach((newEl) => {
      newElementsMap.set(newEl.dataset.variantInfo, newEl);
    });
    newTemplateElements.forEach((template) => {
      const templateElements = template.content.querySelectorAll(
        "[data-variant-info]"
      );
      templateElements.forEach((newEl) => {
        newElementsMap.set(newEl.dataset.variantInfo, newEl);
      });
    });
    preserveFocus(() => {
      curElements.forEach((curEl) => {
        const newEl = newElementsMap.get(curEl.dataset.variantInfo);
        if (newEl) {
          curEl.innerHTML = newEl.innerHTML;
          Array.from(curEl.attributes).forEach((attr) => {
            curEl.removeAttribute(attr.name);
          });
          Array.from(newEl.attributes).forEach((attr) => {
            curEl.setAttribute(attr.name, attr.value);
          });
        }
      });
    });
  }
  updateURL() {
    if (!this.variantPicker.currentVariant || this.variantPicker.dataset.updateUrl === "false" || !this.variantPicker.closest(".section-main-product")) {
      return;
    }
    window.history.replaceState(
      {},
      "",
      `${this.variantPicker.dataset.url}?variant=${this.variantPicker.currentVariant.id}`
    );
  }
  preloadOptions() {
    this.getOptionsToPreload().forEach((option) => {
      const url = this.buildUrl({
        ...option,
        productUrl: option.productUrl || this.variantPicker.productUrl,
        sectionId: option.productUrl ? null : this.variantPicker.dataset.section
      });
      this.fetchUrl(url.toString());
    });
  }
  getOptionsToPreload() {
    const variants = [];
    const currentOptionValueIds = this.variantPicker.getSelectedOptionValueIds();
    this.variantPicker.getProductOptions().forEach((optionValues, i) => {
      optionValues.forEach((value) => {
        if (value.id.toString() !== currentOptionValueIds[i]) {
          const newCombination = [...currentOptionValueIds];
          newCombination[i] = value.id.toString();
          variants.push({
            productUrl: value.productUrl ?? "",
            variantId: value.variantId ?? "",
            optionValueIds: newCombination
          });
        }
      });
    });
    return variants;
  }
}
class VariantPicker extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "currentVariant");
    this.productRenderer = new ProductRenderer(this);
    this.addEventListener("change", this.handleChange);
    whenInView(this, async () => {
      await windowLoaded();
      this.productRenderer.preloadOptions();
    });
  }
  get addButton() {
    return this.section.querySelector('[name="add"]');
  }
  get productForm() {
    var _a;
    return (_a = this.section) == null ? void 0 : _a.querySelector("product-form");
  }
  get productUrl() {
    return this.dataset.url;
  }
  connectedCallback() {
    this.quickAddModal = this.closest("#quick-add-modal");
    this.productInfoWrapper = this.closest(".product-info");
    this.section = this.closest(".shopify-section") ?? this.closest(".quick-add-modal");
  }
  disconnectedCallback() {
    if (Shopify == null ? void 0 : Shopify.designMode) {
      this.productRenderer.clearCache();
    }
  }
  async handleChange(e) {
    var _a;
    this.setLoading(true);
    this.productForm.setErrorMessage();
    try {
      if (e.target.dataset.productUrl) {
        this.productRenderer.switchProduct(
          e.target.dataset.productUrl,
          e.target.dataset.variantId
        );
      } else {
        await this.productRenderer.switchVariant(e.target.dataset.variantId);
        this.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: { variant: this.currentVariant },
            bubbles: true
          })
        );
      }
    } catch (err) {
      console.error("Error updating product section", err);
      (_a = this.addButton) == null ? void 0 : _a.removeAttribute("disabled");
    } finally {
      this.setLoading(false);
    }
  }
  updateCurrentVariant() {
    const variantJson = this.section.querySelector("[data-variant-info=json]");
    if (variantJson) {
      this.currentVariant = JSON.parse(variantJson.textContent);
    } else {
      this.currentVariant = null;
    }
  }
  setLoading(loading) {
    var _a;
    if (loading) {
      this.classList.add("disabled");
      (_a = this.addButton) == null ? void 0 : _a.setAttribute("disabled", "");
    } else {
      this.classList.remove("disabled");
    }
  }
  getProductOptions() {
    const optionGroups = this.querySelectorAll("[data-option-group]");
    const productOptions = [];
    optionGroups.forEach((group) => {
      const groupOptions = [];
      const elements = Array.from(
        group.querySelectorAll("[data-option-value-id]")
      );
      uniqBy(elements, (el) => el.dataset.optionValueId).forEach((el) => {
        groupOptions.push({
          id: el.dataset.optionValueId,
          variantId: el.dataset.variantId,
          productUrl: el.dataset.productUrl,
          selected: el.dataset.optionValueId === this.getOptionGroupSelected(group).dataset.optionValueId
        });
      });
      productOptions.push(groupOptions);
    });
    return productOptions;
  }
  /** The input that contains the selected value */
  getOptionGroupSelected(el) {
    if (el.tagName === "FIELDSET") {
      return el.querySelector("input:checked");
    } else {
      return el.querySelector("input");
    }
  }
  getSelectedOptionValueIds() {
    return this.getProductOptions().map(
      (group) => {
        var _a;
        return (_a = group.find((option) => option.selected)) == null ? void 0 : _a.id;
      }
    );
  }
}
customElements.define("variant-picker", VariantPicker);
class VariantRadios extends VariantPicker {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
  getOptionGroups() {
    return this.querySelectorAll("fieldset");
  }
  getOptionGroupValue(el) {
    return Array.from(el.querySelectorAll("input")).find((radio) => radio.checked).value;
  }
  getOptionGroupElements(el) {
    return el.querySelectorAll("input");
  }
  getOptionGroupElementValue(el) {
    return el.value;
  }
}
customElements.define("variant-radios", VariantRadios);
class VideoPlayer extends HTMLElement {
  get host() {
    return this.getAttribute("host");
  }
  get videoId() {
    return this.getAttribute("video-id");
  }
  get controls() {
    if (this.background)
      return false;
    return this.getAttribute("controls") !== null;
  }
  get muted() {
    if (this.background)
      return true;
    return this.getAttribute("muted") !== null;
  }
  get loop() {
    if (this.background)
      return true;
    return this.getAttribute("loop") !== null;
  }
  get background() {
    return this.getAttribute("background") !== null;
  }
  get autopause() {
    return this.getAttribute("autopause") !== "false";
  }
  get autoplay() {
    return this.getAttribute("autoplay") !== "false";
  }
  connectedCallback() {
    this.poster = this.querySelector("[data-poster]");
    if (!this.host || this.host === "native") {
      this.controller = new NativeVideoPlayerController(this);
    } else if (this.host === "youtube") {
      this.controller = new YoutubeVideoPlayerController(this);
    } else if (this.host === "vimeo") {
      this.controller = new VimeoVideoPlayerController(this);
    }
    if (this.poster) {
      this.poster.addEventListener("click", this.onPosterClick.bind(this));
    } else if (this.autoplay) {
      this.createInitObserver();
    }
    if (this.autopause) {
      this.createAutoPauseObserver();
    }
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.observer) == null ? void 0 : _a.disconnect();
    (_b = this.autoPauseObserver) == null ? void 0 : _b.disconnect();
  }
  createInitObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.controller.createPlayer();
          this.observer.disconnect();
        }
      },
      { rootMargin: "50% 0px 50% 0px", threshold: 0 }
    );
    this.observer.observe(this);
  }
  createAutoPauseObserver() {
    this.autoPauseObserver = new IntersectionObserver(
      (entries) => {
        if (!this.controller.init)
          return;
        if (entries[0].isIntersecting && this.background) {
          this.controller.play();
        } else if (!entries[0].isIntersecting) {
          this.controller.pause();
        }
      },
      { threshold: 0 }
    );
    this.autoPauseObserver.observe(this);
  }
  async onPosterClick() {
    await this.play();
  }
  hidePoster() {
    if (this.poster) {
      this.poster.style.display = "none";
    }
  }
  async play() {
    if (this.controller.init) {
      this.controller.play();
    } else {
      this.classList.add("video-player--loading");
      await this.controller.createPlayer();
      this.hidePoster();
      this.classList.remove("video-player--loading");
    }
  }
  async pause() {
    await this.controller.pause();
  }
}
class VideoPlayerController {
  constructor(player) {
    this.player = player;
    this.init = false;
  }
  createPlayer() {
  }
  play() {
  }
  pause() {
  }
}
class YoutubeVideoPlayerController extends VideoPlayerController {
  async loadAPI() {
    var _a;
    if (!((_a = window.YT) == null ? void 0 : _a.Player)) {
      const el = document.createElement("script");
      el.src = "//www.youtube.com/iframe_api";
      document.head.appendChild(el);
      await new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = () => resolve();
      });
    }
  }
  async createPlayer() {
    this.init = true;
    await this.loadAPI();
    const wrapper = document.createElement("div");
    wrapper.style.display = "none";
    if (this.player.background) {
      Object.assign(wrapper.style, {
        pointerEvents: "none",
        userSelect: "none",
        // Hack to hide the title bar
        width: "300%",
        height: "calc(100% + 2px)",
        marginTop: "-1px",
        marginLeft: "-100%"
      });
    }
    this.player.appendChild(wrapper);
    await new Promise((resolve) => {
      this.playerInstance = new window.YT.Player(wrapper, {
        width: "100%",
        height: "100%",
        videoId: this.player.videoId,
        playerVars: {
          playlist: this.player.videoId,
          controls: this.player.controls ? 1 : 0,
          autoplay: true,
          mute: this.player.muted ? 1 : 0,
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          loop: this.player.loop ? 1 : 0,
          showinfo: 0
        },
        events: {
          onReady: resolve
        }
      });
    });
    this.playerInstance.getIframe().style.display = null;
  }
  play() {
    var _a;
    (_a = this.playerInstance) == null ? void 0 : _a.playVideo();
  }
  pause() {
    var _a;
    (_a = this.playerInstance) == null ? void 0 : _a.pauseVideo();
  }
}
class VimeoVideoPlayerController extends VideoPlayerController {
  async loadAPI() {
    var _a;
    if (!((_a = window.Vimeo) == null ? void 0 : _a.Player)) {
      const el = document.createElement("script");
      el.src = "//player.vimeo.com/api/player.js";
      document.head.appendChild(el);
      await new Promise((resolve) => {
        el.onload = () => resolve();
      });
    }
  }
  async createPlayer() {
    this.init = true;
    await this.loadAPI();
    const wrapper = document.createElement("div");
    Object.assign(wrapper.style, {
      display: "none",
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    });
    this.player.appendChild(wrapper);
    this.playerInstance = new window.Vimeo.Player(wrapper, {
      id: this.player.videoId,
      width: 640,
      height: 360,
      controls: this.player.controls,
      autopause: false,
      autoplay: true,
      muted: this.player.muted,
      playsinline: true,
      loop: this.player.loop,
      background: this.player.background
    });
    await this.playerInstance.ready();
    const iframe = wrapper.querySelector("iframe");
    if (iframe) {
      Object.assign(iframe.style, { width: "100%", height: "100%" });
    }
    wrapper.style.display = null;
  }
  async play() {
    var _a;
    await ((_a = this.playerInstance) == null ? void 0 : _a.play());
  }
  async pause() {
    var _a;
    await ((_a = this.playerInstance) == null ? void 0 : _a.pause());
  }
}
class NativeVideoPlayerController extends VideoPlayerController {
  createPlayer() {
    this.init = true;
    const template = this.player.querySelector("template");
    if (template) {
      const node = document.importNode(template.content, true).firstElementChild;
      this.video = node.tagName === "VIDEO" ? node : node.querySelector("video");
      this.video.autoplay = true;
      this.video.playsinline = true;
      this.video.controls = this.player.controls;
      this.video.muted = this.player.muted;
      this.video.loop = this.player.loop;
      if (this.player.background) {
        Object.assign(this.video.style, {
          pointerEvents: "none",
          userSelect: "none"
        });
      }
      this.player.appendChild(node);
    }
  }
  async play() {
    var _a;
    await ((_a = this.video) == null ? void 0 : _a.play());
  }
  async pause() {
    var _a;
    await ((_a = this.video) == null ? void 0 : _a.pause());
  }
}
customElements.define("video-player", VideoPlayer);
function clearPreventTransition() {
  document.querySelectorAll(".prevent-transition-on-load").forEach((el) => el.classList.remove("prevent-transition-on-load"));
}
document.addEventListener("DOMContentLoaded", () => {
  setScrollbarWidth();
  setupFormButtonLoading();
  clearPreventTransition();
});
window.addEventListener("pageshow", () => {
  document.querySelectorAll("button[data-loading]").forEach((el) => {
    setButtonLoading(el, false);
  });
});
window.addEventListener("resize", debounce(setScrollbarWidth, 100));
window.pauseAllMedia = pauseAllMedia;
if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:unload", () => {
    window.activeModals = [];
    window.activeDropdowns = [];
    window.activeMegaMenuHorizontal = null;
    unlockScroll();
    clearPreventTransition();
  });
}
document.body.addEventListener("click", function(e) {
  var _a;
  const link = e.target.closest("a:not([data-smooth-scroll-ignore])");
  if (link && ((_a = link.getAttribute("href")) == null ? void 0 : _a.startsWith("#")) && link.getAttribute("href").length > 1) {
    e.preventDefault();
    const el = document.querySelector(link.getAttribute("href"));
    if (el) {
      const targetTopPosition = el.getBoundingClientRect().top;
      const offset2 = window.innerHeight * 0.25;
      const scrollPosition = window.scrollY + targetTopPosition - offset2;
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth"
      });
    }
    if (el.getAttribute("tabindex") !== null || ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(el.tagName)) {
      el.focus();
    }
  }
});
